import type { Dict } from "../types";

export const zhCN: Dict = {
  "chat.amrCard.switchTitle": "模型调用失败，当前任务已暂停",
  "chat.amrCard.switchBody":
    "可切换到 Crie3 Cloud 官方模型服务，无需配置 API Key。完成登录、授权和充值后，将自动重试当前任务。",
  "chat.amrCard.chipOfficial": "官方托管",
  "chat.amrCard.chipNoKey": "无需 API Key",
  "chat.amrCard.chipAutoRetry": "授权后自动重试",
  "chat.amrCard.switchCta": "切换到 Crie3 Cloud 并重试",
  "chat.amrError.authMessage":
    "Crie3 Cloud 账号尚未授权。完成授权后将自动重试当前任务。",
  "chat.amrError.balanceMessage":
    "Crie3 Cloud 账户余额不足。充值后可继续运行当前任务。",
  "chat.amrError.authorizeCta": "授权并重试",
  "chat.amrError.rechargeCta": "为 Crie3 Cloud 充值",
  "chat.amrBalanceGate.title": "升级套餐，继续创作",
  "chat.amrBalanceGate.message": "余额不足（当前 {balance}），升级套餐或充值后，任务马上就能开始。",
  "chat.amrBalanceGate.benefitsTitle": "Crie3 Cloud 为你提供",
  "chat.amrBalanceGate.benefit1": "无需 API Key，海量模型任选",
  "chat.amrBalanceGate.benefit2": "自带 SOTA Design Agent，零配置",
  "chat.amrBalanceGate.benefit3": "官方服务，稳定有保障",
  "chat.amrBalanceGate.benefit4": "持续升级：一键部署、多模态、团队版等",
  "chat.amrBalanceGate.laterCta": "暂不需要",
  "chat.amrBalanceGate.plansCta": "升级套餐",
  "chat.amrBalanceGate.signedOutTitle": "登录 Crie3 Cloud，开始创作",
  "chat.amrBalanceGate.signedOutMessage": "当前使用的是 Crie3 Cloud 智能体，登录后这个任务马上就能开始。",
  "chat.amrBalanceGate.signInCta": "立即登录",
  "chat.amrBalanceGate.watchingWallet": "充值到账后将自动继续。",
  "chat.amrLowBalance.title": "余额不多了",
  "chat.amrLowBalance.message": "余额仅剩 {balance}，可能不够完成这个任务，建议先充值或升级套餐。",
  "chat.amrLowBalance.rechargeCta": "去充值",
  "chat.amrLowBalance.proceedCta": "仍要发起任务",
  "chat.amrLowBalance.dontRemind": "不再提示",
  "chat.amrArtifactUpgrade.title": "用更强模型继续完善作品",
  "chat.amrArtifactUpgrade.message": "解锁高阶模型、更多任务并发和更高每月积分。",
  "chat.amrArtifactUpgrade.benefit1": "更多高阶模型，如 Fable 5、GPT-5.6",
  "chat.amrArtifactUpgrade.benefit2": "任务并发最高提升 10 倍",
  "chat.amrArtifactUpgrade.benefit3": "月度积分最高提升 300 倍",
  "chat.amrArtifactUpgrade.benefit4": "高峰期优先排队，生成更快",
  "chat.amrArtifactUpgrade.promoBanner": "订阅套餐限时低至 3.3 折",
  "chat.amrArtifactUpgrade.countdownLabel": "优惠倒计时",
  "chat.amrArtifactUpgrade.plansCta": "立即升级套餐，低至 3.3 折",
  "chat.amrArtifactUpgrade.homePlansCta": "3.3 折升级",
  "chat.amrArtifactUpgrade.laterCta": "继续使用 Free 并发送",
  "chat.amrArtifactUpgrade.homeTitle": "作品已生成，让下一次创作更进一步",
  "chat.amrArtifactUpgrade.homeMessage": "升级即可解锁高阶模型、更多并发和更高每月积分。",
  "chat.amrArtifactUpgrade.homeArtifactCta": "查看作品",
  "chat.antigravityError.launchTerminalCta": "在终端中登录",
  "chat.antigravityError.launchSwitchModelCta": "在终端中切换模型",
  "chat.connectionDropped":
    "与模型服务的连接在响应完成前中断了——通常是网络或代理不稳定。请重试。",
  "chat.runError.title.authRequired": "需要授权",
  "chat.runError.title.balance": "余额不足",
  "chat.runError.title.connectionDropped": "连接中断",
  "chat.runError.title.signInRequired": "需要登录",
  "chat.runError.title.rateLimited": "已达用量上限",
  "chat.runError.title.generic": "任务执行失败",
  "chat.runError.signInMessage.amr":
    "Crie3 Cloud 智能体尚未登录，前往登录即可正常使用",
  "chat.runError.signInMessage.other":
    "{agent}尚未登录，请本地检查登录状态。推荐使用 Crie3 Cloud 智能体，更稳定划算",
  "chat.runError.agentFallback": "智能体",
  "chat.runError.sourceLabel": "报错源码",
  "chat.runError.sourceExpandAria": "展开报错源码",
  "chat.runError.sourceCollapseAria": "收起报错源码",
  "chat.runError.title.cliMissing": "智能体未安装",
  "chat.runError.title.promptTooLarge": "内容过长",
  "chat.runError.title.modelUnavailable": "模型不可用",
  "chat.runError.title.upstreamUnavailable": "服务暂时不可用",
  "chat.runError.title.toolLoop": "操作陷入循环",
  "chat.runError.title.outputInvalid": "输出异常",
  "chat.runError.title.runtimeConfig": "配置错误",
  "chat.runError.cliMissingMessage": "未检测到 {agent} 的命令行工具。请先安装并确保它在 PATH 中，然后重试。",
  "chat.runError.promptTooLargeMessage": "本轮输入超出了模型的上下文上限。请缩短提示词、减少附件，或新建对话后重试。",
  "chat.runError.modelUnavailableMessage": "所选模型不可用或不存在。请在设置中切换到其他可用模型后重试。",
  "chat.runError.rateLimitedMessage": "已触发模型服务的用量限制。请稍后重试，或切换到其他模型/服务。",
  "chat.runError.upstreamUnavailableMessage": "模型服务暂时不可用，通常是上游波动或网络/代理问题。请稍后重试。",
  "chat.runError.toolLoopMessage": "{agent} 在重复执行同一操作但没有进展，已自动停止。请检查目标文件或命令后重试。",
  "chat.runError.outputInvalidMessage": "模型输出了异常内容，本轮已被中断。通常重试即可恢复。",
  "chat.runError.runtimeConfigMessage": "所选智能体的运行时配置有误，无法启动本轮任务。请更新到最新版本或联系支持。",
  "chat.runError.title.quotaExhausted": "额度已用尽",
  "chat.runError.title.timedOut": "运行超时",
  "chat.runError.title.emptyOutput": "没有任何输出",
  "chat.hostedAgentName": "Crie3 智能体",
  "chat.plain.warningTruncated": "出于安全考虑，这次回答被中断了。请再说一次，最好写得更具体一些。",
  "chat.plain.warningRepeatedStopped": "同一个步骤连续失败了好几次，所以工作停了下来。可以再说一次，或者换个说法描述。",
  "chat.plain.warningRepeatedStuck": "同一个步骤一直在失败，可能会拖住后面的工作。",
  "chat.runError.hostedGenericMessage": "这次任务没有完成。稍后再试一次；如果还是这样，请联系我们。",
  "chat.plain.details": "查看技术细节",
  "chat.plain.detailsHide": "隐藏技术细节",
  "chat.brandAudit.needsFixes": "需要调整（{count}）",
  "chat.brandAudit.syncFailed": "现在无法更新品牌：{error}",
  "chat.brandAudit.checkFailed": "现在无法检查品牌。",
  "chat.brandEnrichmentStartFailed": "现在无法开始优化。请稍后再试。",
  "chat.designNoResult": "Crie3 finished without producing the piece. Try asking again — if it keeps happening, describe what you asked for and we will look into it.",
  "chat.designDeliveryFailed": "The piece was created, but Crie3 could not save it to the project. Try again.",
  "chat.runError.title.sessionExpired": "会话已过期",
  "chat.runError.title.gitBashMissing": "缺少 Git Bash",
  "chat.runError.quotaExhaustedMessage": "所用模型服务的额度或账单上限已用尽，重试也无法恢复。请前往对应服务充值，或切换到其他模型/服务。",
  "chat.runError.workspaceCreditsMessage": "工作区额度已用尽。请充值（或联系工作区管理员补充），或切换到其他模型/服务。",
  "chat.runError.timedOutMessage": "本次运行耗时过长已被中断。请重试，或缩小任务范围后再试。",
  "chat.runError.inactivityTimeoutMessage": "智能体长时间没有新输出，已按超时中断。通常重试即可继续。",
  "chat.runError.emptyOutputMessage": "智能体本次结束时没有产生任何输出。这通常是暂时的，重试即可再次运行。",
  "chat.runError.sessionExpiredMessage": "要恢复的会话已过期，已为你重置。重试即可开始一次全新运行。",
  "chat.runError.gitBashMissingMessage": "在 Windows 上运行该智能体需要 Git Bash，但未找到。请安装 Git for Windows 后重试。",
  "common.cancel": "取消",
  "chat.selectFromLibrary": "从资源库导入",
  "chat.importFigma": "从 Figma 导入",
  "chat.plus.group.files": "文件",
  "chat.plus.group.code": "代码",
  "chat.plus.group.designs": "设计",
  "chat.plus.group.other": "其他",
  "chat.plus.attachFiles": "附加文件",
  "chat.plus.referenceProject": "引用其它项目",
  "chat.plus.linkLocalCode": "关联本地代码",
  "chat.plus.uploadFig": "上传 .fig 文件",
  "chat.plus.learnHow": "查看方法",
  "chat.plus.designSystem": "设计系统",
  "chat.plus.skills": "技能",
  "chat.plus.noSkills": "暂无可用技能",
  "chat.plus.connectors": "连接器",
  "chat.plus.plugins": "插件",
  "chat.plus.mcp": "MCP",
  "chat.referenceProject.title": "引用其它项目",
  "chat.referenceProject.search": "搜索项目…",
  "chat.referenceProject.empty": "没有匹配“{query}”的项目",
  "chat.referenceProject.emptyAll": "暂无其它项目",
  "chat.referenceProject.loadFailed": "无法加载项目。请确认 daemon 正在运行后重试。",
  "chat.referenceProject.confirm": "引用项目",
  "chat.contextPrompt.referenceProject":
    "请把 Crie3 项目“{name}”作为参考上下文。它的本地路径是：{path}。在设计或修改前，如有帮助请先搜索并读取这个目录。",
  "chat.contextPrompt.localCode":
    "请把本地代码目录“{name}”作为代码参考。它的绝对路径是：{path}。如有帮助请先读取相关文件，并与现有实现保持一致。",
  "chat.figmaHelp.title": "如何下载 .fig 文件",
  "chat.figmaHelp.intro": "从 Figma 网页版或桌面版：",
  "chat.figmaHelp.step1": "打开 Figma 文件。",
  "chat.figmaHelp.step2": "进入 File → Save local copy...（网页版在主菜单 → File）。",
  "chat.figmaHelp.step3": "Figma 会下载一个 .fig 文件，把它拖入输入框或上传。",
  "chat.figmaHelp.note": ".fig 文件会在本机解析，不会上传到 Figma。",
  "designFiles.library.label": "从资源库导入",
  "designFiles.library.title": "从资源库导入",
  "libraryPicker.title": "从资源库导入",
  "libraryPicker.searchPlaceholder": "搜索资源库…",
  "libraryPicker.empty": "资源库暂无内容",
  "libraryPicker.allKinds": "全部",
  "libraryPicker.add": "导入",
  "libraryPicker.loading": "加载中…",
  "common.save": "保存",
  "common.close": "关闭",
  "common.clear": "清除",
  "common.delete": "删除",
  "common.rename": "重命名",
  "common.edit": "编辑",
  "common.preview": "预览",
  "common.share": "分享",
  "common.search": "搜索",
  "common.searchEllipsis": "搜索…",
  "common.loading": "加载中…",
  "common.all": "全部",
  "common.none": "无",
  "common.default": "默认",
  "common.installed": "已安装",
  "common.notInstalled": "未安装",
  "common.active": "使用中",
  "common.disabled": "已关闭",
  "common.enabled": "已开启",
  "common.selected": "已选",
  "common.create": "创建",
  "common.openPreview": "打开预览",
  "common.exitFullscreen": "退出全屏",
  "common.fullscreen": "全屏",
  "common.openInNewTab": "在新标签页中打开",
  "common.exportPdf": "导出为 PDF",
  "common.exportZip": "下载为 .zip",
  "common.exportHtml": "导出为独立 HTML",
  "common.exportImage": "导出为图片",
  "common.exportImageFailed": "无法生成图片，请重试。",
  "common.justNow": "刚刚",
  "common.minutesAgo": "{n} 分钟前",
  "common.hoursAgo": "{n} 小时前",
  "common.daysAgo": "{n} 天前",
  "common.weeksAgo": "{n} 周前",
  "common.now": "刚刚",
  "common.minutesShort": "{n}分",
  "common.hoursShort": "{n}时",
  "common.daysShort": "{n}天",
  "common.untitled": "未命名",
  "plugins.availableDetails.provenance": "来源",
  "plugins.availableDetails.provenanceLine":
    "来自 {source} · {trust} · {resolved}",
  "plugins.availableDetails.provenanceLineWithIntegrity":
    "来自 {source} · {trust} · {resolved} · {integrity}",
  "plugins.availableDetails.install": "安装",
  "plugins.availableDetails.version": "版本",
  "plugins.availableDetails.pluginVersion": "插件版本",
  "plugins.availableDetails.copyInstallCommand": "复制安装命令",
  "plugins.availableDetails.copied": "已复制",
  "plugins.availableDetails.deprecatedPrefix": "已弃用：{message}",
  "plugins.availableDetails.deprecatedFallback": "此版本已标记为弃用。",
  "plugins.availableDetails.yanked": "已撤回。",
  "plugins.availableDetails.yankedWithReason": "已撤回：{reason}",
  "plugins.availableDetails.versionDeprecatedSuffix": "（已弃用）",
  "plugins.availableDetails.versionYankedSuffix": "（已撤回）",
  "plugins.availableDetails.ref": "引用",
  "plugins.availableDetails.integrity": "Integrity",
  "plugins.availableDetails.permissions": "权限",
  "plugins.availableDetails.capabilitySummary": "能力摘要",
  "plugins.actions.copyInstallCommand": "复制安装命令",
  "plugins.actions.copyPluginId": "复制插件 ID",
  "plugins.actions.openSourceGithub": "在 GitHub 打开源码",
  "plugins.actions.openSource": "打开源码",
  "plugins.actions.openHomepage": "打开项目主页",
  "plugins.actions.openMarketplace": "在插件市场打开",
  "app.brand": "Crie3",
  "app.brandPill": "研究预览版",
  "app.brandSubtitle": "由 Nexu Labs 出品",
  "app.welcomeLoading": "正在加载工作区…",
  "settings.welcomeKicker": "",
  "settings.welcomeTitle": "欢迎使用 Crie3",
  "settings.welcomeSubtitle": "",
  "settings.onboardingCreateTitle": "从一句需求开始",
  "settings.onboardingCreateBody":
    "描述你想做的网站、应用、Deck、图片或视频，Crie3 会创建项目，并保留可继续编辑的产物。",
  "settings.onboardingMemoryTitle": "保存工作上下文",
  "settings.onboardingMemoryBody":
    "把偏好、项目事实和长期规则写入 Memory，后续对话会自动带上正确背景。",
  "settings.onboardingMemoryCalloutTitle": "已保存到你的记忆",
  "settings.onboardingMemoryCalloutBody":
    "这些回答会构成你的记忆画像。Crie3 会在每个任务中复用它，并在你工作时持续学习。",
  "settings.onboardingMemoryBenefitIntent": "从一句简短需求就能理解你的意图",
  "settings.onboardingMemoryBenefitFewerQuestions": "跳过重复的设置提问",
  "settings.onboardingMemoryBenefitPersonalized":
    "按你的角色、受众和品味定制产出",
  "settings.onboardingSystemsTitle": "接入你的设计系统",
  "settings.onboardingSystemsBody":
    "选择或创建品牌系统，让生成结果跟随真实的颜色、字体和产品语言。",
  "settings.onboardingExecutionTitle": "选择生成方式",
  "settings.onboardingExecutionBody":
    "官方 CLI，一键配置、开箱即用。一个 Key 自由选择海量模型，价格更优惠。",
  "settings.onboardingAmrCloudBenefitOfficial": "官方推荐",
  "settings.onboardingAmrCloudBenefitReady": "免部署即用",
  "settings.onboardingAmrCloudBenefitModels": "支持 Claude Opus 4.8",
  "settings.onboardingAmrCloudBenefitPricing": "SOTA Harness",
  "settings.onboardingAmrCloudUpcomingLabel": "即将支持",
  "settings.onboardingAmrCloudUpcomingImageVideo": "生图/视频",
  "settings.onboardingAmrCloudUpcomingSkills": "海量 Skills",
  "settings.onboardingAmrCloudUpcomingRouting": "智能路由",
  "settings.onboardingAmrModelSourceLabel": "Crie3 Cloud",
  "settings.onboardingAmrCloudAuthorizeAction": "授权 Crie3 Cloud",
  "settings.onboardingAmrCloudAuthorizedAction": "已授权",
  "settings.onboardingStepConnect": "连接",
  "settings.onboardingStepDesignSystem": "构建设计系统",
  "settings.onboardingStepProfile": "了解你",
  "settings.onboardingStepNewsletter": "获取最新动态",
  "settings.onboardingNewsletterTitle": "获取最新动态",
  "settings.onboardingNewsletterBody":
    "留下邮箱，接收产品更新、新模板、设计系统资源和社区活动。",
  "settings.onboardingConnectTitle": "选择运行方式",
  "settings.onboardingConnectBody": "",
  "settings.onboardingCloudTitle": "登录 Crie3",
  "settings.onboardingCloudBody":
    "登录后可直接用云端 AI 开始设计，无需任何复杂配置。",
  "settings.onboardingCloudSignIn": "登录 Crie3 云端",
  "settings.onboardingCloudContinue": "继续（已登录）",
  "settings.onboardingCloudAlternative": "使用本地 CLI 或自己的 API Key",
  "settings.onboardingCloudRights": "保留所有权利。",
  "settings.onboardingCloudOr": "或",
  "settings.onboardingGateTooltipNoRuntime":
    "后续流程由 AI 运行，请先选择一种运行方式。",
  "settings.onboardingGateTooltipAmr":
    "后续流程由 AI 运行，请先登录 Crie3 Cloud。",
  "settings.onboardingGateTooltipLocal":
    "后续流程由 AI 运行，请先选择一个可用的本地 CLI。",
  "settings.onboardingGateTooltipByok":
    "后续流程由 AI 运行，请先填写并测试通过你的模型 Key。",
  "settings.onboardingRecommended": "推荐",
  "settings.onboardingAmrCloudOfficialBadge": "官方",
  "settings.onboardingLocalTitle": "本地 Coding Agent",
  "settings.onboardingLocalBody":
    "使用已安装的 CLI，如 Claude Code、Codex、Cursor、Gemini 或 OpenCode。",
  "settings.onboardingLocalAction": "打开 CLI 设置",
  "settings.onboardingCliScanHint": "通常 5 到 10 秒内完成扫描。",
  "settings.onboardingByokTitle": "自己的模型 Key",
  "settings.onboardingByokBody": "使用你自己的模型服务凭证。",
  "settings.onboardingByokAction": "打开 BYOK 设置",
  "settings.onboardingDesignTitle": "设计系统",
  "settings.onboardingDesignBody": "生成一次，后续复用。",
  "settings.onboardingDesignIntroGenerateTitle": "用已有内容生成",
  "settings.onboardingDesignIntroGenerateBody":
    "从 GitHub、本地代码仓库、Figma 文件，或现成图片等内容资产中上传你的设计系统。",
  "settings.onboardingDesignIntroReuseTitle": "后续产物直接复用",
  "settings.onboardingDesignIntroReuseBody":
    "后续生成原型、Slide 和其他内容时，都可以参考现有的字体、间距、Logo 样式、色调等。",
  "settings.onboardingDesignIntroSkipTitle": "也可以先跳过",
  "settings.onboardingDesignIntroSkipBody":
    "现在不想生成也没关系，可以直接进入产品。",
  "settings.onboardingGithubTitle": "从 GitHub 导入",
  "settings.onboardingGithubBody": "使用前端仓库。",
  "settings.onboardingUploadTitle": "上传本地文件",
  "settings.onboardingUploadBody": "添加项目文件、截图、CSS、文档或素材。",
  "settings.onboardingPromptTitle": "用一句话生成",
  "settings.onboardingPromptBody": "描述产品或品牌。",
  "settings.onboardingProfileTitle": "关于你",
  "settings.onboardingProfileBody": "可选信息，用于优化默认配置。",
  "settings.onboardingRoleLabel": "你的身份",
  "settings.onboardingOrgSizeLabel": "组织规模",
  "settings.onboardingWorshipTeamLabel": "How big is the worship team?",
  "settings.onboardingWorshipSolo": "Just me",
  "settings.onboardingWorshipSmall": "Up to 5 people",
  "settings.onboardingWorshipMedium": "6 to 15 people",
  "settings.onboardingWorshipLarge": "More than 15, on rotation",
  "settings.onboardingMediaTeamLabel": "Who handles the media work?",
  "settings.onboardingMediaSolo": "Just me",
  "settings.onboardingMediaPair": "2 or 3 volunteers",
  "settings.onboardingMediaTeam": "A team of 4 to 10",
  "settings.onboardingMediaDept": "A full communications department",
  "settings.onboardingAgencyClientsLabel": "How many churches or ministries do you serve?",
  "settings.onboardingAgencyFew": "1 to 3",
  "settings.onboardingAgencySome": "4 to 10",
  "settings.onboardingAgencyMany": "11 to 25",
  "settings.onboardingAgencyLots": "More than 25",
  "settings.onboardingUseCaseLabel": "使用场景",
  "settings.onboardingSourceLabel": "从哪里听说的",
  "settings.onboardingSourceX": "🐦 X / Twitter",
  "settings.onboardingSourceGithub": "🐙 GitHub",
  "settings.onboardingSourceYoutube": "▶️ YouTube",
  "settings.onboardingSourceTiktok": "🎵 TikTok",
  "settings.onboardingSourceReddit": "👽 Reddit",
  "settings.onboardingSourceLinkedin": "💼 LinkedIn",
  "settings.onboardingSourceMetaSocial": "📸 Instagram / Threads / Facebook",
  "settings.onboardingSourceSearch": "🔍 搜索（Google / Bing）",
  "settings.onboardingSourceAiTool": "🤖 AI 工具（ChatGPT / Perplexity）",
  "settings.onboardingSourceFriend": "👥 朋友或同事",
  "settings.onboardingSourceCommunity": "💬 Discord / 社区",
  "settings.onboardingSourceEmail": "✉️ 邮件 / 邮件订阅",
  "settings.onboardingSourceBlog": "📝 博客 / 文章",
  "settings.onboardingSourceOther": "✨ 其他",
  "settings.onboardingSourceOtherPlaceholder": "告诉我们具体在哪（选填）",
  "settings.onboardingSelectPlaceholder": "请选择",
  "settings.onboardingSelectMultiplePlaceholder": "可选择多个",
  "settings.onboardingOrgSolo": "个人使用（1 人）",
  "settings.onboardingOrgTeam": "小团队（2-10 人）",
  "settings.onboardingOrgStartup": "初创 / 中小企业（11-50 人）",
  "settings.onboardingOrgGrowth": "成长期公司（51-200 人）",
  "settings.onboardingOrgMidMarket": "中大型公司（201-1000 人）",
  "settings.onboardingOrgEnterprise": "大型企业（1000+ 人）",
  "settings.onboardingRolePm": "📋 产品经理",
  "settings.onboardingRoleDesigner": "🎨 设计师",
  "settings.onboardingRoleEngineer": "💻 研发",
  "settings.onboardingRoleMarketing": "📣 营销",
  "settings.onboardingRoleAgency": "📣 营销代理商",
  "settings.onboardingRoleGrowth": "📈 增长",
  "settings.onboardingRoleOps": "⚙️ 运营",
  "settings.onboardingRoleFounder": "🚀 创始人 / 管理者",
  "settings.onboardingRoleStudent": "🎓 学生 / 教育者",
  "settings.onboardingRoleOther": "✨ 其他",
  "settings.onboardingUseProduct": "🎨 产品设计",
  "settings.onboardingUseDesignSystem": "🧩 设计系统",
  "settings.onboardingUsePrototype": "📱 原型 / 应用界面",
  "settings.onboardingUseLanding": "🌐 落地页",
  "settings.onboardingUseAds": "📣 广告 / 社媒内容",
  "settings.onboardingUseDashboard": "📊 仪表盘 / 内部工具",
  "settings.onboardingUseDeck": "🖥️ 演示文稿 / 提案",
  "settings.onboardingUseMarketing": "📈 营销 / 增长",
  "settings.onboardingUseEngineering": "🤝 工程交付",
  "settings.onboardingUseAgency": "💼 代理商 / 客户项目",
  "settings.onboardingBack": "上一步",
  "settings.onboardingContinue": "继续",
  "settings.onboardingFinish": "完成",
  "settings.kicker": "设置",
  "settings.title": "执行模式",
  "settings.subtitle": "在本机 CLI 与 BYOK 之间选择。",
  "settings.modeAria": "执行模式",
  "settings.protocolAria": "API 协议",
  "settings.modeDaemon": "本机 CLI",
  "settings.modeDaemonHelp": "通过本机的代码代理 CLI 执行",
  "settings.modeDaemonOffline": "后台守护进程未运行",
  "settings.modeDaemonOfflineMeta": "守护进程未运行",
  "settings.modeDaemonInstalledMeta": "已安装 {count} 个",
  "settings.modeApi": "API 提供方",
  "settings.modeApiMeta": "BYOK",
  "settings.byokNoFileToolsNotice":
    "BYOK 无法读写或修改项目文件；需要改代码时请使用本机 CLI。",
  "settings.codeAgent": "代码代理",
  "settings.codeAgentHint": "选择用来运行提示词的 CLI。",
  "settings.rescan": "↻ 重新扫描",
  "settings.rescanTitle": "重新扫描 PATH",
  "settings.rescanRunning": "扫描中...",
  "settings.rescanSuccess": "扫描完成，{count} 个可用。",
  "settings.designSystemRenameFailed": "重命名失败，请检查后台守护进程后重试。",
  "settings.rescanFailed": "扫描失败，请检查后台守护进程后重试。",
  "settings.test": "测试",
  "settings.testTitle": "发送极小的测试提示词以验证连接",
  "settings.testRunning": "正在测试连接…",
  "settings.byokReadyToTest": "可测试连接",
  "settings.testCancel": "取消",
  "settings.testRetry": "重新测试",
  "settings.required": "必填",
  "settings.testMissingFields": "请填写 {fields} 后再测试连接。",
  "settings.testSuccessApi": "已连接。{ms} 毫秒响应 — '{sample}'",
  "settings.testSuccessCli": "{agentName} 在 {ms} 毫秒内响应 — '{sample}'",
  "settings.testAuthFailed": "鉴权失败，请检查 API 密钥。",
  "settings.testForbidden": "访问被拒绝。请检查账号、地区或组织。",
  "settings.testNotFoundModel": "未在此端点找到模型 '{model}'。",
  "settings.testInvalidModelId":
    "模型 ID '{model}' 格式无效。自定义 ID 必须以字母或数字开头，且不能包含空格。",
  "settings.testInvalidBaseUrl": "Base URL 无效或不可达。",
  "settings.testRateLimited": "提供商对测试进行了限流，配置看起来有效。",
  "settings.testUpstream": "提供商返回 {status}，请稍后再试。",
  "settings.testTimeout": "测试在 {ms} 毫秒后超时。",
  "settings.testAgentMissing": "{agentName} 未安装，或不在 PATH 中。",
  "settings.testAgentSpawn": "无法启动 {agentName}：{detail}。",
  "settings.testUnknown": "测试失败：{detail}",
  "settings.agentInstall.install": "安装",
  "settings.agentInstall.docs": "文档",
  "settings.agentInstall.pathHint":
    "如果你通过 npm 或 Homebrew 安装了 CLI，但仍显示为未安装，请确认该工具的 bin 目录已加入 Crie3 daemon 继承的 PATH（在 macOS 上，Terminal 与 GUI 应用的 PATH 可能不同）。请参阅 QUICKSTART.md（“Local agent CLI and PATH” 章节）。",
  "settings.agentInstall.stepOpenLinks":
    "在目标代理卡片上打开“安装”或“文档”链接。",
  "settings.agentInstall.stepAuth":
    "返回 Crie3 之前，请先在对应 CLI 中完成认证（登录或添加 API 凭据）。",
  "settings.agentInstall.stepRescan": "在此区域点击“重新扫描”。",
  "settings.agentInstall.stepSelect": "当代理显示为已安装后，选择该代理卡片。",
  "settings.noAgentsDetected":
    "尚未检测到任何代理。请安装 Claude Code、Codex、OpenCode、Cursor Agent、Qwen 或 GitHub Copilot CLI 中的一个，然后点击「重新扫描」。",
  "settings.agentInstalledGroup": "你的 CLI（{count}）",
  "settings.agentInstallGroup": "可安装（{count}）",
  "settings.agentAuthRequired": "需要认证",
  "settings.agentAuthUnknown": "认证状态未知",
  "settings.amrCloud": "Crie3 Cloud",
  "settings.amrAuthorize": "授权",
  "settings.amrBenefitOfficial": "官方推荐",
  "settings.amrBenefitLowerPrice": "免部署即用",
  "settings.amrBenefitManyModels": "多种模型",
  "settings.amrPromoBonus": "限时充值赠 100%",
  "settings.amrSignInToContinue": "授权后继续",
  "settings.amrSignIn": "登录",
  "settings.amrSignedIn": "已登录",
  "settings.amrWalletBalance": "钱包余额",
  "settings.amrWalletUnavailable": "余额暂不可用",
  "settings.amrWalletUpdatedAt": "更新于 {time}",
  "settings.amrWalletCached": "缓存",
  "settings.amrWalletRefresh": "刷新",
  "settings.amrWalletRefreshTitle": "刷新 Crie3 Cloud 钱包余额",
  "settings.amrNotSignedIn": "未授权",
  "settings.amrSigningIn": "登录中…",
  "settings.amrActivationHint": "没有弹出登录页?点击下方按钮重新拉起",
  "settings.amrActivationBrowserFailed":
    "没能自动打开浏览器,请打开下面的登录页继续。",
  "settings.amrActivationOpen": "打开登录页",
  "settings.amrCancelSignIn": "取消登录",
  "settings.amrAccountStatus": "Crie3 Cloud 账户状态",
  "settings.amrConsole": "Crie3 Cloud 管理",
  "settings.amrLoginErrorCompact": "Crie3 Cloud 登录失败。",
  "settings.advanced": "高级设置",
  "settings.amrLogin": "登录",
  "settings.amrLogout": "登出",
  "settings.amrLoggingIn": "登录中…",
  "settings.amrLoggingOut": "退出中…",
  "settings.amrLoggedInAs": "已登录 {email}",
  "settings.amrLoggedInWithPlan": "已登录 {email} · {plan}",
  "settings.amrLoggedInPill": "已登录",
  "settings.amrNotLoggedIn": "未授权",
  "settings.apiSection": "Anthropic API",
  "settings.quickFillProvider": "快速填充提供方",
  "settings.providerPreset": "网关预设",
  "settings.protocolGroupProtocols": "协议",
  "settings.protocolGroupGateways": "网关",
  "settings.customProvider": "自定义提供方",
  "settings.apiKey": "API Key",
  "settings.apiKeyGetLink": "获取 key ↗",
  "settings.showKey": "显示 Key",
  "settings.hideKey": "隐藏 Key",
  "settings.show": "显示",
  "settings.hide": "隐藏",
  "settings.model": "模型",
  "settings.sidebarExpand": "展开设置菜单",
  "settings.sidebarCollapse": "收起设置菜单",
  "settings.sectionsNavAria": "设置分区",
  "settings.apiKeyInvalid": "API key 无效。",
  "settings.apiKeyCleaned": "已移除 API key 中多余的空白字符。",
  "settings.modelsLoadedFromAccount": "✓ 已从你的账号加载 {count} 个模型。",
  "settings.modelsLoadedCount": "✓ 已加载 {count} 个模型。",
  "settings.modelSourceAccount": "来自你的账号",
  "settings.modelSourceSuggested": "建议",
  "modelCapability.standard": "Standard",
  "modelCapability.advanced": "Advanced",
  "modelCapability.bestQuality": "Best Quality",
  "modelCapability.standardDescription": "Solid quality for regular tasks.",
  "modelCapability.advancedDescription": "Stronger quality for more demanding tasks.",
  "modelCapability.bestQualityDescription": "Best output quality for the most demanding work.",
  "modelCost.upToHalf": "低成本",
  "modelCost.halfToOne": "中成本",
  "modelCost.oneToFour": "高成本",
  "modelCost.overFour": "最高成本",
  "settings.fetchModels": "拉取模型",
  "settings.fetchModelsTitle": "从当前提供方拉取可用模型",
  "settings.fetchModelsRunning": "正在拉取模型…",
  "settings.fetchModelsMissingFields": "请填写 {fields} 后再拉取模型。",
  "settings.fetchModelsInvalidBaseUrl": "请输入有效的 Base URL 后再拉取模型。",
  "settings.fetchModelsUnsupportedAzure":
    "Azure OpenAI 使用部署名称，此处不支持自动发现模型。",
  "settings.fetchModelsUnsupportedOllama":
    "Ollama Cloud 暂不支持自动发现模型，请选择或输入模型。",
  "settings.fetchModelsSuccess": "已拉取 {count} 个模型。",
  "settings.fetchModelsEmpty": "未返回可兼容的文本模型。",
  "settings.fetchModelsUnsupported": "此协议暂不支持自动发现模型。",
  "settings.fetchModelsFailed": "无法拉取模型：{detail}",
  "settings.suggestedModelsHint":
    "这些是此协议的建议模型。你的提供方可能支持不同的模型。",
  "settings.baseUrl": "Base URL",
  "settings.baseUrlInvalid": "使用公网 http:// 或 https:// URL。",
  "settings.baseUrlCustomize": "自定义",
  "settings.baseUrlDefaultHint": "默认接口地址，通常不需要修改。",
  "settings.azureBaseUrlPlaceholder": "粘贴 Azure endpoint URL",
  "settings.azureBaseUrlHint":
    "在 Azure portal → 你的 resource → Endpoint 中找到。",
  "settings.azureDeploymentModel": "部署名称",
  "settings.azureCustomDeploymentName": "自定义部署名称",
  "settings.azureDeploymentModelHint":
    "对于 Azure OpenAI，此字段会作为 /openai/deployments/<model> 中的部署名称使用。请填写你在 Azure 中创建的部署名称。",
  "settings.azureModelFetchHint":
    "填写 Azure resource 里的部署名称。Azure deployment 目前无法自动拉取。",
  "settings.apiVersion": "API 版本",
  "settings.byokImageModel": "图片生成模型",
  "settings.byokVideoModel": "视频生成模型",
  "settings.byokVideoI2vHint":
    "图生视频模型:需要参考图(不指定时自动使用项目中最新的图片)",
  "settings.byokSpeechModel": "语音生成模型",
  "settings.byokSpeechVoice": "音色",
  "settings.byokModelDefaultOption": "默认",
  "settings.maxTokens": "最大 tokens（可选）",
  "settings.maxTokensHint":
    "响应长度上限。每个 model 有调优过的默认值（在 placeholder 里显示），留空即使用，输入数字则覆盖。",
  "settings.apiHint": "仅保存在本浏览器。",
  "settings.skipForNow": "暂时跳过",
  "settings.getStarted": "开始使用",
  "settings.envConfigure": "执行模式",
  "settings.agentModel": "智能体与模型",
  "settings.agentModelHint": "在 Crie3 内工作的智能体",
  "settings.agentModelBody": "选择你在 Crie3 内创作时 Crie3 智能体使用的模型。这不会改变通过 MCP 连接的助手。",
  "settings.localCli": "本机 CLI",
  "settings.anthropicApi": "Anthropic API",
  "settings.noAgentSelected": "尚未选择代理",
  "settings.language": "界面语言",
  "settings.languageHint": "切换界面语言，设置仅保存在当前浏览器。",
  "settings.appearance": "外观",
  "settings.appearanceHint": "选择浅色、深色或跟随系统设置。",
  "settings.themeSystem": "系统",
  "settings.themeLight": "浅色",
  "settings.themeDark": "深色",
  "settings.agentModelHead": "模型：",
  "settings.modelPicker": "模型",
  "settings.modelSourceLive": "来自 CLI 的实时列表",
  "settings.modelSourceFallback": "内置列表",
  "settings.reasoningPicker": "推理强度",
  "settings.modelPickerHint":
    "当 CLI 提供 `models` 命令时会自动拉取。选择「默认」则沿用 CLI 自身的配置；选择「自定义」可手动输入任何 CLI 支持的模型 id。",
  "settings.modelPickerLiveHint":
    "模型列表来自这个 CLI；选“默认”会沿用 CLI 自己的设置。",
  "settings.modelPickerLiveCatalogOnlyHint": "模型列表来自这个 CLI。",
  "settings.modelPickerFallbackHint":
    "正在显示内置默认值。点击“重新扫描”可从 CLI 拉取实时模型。",
  "settings.cliEnvTitle": "高级：代理与自定义路径",
  "settings.cliEnvHint":
    "用于覆盖所选 CLI 的底层环境变量：API key、代理 base URL、自定义 home 或非标准可执行文件路径。不填 base URL 时，CLI 会使用自己的默认接口地址。密钥只保存在本地应用配置中，并且只传给所选 CLI。",
  "settings.cliEnvClaudeConfigDir": "Claude Code 配置目录",
  "settings.cliEnvClaudeBaseUrl": "Claude proxy base URL",
  "settings.cliEnvClaudeApiKey": "Claude CLI API key",
  "settings.cliEnvCodexHome": "Codex home",
  "settings.cliEnvCodexBin": "Codex 可执行文件路径",
  "settings.cliEnvCodexBaseUrl": "Codex/OpenAI proxy base URL",
  "settings.cliEnvCodexApiKey": "Codex/OpenAI CLI API key",
  "settings.modelCustom": "自定义（在下方填写）…",
  "settings.modelCustomLabel": "自定义模型 id",
  "settings.modelCustomPlaceholder": "例如 anthropic/claude-sonnet-4-6",
  "settings.mediaProviders": "媒体生成提供商",
  "settings.mediaProvidersHint":
    "图片、视频、音频生成的 API key。存于本机并同步到本地守护进程。",
  "settings.mcpServerTitle": "MCP 服务器",
  "settings.mcpServerHint":
    "将 Crie3 作为 MCP 服务器暴露给你的编码代理。",
  "settings.externalMcpTitle": "外部 MCP",
  "settings.externalMcpHint":
    "接入外部服务的 MCP 工具（Higgsfield、GitHub 等）。",
  "settings.mediaProviderApiKey": "API key",
  "settings.mediaProviderBaseUrl": "Base URL",
  "settings.mediaProviderConfigured": "已配置",
  "settings.mediaProviderUnset": "未配置",
  "settings.mediaProviderClear": "清除",
  "settings.mediaProviderClearConfirm":
    "清除已保存的 {name} 设置？您需要再次输入才能使用 {name}。",
  "settings.mediaProviderPlaceholder": "粘贴 API key",
  "settings.mediaProviderBaseUrlPlaceholder": "覆盖默认 Base URL",
  "settings.mediaProviderReload": "从本地守护进程重新加载",
  "settings.mediaProviderReloadError":
    "无法从本地守护进程重新加载媒体提供方设置。",
  "settings.mediaProviderReloadSuccess":
    "已从本地守护进程重新加载媒体提供方设置。",
  "settings.mediaProviderLoadError":
    "无法从本地守护进程加载媒体提供方设置。当前将使用浏览器中保存的设置。",
  "settings.mediaProviderComingSoonHint":
    "我们在路线图中跟踪这些提供方；守护进程尚未提供客户端，因此暂无可配置项。",
  "settings.privacy": "隐私",
  "settings.privacyHint": "与 Crie3 团队共享哪些数据",
  "settings.privacyConsentKicker": "帮助我们改进 Crie3",
  "settings.privacyConsentLead":
    "分享使用数据后，我们能更了解 Crie3 在真实工作流里的表现，并优先改进真正影响体验的地方。",
  "settings.privacyConsentFooter": "你可以随时在 设置 → 隐私 中修改这些选项。",
  "settings.privacyConsentShare": "分享",
  "settings.privacyConsentDecline": "不分享",
  "settings.privacyConsentAccept": "我知道了",
  "settings.privacyConsentBannerFooter":
    "默认开启数据分享。你可以随时在 设置 → 隐私 中关闭。",
  "settings.privacyConsentPolicyLink": "查看隐私控制项",
  "settings.privacyMetrics": "匿名指标",
  "settings.privacyMetricsHint":
    "运行次数、token 用量、错误率、耗时等基础使用指标。",
  "settings.privacyContent": "对话和工具内容",
  "settings.privacyContentHint":
    "在剥离密钥等敏感信息后，我们会使用 prompt、助手回复、工具输入/输出，以及质量回看所需的上下文。",
  "settings.privacyConsentContentExcluded": "此选择不会共享这些内容。对话内容保持关闭，除非你在设置 → 隐私中开启。",
  "settings.privacyInstallationId": "匿名 ID",
  "settings.privacyOptedOut": "已退出",
  "settings.privacyDataDeletion": "删除我的数据",
  "settings.privacyDataDeletionHint":
    "轮换你的匿名 ID 并停止发送。已有数据按我们的留存策略自然过期。",
  "settings.legal": "条款",
  "settings.legalHint": "使用条款与隐私政策",
  "settings.plans": "套餐",
  "settings.plansHint": "订阅价格与额度",
  "settings.billing": "订阅",
  "settings.billingHint": "您的套餐与付款信息",
  "legal.tabTerms": "使用条款",
  "legal.tabPrivacy": "隐私政策",
  "legal.badgeDefault": "默认范本",
  "legal.defaultNotice": "这是默认范本，请填写方括号内的内容，并在发布前送审。",
  "legal.updatedAt": "更新于 {date}",
  "legal.reset": "恢复默认范本",
  "legal.resetConfirm": "恢复默认范本？当前正文将会丢失。",
  "legal.exportPdf": "导出 PDF",
  "legal.exportDocx": "导出 DOCX",
  "legal.exporting": "正在导出…",
  "legal.readOnly": "只读。只有本部署的运营者可以编辑这些文档。",
  "legal.titleLabel": "标题",
  "legal.bodyLabel": "正文（Markdown）",
  "legal.bodyHint": "用 # 表示标题，用 - 表示列表。同一段正文会同时用于页面、PDF 和 DOCX。",
  "legal.loadError": "无法加载文档。",
  "legal.saveError": "无法保存文档。",
  "legal.exportError": "无法导出文档。",
  "legal.saved": "文档已保存。",
  "legal.bodyRequired": "正文不能为空。",
  "settings.briefing": "我的品牌",
  "settings.briefingHint": "用于内容和 AI 的品牌资料",
  "briefing.intro": "这些信息会自动填入内容（地址、社交账号、人物），无需每次重新输入。",
  "briefing.loadError": "无法加载资料。",
  "briefing.saveError": "无法保存资料。",
  "briefing.logoUploadError": "无法上传徽标。",
  "briefing.saved": "已保存。",
  "briefing.saving": "保存中…",
  "briefing.save": "保存",
  "briefing.nameLabel": "名称",
  "briefing.cityLabel": "城市",
  "briefing.addressLabel": "地址",
  "briefing.serviceTimesLabel": "固定时间",
  "briefing.servicesLabel": "每周日程",
  "briefing.servicesHint": "每个固定活动的日期和时间（礼拜、排练、直播）。",
  "briefing.serviceDay": "星期",
  "briefing.serviceTime": "时间",
  "briefing.serviceNamePlaceholder": "名称（可选），例如：家庭礼拜、排练",
  "briefing.serviceAdd": "添加时间",
  "briefing.serviceRemove": "移除时间",
  "briefing.serviceIncomplete": "请填写每一行的时间，或移除该行。",
  "briefing.timezoneLabel": "时区",
  "briefing.timezone.saoPaulo": "巴西利亚时间 (UTC−3)",
  "briefing.timezone.manaus": "马瑙斯、库亚巴、大坎普 (UTC−4)",
  "briefing.timezone.rioBranco": "阿克里 (UTC−5)",
  "briefing.timezone.noronha": "费尔南多-迪诺罗尼亚 (UTC−2)",
  "briefing.socialHandlesLabel": "社交账号",
  "briefing.contactsLabel": "联系方式",
  "briefing.contactWhatsapp": "WhatsApp",
  "briefing.contactPhone": "电话",
  "briefing.contactEmail": "邮箱",
  "briefing.contactSite": "网站",
  "briefing.customFieldsLabel": "自定义字段",
  "briefing.customFieldsHint": "填写此客户特有的信息，例如宗派或收听渠道。",
  "briefing.customFieldLabelPlaceholder": "名称",
  "briefing.customFieldValuePlaceholder": "内容",
  "briefing.customFieldAdd": "添加字段",
  "briefing.customFieldRemove": "移除",
  "clients.listHeading": "客户",
  "clients.listHint": "每个客户都有自己的资料、设计系统和 Instagram。",
  "clients.limitUsage": "已使用套餐中 {limit} 个客户里的 {used} 个。",
  "clients.limitReached": "如需添加更多客户，请在“订阅”中更换套餐。",
  "clients.new": "新建客户",
  "clients.namePlaceholder": "客户名称",
  "clients.create": "创建",
  "clients.default": "主要",
  "clients.open": "打开",
  "clients.back": "所有客户",
  "clients.nameLabel": "客户名称",
  "clients.typeLabel": "类型",
  "clients.type.igreja": "教会",
  "clients.type.ministerio": "事工",
  "clients.type.pregador": "传道人",
  "clients.type.cantor_banda": "歌手或乐队",
  "clients.type.criador": "内容创作者",
  "clients.type.evento": "活动",
  "clients.type.agencia": "代理机构",
  "clients.type.outro": "其他",
  "clients.designSystemLabel": "设计系统",
  "clients.designSystemDefault": "账户默认",
  "clients.instagramLabel": "Instagram",
  "clients.instagramNone": "无",
  "clients.save": "保存客户",
  "clients.saved": "客户已保存。",
  "clients.loadError": "无法加载客户。",
  "clients.saveError": "无法保存客户。",
  "clients.nameTaken": "已有其他客户使用此名称。",
  "clients.instagramTaken": "此 Instagram 已属于其他客户。",
  "clients.inviteButton": "邀请连接",
  "clients.inviteHint": "把这个链接发给客户。有效期 7 天，只能连接一次；新链接会替换这个链接。",
  "clients.inviteExpires": "有效期至 {date}",
  "clients.inviteCopy": "复制链接",
  "clients.inviteCopied": "链接已复制。",
  "clients.inviteNew": "新链接",
  "clients.instagramConnect": "连接 Instagram",
  "clients.instagramConnectHint": "打开 Instagram 由你授权；账号归属此客户。",
  "clients.instagramConnected": "Instagram 已连接到此客户。",
  "clients.instagramConnectError": "无法连接 Instagram，请重试。",
  "clients.instagramConnectTaken": "这个 Instagram 已属于另一个客户。",
  "clients.instagramReconnect": "重新连接 Instagram",
  "clients.instagramStatusConnected": "已连接：{handle}，自 {date} 起",
  "clients.instagramStatusReconnect": "{handle} 需要重新授权；在此之前发布会失败。",
  "clients.instagramStatusMissing": "这个客户的 Instagram 已不再连接。请重新连接。",
  "clients.instagramStatusNone": "这个客户还没有连接 Instagram。",
  "clients.instagramBadgeConnected": "Instagram 已连接",
  "clients.instagramBadgeReconnect": "重新连接 Instagram",
  "clients.inviteRevoke": "撤销链接",
  "clients.inviteError": "无法生成邀请链接。",
  "invite.title": "连接 Instagram",
  "invite.body": "{inviter} 邀请 {client} 将 Instagram 连接到 Crie3，以便安排发布。",
  "invite.bodyNoInviter": "{client} 受邀将 Instagram 连接到 Crie3，以便排期发布帖子。",
  "invite.whoSent": "发送邀请的人",
  "invite.connect": "连接 Instagram",
  "invite.privacy": "授权在 Instagram 上完成，Crie3 永远看不到你的密码。",
  "invite.connected": "完成！Instagram @{username} 已连接到 {client}。",
  "invite.connectedNoName": "完成！Instagram 已连接到 {client}。",
  "invite.expired": "此链接已过期。请向 {inviter} 索取新链接。",
  "invite.revoked": "此链接已失效。请向 {inviter} 索取新链接。",
  "invite.notFound": "此链接不存在。请确认链接是否完整复制。",
  "invite.loading": "加载中…",
  "invite.loadError": "无法打开邀请，请重试。",
  "invite.errorDenied": "已在 Instagram 上取消授权，你可以重试。",
  "invite.errorTaken": "这个 Instagram 已连接到其他客户或账户。请使用其他 Instagram，或联系 {inviter}。",
  "invite.errorGeneric": "无法连接，请重试。",
  "clients.archive": "归档",
  "clients.archiveConfirm": "归档 {name}？其项目会保留，Instagram 将释放给其他客户使用。",
  "clients.delete": "删除客户",
  "clients.deleteTitle": "删除 {name}?",
  "clients.deleteBody": "此操作无法撤销。该客户的 Instagram 会与 Crie3 断开,未使用的邀请链接也会失效。如果只想隐藏客户,请使用归档。",
  "clients.deleteProjectsQuestion": "该客户的项目怎么处理?",
  "clients.deleteMove": "把项目移到 {main}",
  "clients.deleteDrop": "同时删除项目",
  "clients.deleteConfirm": "永久删除",
  "clients.deleteScheduled": "{name} 有 {count} 篇已批准或已排期的帖子。请先在日历中取消,再删除。",
  "clients.deleteError": "删除失败。没有删除任何内容,请重试。",
  "clients.profileHeading": "资料",
  "clients.layoutsHeading": "已保存的模板",
  "clients.layoutsEmpty": "还没有模板。在日历中批准帖子时，Crie3 会询问是否将其保存为此客户的模板。",
  "clients.layoutUse": "使用",
  "clients.layoutDelete": "删除",
  "clients.layoutDeleteConfirm": "删除模板“{name}”？",
  "clients.layoutError": "操作失败，请重试。",
  "briefing.pastorsLabel": "出现在内容中的人物",
  "briefing.pastorNamePlaceholder": "姓名",
  "briefing.pastorRolePlaceholder": "角色",
  "briefing.pastorRemove": "删除",
  "briefing.pastorAdd": "添加",
  "briefing.missionLabel": "描述",
  "briefing.audienceLabel": "受众",
  "briefing.bibleVersionLabel": "圣经译本",
  "briefing.voiceAdjectivesLabel": "语气 — 形容词",
  "briefing.voiceUseLabel": "语气 — 使用",
  "briefing.voiceAvoidLabel": "语气 — 避免",
  "briefing.commaHint": "用逗号分隔",
  "briefing.voiceSheet.heading": "语气档案",
  "briefing.voiceSheet.hint": "品牌真正会写的话。内容会遵循这些措辞，绝不使用禁用词。",
  "briefing.voiceSheet.realPhrases": "真实句子（每行一句）",
  "briefing.voiceSheet.greetings": "常用问候语",
  "briefing.voiceSheet.forbidden": "禁用词",
  "briefing.voiceSheet.register": "语气",
  "briefing.voiceSheet.registerUnset": "待确认",
  "briefing.voiceSheet.registerOption.sobrio": "庄重",
  "briefing.voiceSheet.registerOption.caloroso": "温暖",
  "briefing.voiceSheet.registerOption.fervoroso": "火热",
  "briefing.voiceSheet.hashtagsFixed": "固定话题标签（3 到 5 个）",
  "briefing.voiceSheet.hashtagBrand": "品牌话题标签",
  "briefing.doctrine.heading": "教义设定",
  "briefing.doctrine.hint": "标为\"待确认\"的项目在作品中绝不预设立场。",
  "briefing.doctrine.family": "教义传统",
  "briefing.doctrine.giftsTongues": "圣灵恩赐 / 说方言",
  "briefing.doctrine.faithHealing": "凭信心得医治",
  "briefing.doctrine.prosperity": "成功神学",
  "briefing.doctrine.eternalSecurity": "永远得救的确据",
  "briefing.doctrine.predestination": "预定论",
  "briefing.doctrine.womenInMinistry": "女性事奉",
  "briefing.doctrine.stance.afirma": "认同",
  "briefing.doctrine.stance.neutro": "中立",
  "briefing.doctrine.stance.nega": "不认同",
  "briefing.doctrine.stance.aConfirmar": "待确认",
  "briefing.decisions.label": "已批准的决定",
  "briefing.decisions.hint": "现场已确认的内容。之后的内容从这里出发。",
  "briefing.decisions.empty": "暂无记录。",
  "briefing.decisions.remove": "移除决定",
  "briefing.decisions.kind.voz": "语气",
  "briefing.decisions.kind.visual": "视觉",
  "briefing.spacePhotos.label": "场地照片",
  "briefing.spacePhotos.hint": "礼拜堂、讲台或外观的真实照片。只有质量\"良好\"的照片可以作为作品主图。",
  "briefing.spacePhotos.add": "添加照片",
  "briefing.spacePhotos.descriptionPlaceholder": "照片内容",
  "briefing.spacePhotos.quality": "质量",
  "briefing.spacePhotos.quality.boa": "良好",
  "briefing.spacePhotos.quality.mediana": "一般",
  "briefing.spacePhotos.remove": "移除照片",
  "briefing.spacePhotos.uploadError": "照片上传失败。请使用不超过 12 MB 的 JPEG、PNG 或 WebP。",
  "briefing.spacePhotos.saveError": "照片更新失败。",
  "briefing.colorsLabel": "品牌颜色",
  "briefing.fontsLabel": "品牌字体",
  "briefing.logoLightLabel": "浅色徽标",
  "briefing.logoDarkLabel": "深色徽标",
  "briefing.logoLightHint": "用于浅色背景",
  "briefing.logoDarkHint": "用于深色背景",
  "briefing.logoEmpty": "尚未上传标志",
  "briefing.logoUnavailable": "无法显示此标识，请重新加载页面。",
  "briefing.logoChoose": "选择图片",
  "briefing.logoUploading": "上传中…",
  "briefing.fillWithAi": "用 Crie3 智能体填写",
  "briefing.fillWithAiHint": "回答几个问题，AI 会填写各项内容。你的回答会替换当前内容；历史记录会保留之前的版本。",
  "briefing.fillWithAiCost": "这段对话会使用你套餐的 AI 额度：每次回答都会消耗一点。通过已连接的助手（MCP）制作设计不消耗额度。",
  "briefing.interviewDone": "完成！资料已根据你的回答更新。",
  "briefing.interviewClose": "关闭访谈",
  "briefing.interviewError": "现在无法继续访谈。请关闭后手动填写各项，或稍后再试。",
  "briefing.interviewErrorQuota": "你的账户本月的 AI 用量已用完。请关闭后手动填写各项；访谈下个月可再次使用。",
  "briefing.interviewErrorNotConfigured": "此安装不支持 AI 访谈。请关闭后手动填写各项。",
  "briefing.historyLabel": "修改历史",
  "briefing.historySource.ui": "通过应用",
  "briefing.historySource.cli": "通过 CLI",
  "briefing.historySource.api": "通过 API",
  "briefing.historySource.onboarding": "通过 AI 访谈",
  "briefing.unsavedChanges": "有未保存的更改",
  "settings.about": "关于",
  "settings.aboutHint": "版本和运行时详情",
  "settings.appVersion": "版本",
  "settings.appChannel": "渠道",
  "settings.appRuntime": "运行时",
  "settings.appPlatform": "平台",
  "settings.appArchitecture": "架构",
  "settings.runtimePackaged": "已打包应用",
  "settings.runtimeDevelopment": "开发环境",
  "settings.versionUnavailable": "守护进程离线时无法获取版本详情。",
  "settings.allowSilentUpdates": "允许静默更新",
  "settings.allowSilentUpdatesDesc": "启动时自动应用已下载的 payload 更新。安装器更新仍会先询问。",
  "settings.installLatest": "安装最新版本",
  "settings.alreadyLatest": "当前为最新版本",
  "settings.mcpTitle": "MCP 服务器",
  "settings.mcpHint":
    "让其他仓库中的编码助手（Claude Code、Cursor、VS Code、Antigravity、Zed、Windsurf）读取你的 Crie3 项目。无需先导出 zip，即可将设计拉取到你的应用中。",
  "settings.mcpDaemonError":
    "无法连接到本地守护进程以解析安装路径（{error}）。请确保 Crie3 正在运行，然后重新打开此面板。",
  "settings.mcpBuildDaemon": "请先构建守护进程。",
  "settings.mcpNodeMissing": "Node 二进制文件缺失。",
  "settings.mcpBuildHint":
    "apps/daemon/dist/cli.js 缺失。请运行 `pnpm --filter @open-design/daemon build` 并刷新。",
  "settings.mcpMethodCli": "CLI 命令",
  "settings.mcpInstructionCli": "在你的终端中运行此命令。",
  "settings.mcpMethodToml": "TOML 配置",
  "settings.mcpInstructionCodex":
    "将以下配置追加到 {path}。Codex CLI 与 Codex IDE 扩展共享同一配置。",
  "settings.mcpMethodOneClick": "一键安装",
  "settings.mcpInstructionCursor":
    '点击"在 Cursor 中安装"以通过确认对话框安装，或将此 JSON 合并到 {path}。',
  "settings.mcpDeeplinkInstallCursor": "在 Cursor 中安装",
  "settings.mcpMethodJson": "JSON 配置",
  "settings.mcpInstructionCopilot":
    '打开命令面板（{shortcut}），运行 "MCP: Open User Configuration"，然后合并此 JSON。Copilot Chat 必须处于 Agent 模式，工具才会显示。',
  "settings.mcpInstructionAntigravity":
    '在 Antigravity 中：Agent 面板 "..." 菜单 → MCP Servers → Manage MCP Servers → View raw config。合并此 JSON。',
  "settings.mcpInstructionZed":
    '打开 Zed Settings（{shortcut}），然后将此配置合并到顶层对象中。Zed 使用 "context_servers"，而非 "mcpServers"。',
  "settings.mcpInstructionWindsurf":
    "打开 {path}（或在 Cascade 中使用 MCPs 图标 → Configure）并合并：",
  "settings.mcpCopyAria": "复制 MCP 配置片段",
  "settings.mcpResolvingFailed": "# 解析路径失败，请查看上方错误",
  "settings.mcpLoadingPaths": "# 正在从本地守护进程加载安装路径…",
  "settings.mcpCopied": "已复制",
  "settings.mcpCopy": "复制",
  "settings.mcpCursorApproval": "Cursor 会在写入配置前弹出确认对话框。",
  "settings.mcpCodexOneClickInstall": "配置到 Codex",
  "settings.mcpCodexOneClickUninstall": "取消配置",
  "settings.mcpCodexOneClickUnavailable":
    "未在 PATH 中找到 codex CLI——请先安装 Codex 或手动复制片段。",
  "settings.mcpCodexInstallSuccess": "已配置。请重启 Codex 以加载新 server。",
  "settings.mcpCodexUninstallSuccess": "已从 Codex 取消配置。",
  "settings.mcpCodexBusy": "处理中…",
  "settings.mcpCodexInstallError": "操作失败：{error}",
  "settings.mcpRestartNote": "重启客户端以加载新 server。",
  "settings.mcpRestartDetail":
    "大多数编辑器仅在启动时加载 MCP server。在 Cursor / VS Code / Antigravity / Windsurf 中，你可以在命令面板中运行 `Developer: Reload Window`，无需完全重启。Zed 和 Claude Code 需要退出并重新打开。",
  "settings.mcpCapabilitiesTitle": "你的助手可以做什么",
  "settings.mcpCapabilityRead":
    "读取或搜索项目中的任意文件（HTML、JSX、CSS、JSON、SVG、Markdown）。",
  "settings.mcpCapabilityPull":
    "一次调用拉取设计包：入口文件及其引用的所有 CSS 变量、组件和字体。",
  "settings.mcpCapabilityDefault":
    '默认使用你在 Crie3 中打开的项目和文件，因此你可以直接说"在我的应用中构建这个"，无需重复说明是哪个设计。',
  'settings.mcpRemoteHeading': 'Connect your coding agent',
  'settings.mcpRemoteIntro': 'Connect claude.ai, ChatGPT or a coding agent to this account over the internet.',
  'settings.mcpRemoteAddressLabel': 'Address',
  'settings.mcpRemoteKeyHeading': 'Access key',
  'settings.mcpRemoteKeyNone': 'No key yet. Create one so your agent can sign in.',
  'settings.mcpRemoteKeyCreated': 'Key created on {date}.',
  'settings.mcpRemoteGenerate': 'Create key',
  'settings.mcpRemoteRegenerate': 'Create a new key',
  'settings.mcpRemoteRegenerateNote': 'Creating a new key stops the previous one from working straight away.',
  'settings.mcpRemoteRevoke': 'Revoke key',
  'settings.mcpRemoteRevoked': 'The key was revoked. Anything still using it is now disconnected.',
  'settings.mcpRemoteBusy': 'One moment…',
  'settings.mcpRemoteKeyLabel': 'Your new key',
  'settings.mcpRemoteKeyOnce': 'Copy this key now — it is shown once and cannot be recovered afterwards.',
  'settings.mcpRemoteSnippetHeading': 'Ready to paste',
  'settings.mcpRemoteSnippetNote': 'Paste this into your agent settings. If you have already closed the key, replace the marked part with yours.',
  'settings.mcpRemoteScopeNote': 'The key and the connected apps can read your projects and start new work, including asking the Crie3 agent to change pieces. They cannot delete projects or publish posts without your approval.',
  'settings.mcpRemoteError': 'Something went wrong: {error}',
  'settings.mcpRemoteKeyPlaceholder': 'YOUR-ACCESS-KEY',
  'settings.mcpRemoteOAuthHint': 'In claude.ai, ChatGPT or Claude Code, add this address as a custom connector (remote MCP server). Crie3 asks for your e-mail and password when you connect.',
  'settings.mcpRemoteKeyForOthers': 'For agents without login support, or for scripts, create a key and send it in the Authorization header.',
  'settings.mcpConnectionsHeading': 'Connected apps',
  'settings.mcpConnectionsEmpty': 'No app has connected through login yet.',
  'settings.mcpConnectionsSince': 'Connected on {date}',
  'settings.mcpConnectionsLastUsed': 'last used {date}',
  'settings.mcpConnectionsDisconnect': 'Disconnect',
  'settings.mcpConnectionsDisconnected': '{name} was disconnected. It stops working on its next call.',
  'settings.mcpConnectionsNote': 'Changing your password does not disconnect these apps. Disconnect here any app you no longer use.',
  "settings.mcpRunningNote":
    "Crie3 必须处于运行状态，MCP 工具调用才能成功。如果你在打开 Crie3 之前启动了编码助手，请重启助手以便它能连接到正在运行的守护进程。",
  "entry.tabDesigns": "我的设计",
  "entry.tabTemplates": "模板",
  "entry.tabDesignSystems": "设计体系",
  "entry.tabConnectors": "连接器",
  "entry.openSettingsTitle": "设置",
  "entry.openSettingsAria": "打开设置",
  "entry.discordLabel": "加入 Discord",
  "entry.discordOnlineLabel": "{count} 在线",
  "entry.followThreadsLabel": "Follow Crie3 on Threads",
  "entry.followLinkedinLabel": "在 LinkedIn 上关注 Crie3",
  "entry.followXiaohongshuLabel": "在小红书上关注 Crie3",
  "entry.youtubeLabel": "Crie3 on YouTube",
  "entry.resizeAria": "调整侧边栏宽度",
  "entry.loadingWorkspace": "正在加载工作区…",
  "entry.useEverywhereTitle": "随处使用",
  "entry.useEverywhereAria": "打开「随处使用」指南（CLI、MCP、HTTP、Skills）",
  "entry.workspaceTeamsLabel": "团队版",
  "entry.workspaceTeamsTitle": "团队版工作区 — 告诉我们你的团队需求",
  "entry.workspaceTeamsAria": "打开团队版工作区页面",
  "entry.navExpand": "展开侧栏",
  "entry.navCollapse": "收起侧栏",
  "entry.navNewProject": "新建项目",
  "entry.navHome": "主页",
  "entry.navProjects": "项目",
  "entry.navCalendar": "日历",
  "entry.navClients": "客户",
  "calendar.title": "日历",
  "calendar.intro": "所有已排期的帖子。发布前可以批准、改期或取消。",
  "calendar.week": "周",
  "calendar.client": "客户",
  "calendar.allClients": "全部客户",
  "calendar.month": "月",
  "calendar.previous": "上一页",
  "calendar.next": "下一页",
  "calendar.today": "今天",
  "calendar.loadError": "无法加载日历。",
  "calendar.empty": "此期间没有排期。",
  "calendar.more": "另外 {n} 条",
  "calendar.state.draft": "待批准",
  "calendar.state.approved": "已批准",
  "calendar.state.queued": "已排期",
  "calendar.state.publishing": "发布中",
  "calendar.state.handed_off": "可由你发布",
  "calendar.state.published": "已发布",
  "calendar.state.failed": "失败",
  "calendar.state.canceled": "已取消",
  "calendar.origin.user": "由你创建",
  "calendar.origin.mcp": "外部助手的草稿",
  "calendar.origin.weekly": "由 Crie3 生成",
  "calendar.approve": "批准",
  "calendar.approveTiktokHint": "TikTok 帖子需在发布界面批准，TikTok 在那里要求额外选择。",
  "calendar.reschedule": "改期",
  "calendar.rescheduleLabel": "新的日期和时间",
  "calendar.unapprove": "退回草稿",
  "calendar.cancel": "取消帖子",
  "calendar.cancelReason": "原因（可选）",
  "calendar.close": "关闭",
  "calendar.actionError": "没有成功。请刷新日历后重试。",
  "calendar.layoutOffer": "将此帖子的版式保存为客户模板，以便下次复用？",
  "calendar.layoutNameLabel": "模板名称",
  "calendar.layoutSave": "保存为模板",
  "calendar.layoutDismiss": "暂不",
  "calendar.layoutSaved": "已保存到客户模板。它会显示在客户页面，并提供给 claude.ai 上的助手。",
  "calendar.layoutError": "无法保存此帖子的模板。",
  "calendar.scheduledFor": "排期：{when}",
  "calendar.chipAutomatic": "自动",
  "calendar.automaticNotice": "自动帖子：将于 {when} 发布。如果不想发布，可以在这里取消。",
  "calendar.viewOnInstagram": "在 Instagram 上查看",
  "calendar.slideOf": "第 {n} 张，共 {total} 张",
  "calendar.previousSlide": "上一张",
  "calendar.nextSlide": "下一张",
  "calendar.failure.zernioDisconnected": "Instagram 账号已断开连接，所以帖子没有发出。请重新连接，然后重新安排。",
  "calendar.failure.zernioPostFailed": "Instagram 没有发布这条帖子。请检查作品（格式和尺寸）后重新安排。",
  "calendar.reconnectInstagram": "请重新连接 Instagram：@{account} 已断开连接，重新连接之前，已安排的帖子不会发出。",
  "calendar.reconnectAction": "重新连接",
  "social.health.needsReconnect": "需要重新连接",
  "social.automations.title": "关键词 → 私信",
  "social.automations.hint": "有人在任意 Instagram 帖子下评论这些词时，会收到你的私信。",
  "social.automations.empty": "还没有自动回复。",
  "social.automations.offline": "Zernio 没有响应，显示已保存的副本。",
  "social.automations.keywords": "关键词（用逗号分隔）",
  "social.automations.keywordsPlaceholder": "礼拜, 时间",
  "social.automations.message": "私信内容",
  "social.automations.reply": "对评论的公开回复（可选）",
  "social.automations.account": "哪个 Instagram",
  "social.automations.create": "创建为暂停",
  "social.automations.on": "已开启",
  "social.automations.paused": "已暂停",
  "social.automations.sent": "已发送 {count} 条私信",
  "social.automations.turnOn": "开启",
  "social.automations.turnOff": "暂停",
  "social.automations.delete": "删除",
  "social.automations.confirmOn": "要开启“{keywords}”的回复吗？此后评论这些词的每个人都会收到这条私信。",
  "social.automations.failed": "无法保存自动回复，请重试。",
  "social.automations.needsInstagram": "请先连接教会的 Instagram。",
  "calendar.policy.AUTOMATIC_MODE_OFF": "已退回草稿：自动模式已关闭。如果仍要发布，请批准。",
  "calendar.policy.MISSED_SLOT": "已退回草稿：错过了发布时间。选择新时间后重新批准。",
  "calendar.policy.NOT_ENOUGH_NOTICE": "已退回草稿：自动帖子发布前需要在日历中保留 24 小时。",
  "calendar.policy.NOT_ELIGIBLE_FOR_AUTOMATION": "需要你的批准：只有 Crie3 生成的每周邀请才会自动发布。",
  "publishing.title": "发布模式",
  "publishing.manual": "手动：每个帖子都需要等待你的批准。",
  "publishing.scopeHint": "只有「我的品牌」的每周邀请会自动发布。其他客户的帖子等待你的批准。",
  "publishing.automatic": "在 {account} 上自动：每周邀请会自动发布，每条会先在这里显示 24 小时。",
  "publishing.optedInBy": "由 {who} 于 {when} 开启。",
  "publishing.paused": "已暂停：在你恢复之前，不会发布或生成任何内容。",
  "publishing.turnOn": "开启自动模式",
  "publishing.turnOff": "改回手动",
  "publishing.pause": "暂停全部",
  "publishing.resume": "恢复",
  "publishing.error": "没有成功。请重试。",
  "publishing.optInTitle": "自动发布",
  "publishing.optInTerms": "开启自动发布后，Crie3 每周会为「我的品牌」中登记的每场礼拜生成一份邀请，并在日历显示的时间自动发布，无需再次批准。每份邀请在发布前至少会在这里保留 24 小时，并可以取消。你可以随时暂停全部或改回手动模式。\n\nAI 生成的内容可能包含错误。开启此功能即表示你对以教会名义发布的内容负责，并同意持续关注日历。外部助手生成的草稿仍需要你的批准。",
  "publishing.termsLink": "阅读使用条款（第 12 条）",
  "publishing.optInAccount": "Instagram 账号",
  "publishing.optInNoAccount": "请先在设置中连接一个 Instagram 账号。",
  "publishing.optInAccept": "我已阅读并接受使用条款第 12 条。",
  "publishing.optInConfirm": "开启",
  "publishing.optInTermsChanged": "此窗口打开期间条款发生了变化。请重新阅读并确认。",
  "weekly.title": "本周邀请",
  "weekly.empty": "在「我的品牌」中添加你的礼拜，Crie3 将每周为每场礼拜生成一份邀请。",
  "weekly.scopeHint": "仅适用于「我的品牌」，依据其资料中的礼拜生成。",
  "weekly.runNow": "立即生成",
  "weekly.runNowStarted": "生成中。邀请准备好后会显示在日历中。",
  "weekly.nextRun": "下次生成：{when}",
  "weekly.status.pending": "等待中",
  "weekly.status.generating": "生成中",
  "weekly.status.scheduled": "已排期",
  "weekly.status.draft": "待批准",
  "weekly.status.not_generated": "未生成",
  "weekly.error": "无法加载本周邀请。",
  "weekly.offHint": "已关闭。开启后，Crie3 每周为每场礼拜生成一份邀请——每份都会消耗你套餐中的生成次数。",
  "weekly.turnOn": "开启",
  "weekly.turnOff": "关闭",
  "entry.navTasks": "自动化",
  "entry.navPlugins": "插件",
  "entry.navDesignSystems": "设计体系",
  "entry.navBrands": "设计系统",
  "entry.navIntegrations": "集成",
  "workspaceTabs.project": "项目",
  "workspaceTabs.pluginDetails": "插件详情",
  "workspaceTabs.marketplace": "插件市场",
  "homeHero.title": "你今天要设计什么？",
  "homeHero.startWithTemplate": "从模板开始…",
  "homeHero.startBlankProject": "…或创建一个空白项目",
  "homeHero.templatePicker.label": "模板",
  "homeHero.templatePicker.searchPlaceholder": "搜索模板",
  "homeHero.templatePicker.projectTypes": "项目类型",
  "homeHero.templatesScrollHint": "向上滑动探索更多模板",
  "homeHero.templatesCollapse": "收起模板",
  "homeHero.subtitlePrefix": "Claude Design 的开源替代方案。",
  "homeHero.placeholder": "描述你想生成的内容…",
  "homeHero.placeholderActive": "编辑示例请求，或写下你自己的需求…",
  "homeHero.carousel.hint": "上传文件、关联设计系统，或描述你想创作的内容",
  "homeHero.carousel.onePageBrief": "Put together the church schedule for this week",
  "homeHero.carousel.notesToDeck": "Turn my sermon notes into projection slides",
  "homeHero.carousel.signupFlow": "Build a signup page for the retreat",
  "homeHero.carousel.improveBrief": "Improve the wording of a baptism announcement",
  "homeHero.carousel.loadingAnimation": "Create a countdown for the start of the service",
  "homeHero.carousel.teamUpdateSlides": "Make slides with the song lyrics for the screen",
  "homeHero.carousel.ordersDashboard": "Build a page to follow the giving campaign",
  "homeHero.carousel.productDetail": "Lay out the artwork for a new sermon series",
  "homeHero.carousel.caseStudy": "Write the script for the weekly devotional",
  "homeHero.carousel.landingIntro": "Create an invite for the Friday youth service at 8pm",
  "homeHero.carousel.pitchDeck": "Make slides to present the missions project",
  "homeHero.carousel.appIdea": "Describe a daily devotional app for the church",
  "homeHero.carousel.landingLayout": "Sketch a Bible verse card for the feed",
  "homeHero.skills": "技能",
  "homeHero.addMenu": "添加",
  "homeHero.addPlugin": "添加插件",
  "homeHero.addConnectors": "添加连接器",
  "homeHero.addMcp": "添加 MCP 服务",
  "homeHero.noPlugins": "暂无已安装的插件",
  "homeHero.noMcp": "暂无 MCP 服务",
  "homeHero.noConnectors": "暂无已连接的连接器",
  "homeHero.applying": "正在应用…",
  "homeHero.pluginTitle": "插件：{title}",
  "homeHero.pluginPrefix": "插件：{title}",
  "homeHero.skillPrefix": "技能：{title}",
  "homeHero.removePlugin": "移除插件",
  "homeHero.removePluginAria": "移除插件 {title}",
  "homeHero.clearActivePlugin": "清除当前插件",
  "homeHero.clearActiveSkill": "清除当前技能",
  "homeHero.contextItemsResolved": "已解析 {n} 个上下文项",
  "homeHero.removeFile": "移除文件",
  "homeHero.contextSearchResults": "上下文搜索结果",
  "homeHero.contextSurfaces": "上下文来源",
  "homeHero.loadingContext": "正在加载上下文…",
  "homeHero.noResults": "没有找到“{query}”的结果。",
  "homeHero.searchPrompt": "搜索文件、插件、技能、MCP 服务器和连接器。",
  "homeHero.parameters": "{n} 个参数",
  "homeHero.details": "详情",
  "homeHero.toRun": "运行",
  "homeHero.forNewLine": "换行",
  "homeHero.run": "运行",
  "homeHero.typeSomethingToRun": "输入内容后运行",
  "homeHero.promptExamples": "示例提示词",
  "homeHero.footer.designSystem": "风格",
  "homeHero.footer.autoDesignSystem": "自动",
  "homeHero.footer.autoDesignSystemSummary":
    "根据当前 Prompt 自动匹配合适的设计体系和视觉风格。",
  "homeHero.footer.ratio": "比例",
  "homeHero.footer.duration": "时长",
  "homeHero.footer.resolution": "分辨率",
  "homeHero.footer.speakerNotes": "备注",
  "homeHero.footer.noSpeakerNotes": "无备注",
  "homeHero.footer.availableCount": "{n} 个可用",
  "homeHero.footer.noMatches": "无匹配结果",
  "homeHero.moreShortcuts": "更多",
  "homeHero.railAria": "选择项目类别或启动入口",
  "homeHero.subTypeAria": "选择子类型",
  "homeHero.subTypeMore": "更多",
  "homeHero.confirmReplaceTitle": "替换当前 Prompt？",
  "homeHero.confirmReplaceBody": "使用 {title} 会替换输入框中的现有文本。",
  "homeHero.confirmReplace": "替换",
  "homeHero.chip.prototype": "原型",
  "homeHero.chip.webClone": "网站复刻",
  "homeHero.chip.liveArtifact": "实时看板",
  "homeHero.chip.deck": "幻灯片",
  "homeHero.chip.image": "图片",
  "homeHero.chip.video": "视频",
  "homeHero.chip.hyperframes": "HyperFrames",
  "homeHero.chip.webgl": "WebGL 体验",
  "homeHero.chip.webglDesc": "着色器、3D 与生成式 GPU 视觉",
  "homeHero.chip.worker": "Worker 可视化",
  "homeHero.chip.workerDesc": "离主线程模拟、粒子与数据可视化",
  "homeHero.chip.audio": "音频",
  "homeHero.chip.createBrandKit": "创建设计系统",
  "homeHero.chip.createPlugin": "创建插件",
  "homeHero.chip.figma": "来自 Figma",
  "homeHero.chip.folder": "来自文件夹",
  "homeHero.chip.template": "来自模板",
  "homeHero.chip.liveArtifactHint": "构建可实时预览的交互式 HTML/CSS/JS 制品。",
  "homeHero.chip.hyperframesHint":
    "创作基于 HTML 的动态内容：字幕、音频响应视觉和场景转场。",
  "homeHero.chip.createBrandKitHint":
    "从网站提取一个设计系统，然后在任意对话中应用它。",
  "homeHero.chip.createPluginHint":
    "创作可复用的 Crie3 插件，并添加到我的插件。",
  "homeHero.chip.figmaHint": "将 Figma 画框迁移到当前设计体系。",
  "homeHero.chip.folderHint": "导入本地文件夹并继续编辑。",
  "homeHero.chip.templateHint": "从内置模板开始。",
  "homeHero.chip.wireframe": "线框图",
  "homeHero.chip.mobile": "移动应用",
  "homeHero.chip.document": "文档",
  "homeHero.chip.prototypeDesc": "可交互的应用原型",
  "homeHero.chip.webCloneDesc": "按源码证据复刻网站",
  "homeHero.chip.wireframeDesc": "低保真屏幕与流程",
  "homeHero.chip.mobileDesc": "iOS 与安卓界面",
  "homeHero.chip.deckDesc": "演示文稿与路演稿",
  "homeHero.chip.documentDesc": "简历、报告与 PDF",
  "homeHero.chip.imageDesc": "海报、图形与插画",
  "homeHero.chip.videoDesc": "短片、Reels 与宣传片",
  "homeHero.chip.audioDesc": "配音、音乐与音效",
  "homeHero.chip.hyperframesDesc": "动态图形与循环动画",
  "homeHero.chip.liveArtifactDesc": "数据驱动的实时看板",
  "homeHero.chip.createBrandKitDesc": "从网站提取品牌设计系统",
  "homeHero.chip.prototypeNext":
    "打开对话,构建可逐轮打磨的高保真可点击网页原型。",
  "homeHero.chip.webCloneNext": "打开使用 web-clone skill 的对话，先贴目标 URL，再侦察、复刻并审计产物。",
  "homeHero.chip.wireframeNext":
    "打开对话,先用低保真屏幕与流程验证结构,再做视觉设计。",
  "homeHero.chip.mobileNext": "打开对话,排布 iOS 与安卓的移动端界面。",
  "homeHero.chip.deckNext": "打开对话,生成可演示、可导出的幻灯片。",
  "homeHero.chip.documentNext": "打开对话,起草精美的文档——简历、报告或 PDF。",
  "homeHero.chip.imageNext": "打开对话,生成符合品牌的图片并持续迭代。",
  "homeHero.chip.videoNext": "打开对话,生成可继续打磨的短视频。",
  "homeHero.chip.audioNext": "打开对话,创建配音、音乐或音效。",
  "homeHero.chip.webClonePromptSeed": "想要复刻的网站链接：",
  "homeWorkingDir.trigger": "选择工作目录",
  "homeWorkingDir.pick": "选择目录",
  "homeWorkingDir.replace": "修改工作目录",
  "homeWorkingDir.recent": "最近使用的目录",
  "homeWorkingDir.recentEmpty": "暂无最近使用的目录",
  "homeWorkingDir.clear": "移除工作目录",
  "homeWorkingDir.hint": "让 Agent 可读取该本地目录（不会导入到 Design Files）",
  "homeWorkingDir.missing": "该工作目录已不存在，请重新选择",
  "homeWorkingDir.applyFailed": "无法设置工作目录，该文件夹可能已不存在",
  "workingDirPicker.title": "目录",
  "workingDirPicker.homeTitle": "默认存在本地存储，点击可选择文件夹",
  "workingDirPicker.processing": "处理中…",
  "workingDirPicker.select": "本地存储",
  "workingDirPicker.clearAria": "清除工作目录",
  "workingDirPicker.replaceFailed": "替换工作目录失败",
  "workingDirPicker.unavailable": "未选择目录 — 启动桌面版以使用原生选择器",
  "workingDirPicker.openUnavailable": "请在桌面版中打开此项目以显示文件夹。",
  "workingDirPicker.openFailed": "无法显示此文件夹",
  "workingDirPicker.showInFileManager": "在文件管理器中显示",
  "workingDirPicker.replace": "选择文件夹…",
  "workingDirPicker.recent": "最近使用的目录",
  "workingDirPicker.defaultLabel": "本地存储",
  "handoff.toTarget": "交付给 {target}",
  "handoff.openInTarget": "在 {target} 中打开",
  "handoff.openAction": "打开",
  "handoff.menuTitle": "在哪个编辑器中打开？",
  "handoff.action": "交付",
  "handoff.fallbackTitle": "未找到编辑器 - 使用 {target} 打开",
  "handoff.chooseTargetAria": "选择交付目标",
  "handoff.optionsAria": "交付选项",
  "handoff.editorSection": "通过编辑器打开",
  "handoff.cliSection": "复制给 CLI",
  "handoff.clickOpen": "点击打开",
  "handoff.framework": "代码框架",
  "handoff.framework.react": "React",
  "handoff.framework.vue": "Vue.js",
  "handoff.framework.svelte": "Svelte",
  "handoff.framework.solid": "SolidJS",
  "handoff.framework.next": "Next.js",
  "handoff.framework.vanilla": "JS",
  "handoff.frameworkPrompt.react": "React",
  "handoff.frameworkPrompt.vue": "Vue.js",
  "handoff.frameworkPrompt.svelte": "Svelte",
  "handoff.frameworkPrompt.solid": "SolidJS",
  "handoff.frameworkPrompt.next": "Next.js / React",
  "handoff.frameworkPrompt.vanilla": "原生 JavaScript、HTML 和 CSS",
  "handoff.amrWebsite": "打开 Crie3 Cloud 官网",
  "handoff.copyPrompt": "复制提示词",
  "handoff.copyPromptForTarget": "复制给 {target} 的提示词",
  "handoff.copied": "已复制",
  "handoff.projectPathUnavailable": "还没有拿到项目本地路径，请稍后再试。",
  "handoff.copyFailed": "浏览器拒绝写入剪贴板，请稍后再试。",
  "handoff.promptIntro": "请基于这个 Crie3 项目的本地文件夹继续实现：",
  "handoff.promptTarget": "目标",
  "handoff.promptCli": "CLI",
  "handoff.promptStepsLead": "你现在是在 {cli} 中接手，请：",
  "handoff.promptReadFiles":
    "先进入或读取这个目录，优先阅读 DESIGN.md、README、现有 HTML/CSS/JS、素材和 package.json（如果存在）。",
  "handoff.promptKeepDesign":
    "保持现有视觉、布局、交互和素材，不要只描述方案。",
  "handoff.promptProduceCode":
    "生成或修改真实可运行的 {framework} 代码；如果项目已有更明确的工程栈，先说明冲突并优先保持可运行。",
  "handoff.promptVerify": "完成后告诉我运行、预览和验证命令。",
  "handoff.promptCommandHint": "如果要先切到项目目录，可以用：",
  "handoff.promptProject": "项目",
  "handoff.promptProjectId": "项目 ID",
  "handoff.notInstalled": "未安装",
  "handoff.notDetectedTitle": "{target} - 未在 $PATH 中检测到",
  "designSystemPicker.select": "选择设计系统",
  "designSystemPicker.loading": "正在加载设计系统…",
  "designSystemPicker.searchPlaceholder": "搜索设计系统（标题 / 分类 / 摘要）",
  "designSystemPicker.searchCompactPlaceholder": "搜索设计系统",
  "designSystemPicker.noneTitle": "不指定设计系统",
  "designSystemPicker.noneSummary":
    "不指定设计系统，模型会根据你的 Prompt 自由发挥视觉风格。",
  "designSystemPicker.empty": "没有匹配的设计系统",
  "designSystemPicker.openPreview": "打开预览",
  "designSystemPicker.loadingPreview": "正在加载预览…",
  "designSystemPicker.noPreview": "无预览页面 — 在「设计系统」中查看完整预览",
  "designSystemPicker.previewHint": "将鼠标悬停在左侧条目上查看预览",
  "designSystemPicker.fullscreenAria": "{title} 全屏预览",
  "designSystemPicker.closeFullscreen": "关闭全屏预览",
  "designSystemPicker.closeEsc": "关闭 (Esc)",
  "designSystemPicker.previewFrameTitle": "{title} 预览",
  "designSystemPicker.fullscreenFrameTitle": "{title} 全屏预览",
  "recentProjects.title": "最近项目",
  "recentProjects.viewAll": "查看全部",
  "recentProjects.empty": "还没有项目 — 输入 Prompt 即可开始。",
  "pluginsHome.title": "Community",
  "pluginsHome.subtitle":
    "当前运行环境内置的 Crie3 工作流。选择一个加载 starter prompt，或浏览插件市场查看更多。",
  "pluginsHome.browseRegistry": "浏览插件市场",
  "pluginsHome.count": "{filtered} / {total}",
  "pluginsHome.loadingCatalog": "正在加载目录…",
  "pluginsHome.emptyCatalog":
    "目录为空。Crie3 会随附内置插件，如果这里一直为空，请尝试重启 daemon。",
  "pluginsHome.emptyFiltered": "没有插件匹配当前筛选条件。",
  "pluginsHome.clearFilters": "清除筛选",
  "pluginsHome.modeAria": "插件模式",
  "pluginsHome.featured": "已保存",
  "pluginsHome.totalInCatalog": "目录中共 {n} 个",
  "pluginsHome.categoryFilterAria": "类别筛选",
  "pluginsHome.subcategoryFilterAria": "{label} 子类别筛选",
  "pluginsHome.allCategory": "全部 {label}",
  "pluginsHome.searchPlaceholder": "搜索插件…",
  "pluginsHome.searchAria": "搜索插件",
  "pluginsHome.clearSearch": "清除搜索",
  "pluginsHome.sortAria": "排序方式",
  "pluginsHome.sortHot": "热门",
  "pluginsHome.sortNewest": "最新",
  "pluginsHome.facet.import": "导入",
  "pluginsHome.facet.create": "创建",
  "pluginsHome.facet.export": "导出",
  "pluginsHome.facet.share": "分享",
  "pluginsHome.facet.deploy": "部署",
  "pluginsHome.facet.refine": "优化",
  "pluginsHome.facet.extend": "扩展",
  "pluginsHome.facet.figma": "Figma",
  "pluginsHome.facet.github": "GitHub",
  "pluginsHome.facet.codeFolder": "代码 / 文件夹",
  "pluginsHome.facet.url": "URL",
  "pluginsHome.facet.screenshot": "截图",
  "pluginsHome.facet.pdf": "PDF",
  "pluginsHome.facet.pptx": "PPTX",
  "pluginsHome.facet.framer": "Framer",
  "pluginsHome.facet.webflow": "Webflow",
  "pluginsHome.facet.slides": "幻灯片",
  "pluginsHome.facet.publicLink": "公开链接",
  "pluginsHome.facet.githubPr": "GitHub PR",
  "pluginsHome.facet.githubGist": "GitHub Gist",
  "pluginsHome.subfacet.business-dashboards": "数据看板",
  "pluginsHome.subfacet.app-prototypes": "应用",
  "pluginsHome.subfacet.landing-marketing": "落地页 / 营销",
  "pluginsHome.subfacet.developer-tools": "开发者工具",
  "pluginsHome.subfacet.docs-reports": "文档 / 报告",
  "pluginsHome.subfacet.brand-design": "品牌 / 设计",
  "pluginsHome.subfacet.pitch-business": "路演 / 商务",
  "pluginsHome.subfacet.course-training": "课程 / 培训",
  "pluginsHome.subfacet.reports-briefings": "报告 / 简报",
  "pluginsHome.subfacet.product-sales": "产品 / 销售",
  "pluginsHome.subfacet.engineering-talks": "技术分享",
  "pluginsHome.subfacet.creative-decks": "创意幻灯片",
  "pluginsHome.subfacet.ui-product-mockups": "UI / 产品样机",
  "pluginsHome.subfacet.brand-visuals": "品牌 / Logo",
  "pluginsHome.subfacet.storyboards-motion-refs": "分镜",
  "pluginsHome.subfacet.social-content": "社交 / 内容",
  "pluginsHome.subfacet.avatar-portrait": "头像 / 人像",
  "pluginsHome.subfacet.illustration-style": "插画 / 风格",
  "pluginsHome.subfacet.motion-effects": "动效 / 特效",
  "pluginsHome.subfacet.social-short-form": "社交 / 短视频",
  "pluginsHome.subfacet.marketing-product": "营销 / 产品",
  "pluginsHome.subfacet.data-explainers": "数据 / 解说",
  "pluginsHome.subfacet.cinematic-story": "电影感 / 叙事",
  "pluginsHome.commercialCategory.student-coursework": "学生作业",
  "pluginsHome.commercialCategory.corporate-strategy": "企业战略",
  "pluginsHome.commercialCategory.professional-training": "职业培训",
  "pluginsHome.commercialCategory.b2b-sales": "B2B 销售",
  "pluginsHome.commercialCategory.academic-research": "学术研究",
  "pluginsHome.commercialCategory.marketing-gtm": "市场增长",
  "pluginsHome.commercialCategory.data-finance": "数据与财务",
  "pluginsHome.commercialCategory.fundraising-pitch": "融资路演",
  "pluginsHome.commercialCategory.government-policy": "政府与政策",
  "pluginsHome.commercialCategory.product-management": "产品管理",
  "pluginsHome.commercialCategory.consulting": "咨询顾问",
  "pluginsHome.commercialCategory.career": "职业发展",
  "pluginsHome.commercialCategory.ai-literacy": "AI 素养",
  "pluginsHome.commercialCategory.life": "生活故事",
  "pluginsHome.commercialCategory.design-craft": "设计打磨",
  "pluginsView.lede":
    "浏览已安装工作流，发现插件市场条目，管理来源，并为团队分发准备插件。",
  "pluginsView.importPlugin": "导入插件",
  "pluginsView.agentContext": "智能体上下文",
  "pluginsView.summaryAria": "插件概览",
  "pluginsView.areasAria": "插件区域",
  "pluginsView.loading": "正在加载插件…",
  "pluginsView.tab.installed": "已安装",
  "pluginsView.tab.available": "可用",
  "pluginsView.tab.sources": "来源",
  "pluginsView.tab.team": "团队",
  "pluginsView.tabHint.installed": "你的插件",
  "pluginsView.tabHint.available": "来自来源",
  "pluginsView.tabHint.sources": "目录",
  "pluginsView.tabHint.team": "企业",
  "pluginsView.installedTitle": "已安装插件",
  "pluginsView.installedSubtitle": "你导入或从插件市场来源安装的插件。",
  "pluginsView.installedEmpty":
    "还没有已安装的用户插件。可使用创建 / 导入，或安装一个可用条目。",
  "pluginsView.availableTitle": "来源中的可用插件",
  "pluginsView.availableSubtitle": "从已配置插件市场发现的目录条目。",
  "pluginsView.availableFiltersAria": "可用插件筛选",
  "pluginsView.searchAvailableAria": "搜索可用插件",
  "pluginsView.searchAvailablePlaceholder": "搜索可用插件",
  "pluginsView.clearAvailableSearch": "清除可用插件搜索",
  "pluginsView.source": "来源",
  "pluginsView.availableEmptyInstalled":
    "暂无可用条目。已安装的目录条目会从“可用”中移除；卸载后会再次出现。",
  "pluginsView.availableEmptyFiltered": "没有可用条目匹配当前筛选条件。",
  "pluginsView.availableEmptyNoSources":
    "暂无可用条目。请在“来源”标签页添加来源。",
  "pluginsView.installing": "正在安装…",
  "pluginsView.install": "安装",
  "pluginsView.sourcesTitle": "Registry 来源",
  "pluginsView.sourcesSubtitle": "为“可用插件”提供条目的插件市场目录。",
  "pluginsView.sourceUrl": "来源 URL",
  "pluginsView.defaultTrust": "默认信任级别",
  "pluginsView.trust.restricted": "受限",
  "pluginsView.trust.trusted": "可信",
  "pluginsView.trust.official": "官方",
  "pluginsView.adding": "正在添加…",
  "pluginsView.addSource": "添加来源",
  "pluginsView.sourcesEmpty": "还没有配置 registry 来源。",
  "pluginsView.pluginsCount": "{n} 个插件",
  "pluginsView.catalogVersion": "目录 v{version}",
  "pluginsView.trustFor": "{name} 的信任级别",
  "pluginsView.refreshing": "正在刷新…",
  "pluginsView.removing": "正在移除…",
  "pluginsView.teamTitle": "私有团队插件市场",
  "pluginsView.teamBody":
    "此区域预留给企业和团队目录、私有信任策略，以及共享插件生命周期控制。",
  "pluginCard.details": "详情",
  "pluginCard.use": "使用",
  "pluginCard.useWithQuery": "带查询使用",
  "pluginCard.applying": "正在应用…",
  "pluginCard.duplicate": "Remix",
  "pluginCard.duplicating": "正在 Remix…",
  "pluginCard.duplicateFailed": "无法 Remix 这个模板。",
  "pluginCard.saved": "已保存",
  "pluginCard.publish": "发布",
  "pluginCard.contribute": "贡献",
  "pluginCard.starting": "正在启动…",
  "pluginCard.detailsAria": "查看 {title} 的详情",
  "pluginCard.chooseUseAria": "选择 {title} 的使用方式",
  "pluginCard.useOptionsAria": "{title} 的使用选项",
  "pluginCard.duplicateAria": "将 {title} Remix 成新项目",
  "pluginCard.saveAria": "保存 {title}",
  "pluginCard.savedAria": "{title} 已保存",
  "pluginCard.shareAria": "分享 {title}",
  "pluginCard.publishAria": "将 {title} 发布为 GitHub 仓库",
  "pluginCard.publishTitle": "将插件发布为 GitHub 仓库",
  "pluginCard.contributeAria": "将 {title} 贡献到 Crie3",
  "pluginCard.contributeTitle": "通过 pull request 将插件贡献到 Crie3",
  "skillPluginCandidate.createForMe": "创建插件/模板",
  "skillPluginCandidate.contributeToMain": "贡献到 open-design",
  "skillPluginCandidate.repoDescription": "这个仓库看起来可以做成插件。",
  "integrations.kicker": "集成",
  "integrations.lede":
    "连接外部系统，把 MCP 工具带入智能体循环，并在其它 IDE、脚本和自动化中使用 Crie3。",
  "integrations.agentReady": "智能体就绪",
  "integrations.areasAria": "集成区域",
  "integrations.tabLabel.mcp": "MCP 服务器",
  "integrations.tabLabel.skills": "技能",
  "integrations.tabHint.mcp": "外部工具",
  "integrations.tabHint.connectors": "账号和 API",
  "integrations.tabHint.useEverywhere": "CLI、HTTP、MCP",
  "integrations.skillsTitle": "技能集成",
  "integrations.skillsBody":
    "技能级集成管理正在从另一个分支迁移过来。此标签页预留给 MCP、连接器和未来技能设置，使它们位于同一个集成路由中。",
  "mcpClient.title": "外部 MCP 服务器",
  "mcpClient.subtitle": "供编码智能体使用的第三方工具。",
  "mcpClient.addServer": "添加服务器",
  "mcpClient.emptyTitle": "尚未配置 MCP 服务器。",
  "mcpClient.emptyBody":
    "点击“添加服务器”开始 — 选择模板（Higgsfield OpenClaw、Pollinations、Allyson、Imagician、EdgeOne Pages、GitHub、Filesystem…），或配置自定义 stdio / HTTP 服务器。",
  "mcpClient.saveChanges": "保存更改",
  "mcpClient.storedAt": "存储于",
  "mcpClient.daemonError":
    "无法连接本地 daemon。请确认 Crie3 正在运行，然后重新打开此面板。",
  "mcpClient.saveFailed": "保存失败。请检查 daemon 是否正在运行后重试。",
  "useEverywhere.modalAria": "随处使用 Crie3",
  "useEverywhere.modalTitle": "随处使用 Crie3",
  "useEverywhere.modalSubtitle":
    "把 Crie3 接入任何 IDE、智能体或脚本：CLI、HTTP、MCP 和 Skills。使用“复制智能体指南”，粘贴到 Claude Code、Codex、Cursor、openclaw 或 hermes 中即可完成配置。",
  "useEverywhere.closeAria": "关闭随处使用",
  "useEverywhere.closeTitle": "关闭 (Esc)",
  "useEverywhere.tabsAria": "集成入口",
  "useEverywhere.footStrong": "一键交接。",
  "useEverywhere.footBody":
    "复制一份结构化 Markdown 指南，智能体可以立即按步骤安装、验证并使用。",
  "useEverywhere.configureMcp": "配置 MCP 服务器",
  "useEverywhere.copyGuide": "复制智能体指南",
  "useEverywhere.copy": "复制",
  "useEverywhere.copied": "已复制",
  "useEverywhere.copyFailed": "复制失败",
  "useEverywhere.copySnippetAria": "复制代码片段：{label}",
  "useEverywhere.section.overview.tab": "概览",
  "useEverywhere.section.overview.heading":
    "Crie3 可在智能体工作的任何地方运行",
  "useEverywhere.section.overview.intro":
    "Crie3 不只是一个窗口；它包含本地特权 daemon（`od`），以及 Skills + Design Systems + Atoms registry。它在你的机器上运行后，任何代码智能体（Claude Code、Codex、Cursor、OpenCode/openclaw、Hermes 或你自己的脚本）都可以通过四种可互换入口驱动生成、检查项目并产出设计制品。",
  "useEverywhere.section.overview.bullet1":
    "CLI — 使用 `od <command>` 支持无头脚本、CI 和 shell 自动化。",
  "useEverywhere.section.overview.bullet2":
    "MCP 服务器 — 将 Crie3 作为 Model Context Protocol 服务器接入，使任何支持 MCP 的智能体都能列出技能、运行场景并读取制品。",
  "useEverywhere.section.overview.bullet3":
    "HTTP API — `http://127.0.0.1:7456/api/*` REST + SSE 端点；与 Web UI 使用同一套接口。",
  "useEverywhere.section.overview.bullet4":
    "Skills — 可直接放入的 `SKILL.md` 包（兼容 Claude），任何已在 PATH 中的智能体都能调用，甚至不需要打开 Crie3。",
  "useEverywhere.section.overview.bullet5":
    "标准制品 — 在 daemon 启动前，从 Skills、内置默认插件和社区插件示例中种子生成真实 HTML 项目。",
  "useEverywhere.section.overview.snippet1": "本地启动 daemon（和 Web UI）",
  "useEverywhere.section.overview.snippet2": "确认服务可访问",
  "useEverywhere.section.overview.snippet3": "启动前导入标准制品",
  "useEverywhere.section.overview.footer":
    "daemon 默认写入项目本地的 `./.od/`。设置 `OD_DATA_DIR=~/.open-design` 可在多个项目间共享数据。",
  "useEverywhere.section.cli.tab": "CLI · od",
  "useEverywhere.section.cli.heading": "从任意 shell 驱动 Crie3",
  "useEverywhere.section.cli.intro":
    "`od` 命令随 daemon 一起发布，也是 Claude Code / Codex 运行生成时使用的同一个二进制。多数子命令都是向本地 daemon 发送 POST 的轻量客户端，因此无论你通过 `pnpm tools-dev` 启动，还是通过打包应用启动，行为都一致。",
  "useEverywhere.section.cli.bullet1":
    "`od`（无参数）— 启动 daemon 并打开 Web UI。",
  "useEverywhere.section.cli.bullet2":
    "`od media generate ...` — 通过统一媒体协议生成图片 / 视频 / 音频字节。",
  "useEverywhere.section.cli.bullet3":
    "`od run ...` — 从 prompt + skill 启动一次项目运行。",
  "useEverywhere.section.cli.bullet4":
    "`od plugin install <source>` / `od plugin apply <id>` — 安装并应用社区插件。",
  "useEverywhere.section.cli.bullet5":
    "`od skills list` / `od design-systems list` — 查看本地可用内容。",
  "useEverywhere.section.cli.bullet6":
    "`od status` / `od doctor` — 验证 daemon 健康状态并检测 PATH 中的智能体 CLI。",
  "useEverywhere.section.cli.snippet1": "生成图片（委托给已配置的媒体提供方）",
  "useEverywhere.section.cli.snippet2":
    "无头运行场景插件，并以 JSON Lines 流式输出事件",
  "useEverywhere.section.cli.snippet3":
    "清点本地可用的 skills 和 design systems",
  "useEverywhere.section.cli.snippet4": "通过 CLI 检查种子制品",
  "useEverywhere.section.cli.snippet5":
    "验证环境和已检测到的智能体（Claude、Codex、Cursor 等）",
  "useEverywhere.section.cli.footer":
    "所有子命令都支持 `--daemon-url http://127.0.0.1:<port>`，用于指定某个运行中的 daemon；在测试中运行第二个隔离实例时很有用。",
  "useEverywhere.section.mcp.tab": "MCP 服务器",
  "useEverywhere.section.mcp.heading":
    "把 Crie3 暴露为任意代码智能体可用的 MCP 服务器",
  "useEverywhere.section.mcp.intro":
    "Crie3 内置 Model Context Protocol 服务器（`od mcp`），让任何支持 MCP 的客户端（Cursor、Claude Code、Antigravity、VS Code Copilot Chat、openclaw、hermes）都能发现 Crie3 工具（列出技能、渲染预览、生成媒体、运行插件），无需手动 shell 调用。daemon 会通过 `GET /api/mcp/install-info` 为主流客户端发布可直接粘贴的安装片段。",
  "useEverywhere.section.mcp.bullet1":
    "Stdio 传输 — 无需额外端口，客户端直接启动 `od mcp`。",
  "useEverywhere.section.mcp.bullet2":
    "作为 sidecar 启动时，会通过本地 IPC 状态 socket 自动发现实时 daemon URL。",
  "useEverywhere.section.mcp.bullet3":
    "普通安装会回退到 `--daemon-url http://127.0.0.1:<port>`，确保 MCP 进程总能找到运行中的 daemon。",
  "useEverywhere.section.mcp.bullet4":
    "固定 `OD_DATA_DIR`，让派生的 MCP 进程写入 daemon 已使用的位置，避免打包 macOS app bundle 中的 EPERM 问题。",
  "useEverywhere.section.mcp.snippet1":
    "通用 MCP 客户端配置（适用于 Cursor、Claude Code、Codex 等）",
  "useEverywhere.section.mcp.snippet2":
    "或者：让 daemon 返回与你安装方式匹配的片段",
  "useEverywhere.section.mcp.snippet3": "实时看板 MCP 变体（读取并刷新仪表盘）",
  "useEverywhere.section.mcp.footer":
    "在 Crie3 应用中，打开“设置 → 集成”即可复制特定客户端的安装命令（Cursor、Claude Code、Antigravity、VS Code），无需手写 JSON。",
  "useEverywhere.section.http.tab": "HTTP API",
  "useEverywhere.section.http.heading": "与 Web UI 相同的 REST + SSE 接口",
  "useEverywhere.section.http.intro":
    "本地 daemon 在 `http://127.0.0.1:7456` 提供 HTTP API（端口可配置）。Web UI 调用的每个端点也都可以供你的脚本使用。流式端点（聊天回合、项目运行）会发出 Server-Sent Events，事件类型定义在 `@open-design/contracts` 中。",
  "useEverywhere.section.http.bullet1": "`GET /api/health` — daemon 存活检查。",
  "useEverywhere.section.http.bullet2":
    "`GET /api/skills` 和 `GET /api/design-systems` — 可用 registry。",
  "useEverywhere.section.http.bullet3":
    "`GET /api/projects` 和 `POST /api/projects` — 列出和创建项目（POST 返回项目和首个会话）。",
  "useEverywhere.section.http.bullet4":
    "`GET /api/projects/:id/chat` — 某个会话的智能体事件 SSE 流。",
  "useEverywhere.section.http.bullet5":
    "`POST /api/plugins/:id/apply` — 绑定已安装插件，并获得其渲染后的示例查询和输入。",
  "useEverywhere.section.http.bullet6":
    "`GET /api/agents` — 检测 PATH 中的代码智能体 CLI。",
  "useEverywhere.section.http.snippet1":
    "列出已安装的 skills（智能体会把它们作为模板使用）",
  "useEverywhere.section.http.snippet2": "从 prompt 创建项目（完整服务端流程）",
  "useEverywhere.section.http.snippet3":
    "流式读取聊天回合（SSE，每行兼容 JSON Lines）",
  "useEverywhere.section.http.footer":
    "每个请求 / 响应的纯 TypeScript 类型都在 `@open-design/contracts` 中；脚本中导入即可获得完整自动补全，无需接入生成器。",
  "useEverywhere.section.skills.tab": "Skills 和无头模式",
  "useEverywhere.section.skills.heading":
    "任意智能体可直接使用的 Skills，即使 Crie3 未运行",
  "useEverywhere.section.skills.intro":
    "Skill 是一个包含 Claude 兼容 `SKILL.md`（YAML front matter + 正文）的目录。Crie3 通过 `od:` 命名空间（`mode`、`preview`、`design_system`、`inputs` 等）扩展该格式，使同一个制品既能在 Crie3 内使用，也能被 Claude Code、Codex、openclaw 或 hermes 这类普通智能体使用。发现逻辑遵循优先级链，因此项目可以覆盖自己的 skills。",
  "useEverywhere.section.skills.bullet1":
    "发现顺序：`./.claude/skills/` → `./skills/` → `~/.claude/skills/`（项目优先）。",
  "useEverywhere.section.skills.bullet2":
    "把同一个 skill 符号链接到多个项目，无需复制即可共享。",
  "useEverywhere.section.skills.bullet3":
    "每个 skill 都可以声明 connectors、atoms、design-system 要求，以及用于 gallery 的 `preview` 示例输出。",
  "useEverywhere.section.skills.bullet4":
    "无头模式：PATH 中有 `od` 的智能体可以调用 `od skills list` 后运行任意 skill；只读流程不强制需要 daemon。",
  "useEverywhere.section.skills.bullet5":
    "`pnpm seed:test-projects` 会用默认插件示例和社区插件示例演练同一制品形态，并把生成的 `index.html` 项目保存为可复用测试数据。",
  "useEverywhere.section.skills.snippet1":
    "最小 SKILL.md（Claude 兼容 front matter + Crie3 扩展）",
  "useEverywhere.section.skills.snippet2":
    "把共享 skill 符号链接到项目中（cc-switch 风格）",
  "useEverywhere.section.skills.snippet3":
    "无头模式：列出 daemon 当前看到的 skills",
  "useEverywhere.section.skills.snippet4": "无头制品夹具包",
  "useEverywhere.section.skills.footer":
    "规范：`docs/skills-protocol.md` 和 `docs/agent-adapters.md` 覆盖完整适配器表面（Claude Code、Codex、Cursor、MCP-capable agents、BYOK API fallback）以及每种适配器的 skill 注入策略。",
  "tasks.kicker": "自动化工作区",
  "tasks.comingSoon": "即将上线",
  "tasks.lede":
    "自动化会把 Prompt 变成可持续运行的工作：Orbit 负责执行，例程负责保留，计划决定触发时间，实时看板展示变化。",
  "tasks.newAutomation": "新建自动化",
  "tasks.previewNote":
    "当前仅为预览界面。Orbit 设置已可用；例程、计划和实时看板接线会随后端分支合并后上线。",
  "tasks.primitivesAria": "自动化基础能力",
  "tasks.primitive.orbit.title": "Orbit",
  "tasks.primitive.orbit.body": "用于长期或周期性智能体工作的持久运行时。",
  "tasks.primitive.orbit.enabled": "每日摘要已启用",
  "tasks.primitive.orbit.manualOnly": "仅手动",
  "tasks.primitive.routines.title": "例程",
  "tasks.primitive.routines.body": "单次聊天结束后仍能保留的持久任务定义。",
  "tasks.primitive.routines.meta": "产品外壳已就绪",
  "tasks.primitive.schedules.title": "计划",
  "tasks.primitive.schedules.body": "按时间或事件触发，决定例程何时运行。",
  "tasks.primitive.schedules.meta": "分支待合并",
  "tasks.primitive.liveArtifacts.title": "实时看板",
  "tasks.primitive.liveArtifacts.body": "智能体工作时持续更新的报告和笔记。",
  "tasks.primitive.liveArtifacts.meta": "预览模型",
  "tasks.listAria": "自动化列表",
  "tasks.routinesAndRuns": "{n} 个例程和运行",
  "tasks.filtersAria": "自动化筛选",
  "tasks.filter.scheduled": "已计划",
  "tasks.filter.running": "运行中",
  "tasks.filter.done": "已完成",
  "tasks.configurationAria": "自动化配置",
  "tasks.slot.trigger": "触发器",
  "tasks.slot.pattern": "模式",
  "tasks.slot.runtime": "运行时",
  "tasks.slot.output": "输出",
  "tasks.liveArtifact": "实时看板",
  "tasks.viewProgress": "查看进度",
  "tasks.pause": "暂停",
  "tasks.runNow": "立即运行",
  "tasks.openArtifact": "打开制品",
  "tasks.status.dailyAt": "每日 · {time}",
  "tasks.status.pausedManual": "已暂停 · 仅手动",
  "tasks.sample.orbit.title": "Orbit 每日连接器摘要",
  "tasks.sample.orbit.metaEnabled": "连接器摘要已计划运行",
  "tasks.sample.orbit.metaDisabled": "打开 Orbit 设置以启用",
  "tasks.sample.orbit.previewEnabled": "orbit_daily.html · 实时看板",
  "tasks.sample.orbit.previewDisabled": "尚未计划运行",
  "tasks.sample.orbit.triggerEnabled": "计划 · 每日 {time}",
  "tasks.sample.orbit.triggerDisabled": "手动 · 按需运行",
  "tasks.sample.orbit.pattern": "例程 · 连接器摘要",
  "tasks.sample.orbit.runtime": "Orbit · daemon 计划任务",
  "tasks.sample.orbit.output": "实时看板 · 可刷新报告",
  "tasks.sample.orbit.artifactMetaEnabled": "每次运行后刷新",
  "tasks.sample.orbit.artifactMetaDisabled": "等待计划",
  "tasks.sample.orbit.body1": "# Orbit 每日活动摘要",
  "tasks.sample.orbit.body2": "已检查连接器 · 成功、跳过和失败",
  "tasks.sample.orbit.body3": "重点内容会变成可刷新的实时看板。",
  "tasks.sample.mcp.title": "MCP 替代方案研究",
  "tasks.sample.mcp.status": "正在 Orbit 中运行 · 2 小时 14 分",
  "tasks.sample.mcp.meta": "已处理 14 / 30 个来源",
  "tasks.sample.mcp.preview": "research_notes.md · 实时",
  "tasks.sample.mcp.trigger": "手动 · 一次性",
  "tasks.sample.mcp.pattern": "深度研究 Prompt",
  "tasks.sample.mcp.runtime": "远程 · 持久",
  "tasks.sample.mcp.output": "实时报告 · 自动更新",
  "tasks.sample.mcp.artifactMeta": "12 秒前更新",
  "tasks.sample.mcp.body1": "# MCP 替代方案 - 阶段性发现",
  "tasks.sample.mcp.body2": "已审阅 14 个来源 · 入围 3 个候选",
  "tasks.sample.mcp.body3": "## 入围清单",
  "tasks.sample.mcp.body4": "- 基于 JSON-RPC 的工具调用 schema...",
  "tasks.sample.mcp.body5": "- 基于 gRPC 的智能体协议...",
  "tasks.sample.weekly.title": "团队周报摘要",
  "tasks.sample.weekly.status": "下次：周一 9:00 AM",
  "tasks.sample.weekly.meta": "更新团队周报文档",
  "tasks.sample.weekly.preview": "team_weekly.md · 下一个制品",
  "tasks.sample.weekly.trigger": "计划 · 每周",
  "tasks.sample.weekly.pattern": "例程 · 团队摘要",
  "tasks.sample.weekly.runtime": "远程 · 周期性",
  "tasks.sample.weekly.output": "实时看板 · Markdown",
  "tasks.sample.weekly.artifactMeta": "4 天前更新",
  "tasks.sample.weekly.body1": "# 团队周报",
  "tasks.sample.weekly.body2": "## 进行中",
  "tasks.sample.weekly.body3": "- 设计体系集成梳理",
  "tasks.sample.weekly.body4": "- 连接器质量清理",
  "tasks.sample.weekly.body5": "## 风险",
  "tasks.sample.pr.title": "PR 评审提醒",
  "tasks.sample.pr.status": "新 PR 触发 · 23 分钟前已发送",
  "tasks.sample.pr.meta": "发送 Slack 私信",
  "tasks.sample.pr.preview": "上次发送成功",
  "tasks.sample.pr.trigger": "事件 · 新 PR",
  "tasks.sample.pr.pattern": "例程 · 通知",
  "tasks.sample.pr.runtime": "本地 · 快速运行",
  "tasks.sample.pr.output": "消息 · Slack 私信",
  "tasks.sample.pr.artifactMeta": "23 分钟前触发",
  "tasks.sample.pr.body1": "已打开 PR #184 等待评审",
  "tasks.sample.pr.body2": "匹配评审者：design-platform、web-runtime",
  "tasks.sample.pr.body3": "发送结果：Slack 私信已发送",
  "tasks.sample.meeting.title": "会前准备",
  "tasks.sample.meeting.status": "明天 · 10:00 AM",
  "tasks.sample.meeting.meta": "一次性 · 发送摘要",
  "tasks.sample.meeting.preview": "meeting_brief.md · 已排队",
  "tasks.sample.meeting.trigger": "计划 · 一次性",
  "tasks.sample.meeting.pattern": "简报 Prompt",
  "tasks.sample.meeting.runtime": "远程 · 有边界",
  "tasks.sample.meeting.output": "制品 + 消息",
  "tasks.sample.meeting.artifactMeta": "已排队等待生成",
  "tasks.sample.meeting.body1": "# 会议简报",
  "tasks.sample.meeting.body2": "议程来源：日历事件 + 关联文档",
  "tasks.sample.meeting.body3": "输出将包含决策、阻塞点和问题。",
  "tasks.sample.candidate.title": "候选人跟踪",
  "tasks.sample.candidate.status": "失败 · 需要处理",
  "tasks.sample.candidate.meta": "授权已过期",
  "tasks.sample.candidate.preview": "重新连接 Greenhouse 以继续",
  "tasks.sample.candidate.trigger": "计划 · 每日",
  "tasks.sample.candidate.pattern": "例程 · 申请人同步",
  "tasks.sample.candidate.runtime": "远程 · 周期性",
  "tasks.sample.candidate.output": "实时看板 · 表格",
  "tasks.sample.candidate.artifactMeta": "授权恢复前已暂停",
  "tasks.sample.candidate.body1": "# 候选人管道",
  "tasks.sample.candidate.body2": "上次成功同步：2 天前",
  "tasks.sample.candidate.body3": "需要操作：重新连接来源账号。",
  "routines.title": "自动化",
  "routines.subtitle": "无需值守、按计划运行的自动化任务。",
  "routines.newAutomation": "新建自动化",
  "routines.loading": "加载中…",
  "routines.empty": "还没有自动化任务。",
  "routines.emptyHint": "点击“新建自动化”即可安排一次无人值守的智能体运行。",
  "routines.runHistoryLoading": "正在加载运行记录…",
  "routines.runHistoryEmpty": "还没有运行记录。",
  "routines.fieldName": "名称",
  "routines.fieldNamePlaceholder": "晨间简报",
  "routines.fieldPrompt": "提示词",
  "routines.fieldPromptPlaceholder":
    "拉取昨天的 GitHub 与 Linear 活动并总结有哪些变化。",
  "routines.fieldSchedule": "计划",
  "routines.fieldMinute": "每小时的第几分钟",
  "routines.fieldTime": "时间",
  "routines.fieldTimezone": "时区",
  "routines.fieldsetProject": "项目",
  "routines.kind.hourly": "每小时",
  "routines.kind.daily": "每天",
  "routines.kind.weekdays": "工作日",
  "routines.kind.weekly": "每周",
  "routines.weekday.short.0": "周日",
  "routines.weekday.short.1": "周一",
  "routines.weekday.short.2": "周二",
  "routines.weekday.short.3": "周三",
  "routines.weekday.short.4": "周四",
  "routines.weekday.short.5": "周五",
  "routines.weekday.short.6": "周六",
  "routines.weekday.long.0": "周日",
  "routines.weekday.long.1": "周一",
  "routines.weekday.long.2": "周二",
  "routines.weekday.long.3": "周三",
  "routines.weekday.long.4": "周四",
  "routines.weekday.long.5": "周五",
  "routines.weekday.long.6": "周六",
  "routines.timeAm": "上午",
  "routines.timePm": "下午",
  "routines.describe.hourly": "每小时的第 {minute} 分运行",
  "routines.describe.daily": "每天 {time}（{tz}）运行",
  "routines.describe.weekdays": "周一至周五 {time}（{tz}）运行",
  "routines.describe.weekly": "每{day} {time}（{tz}）运行",
  "routines.modeCreate": "每次运行新建项目",
  "routines.modeCreateHint": "每次触发都使用一个全新且隔离的工作区。",
  "routines.modeReuse": "复用现有项目",
  "routines.modeReuseHint": "每次运行作为该项目中的一次新对话。",
  "routines.pickProject": "— 选择一个项目 —",
  "routines.targetReuse": "→ {project}",
  "routines.targetCreate": "→ 每次运行新建项目",
  "routines.tagPaused": "已暂停",
  "routines.metaNext": "下次：{when}",
  "routines.metaLast": "上次：",
  "routines.triggerManual": "手动",
  "routines.triggerScheduled": "计划",
  "routines.openProject": "打开项目",
  "routines.openProjectTitle": "打开本次运行写入的项目",
  "routines.runNow": "立即运行",
  "routines.edit": "编辑",
  "routines.pause": "暂停",
  "routines.resume": "恢复",
  "routines.history": "历史记录",
  "routines.hideHistory": "隐藏历史记录",
  "routines.delete": "删除",
  "routines.deleteTitle": "删除此自动化",
  "routines.cancel": "取消",
  "routines.save": "保存",
  "routines.saving": "保存中…",
  "routines.create": "创建",
  "routines.creating": "创建中…",
  "routines.status.queued": "排队中",
  "routines.status.running": "运行中",
  "routines.status.succeeded": "成功",
  "routines.status.failed": "失败",
  "routines.status.canceled": "已取消",
  "routines.confirmDelete": "删除此自动化？过往运行记录及其项目将予以保留。",
  "routines.errorPickProject":
    "请选择要复用的项目，或切换为“每次运行新建项目”。",
  "routines.errorAgentEmptyOutput":
    "代理已完成运行但未产生任何输出。模型或提供商可能返回了空响应，请检查代理日志中的上游错误。",
  "entry.helpAria": "帮助",
  "entry.helpMenuAria": "帮助菜单",
  "entry.helpGetHelp": "在 GitHub 上获取帮助",
  "entry.helpSubmitFeature": "提交功能建议",
  "entry.helpWhatsNew": "最新动态",
  "entry.helpDownloadDesktop": "下载桌面端",
  "entry.githubStarLabel": "Star",
  "entry.githubStarTitle": "为我们在 GitHub 点亮 Star",
  "entry.githubStarAria": "在 GitHub 上为 Crie3 点亮 Star",
  "entry.tabImageTemplates": "图片模板",
  "entry.tabVideoTemplates": "视频模板",
  "promptTemplates.searchPlaceholder": "搜索模板…",
  "promptTemplates.countLabel": "{n} 个结果",
  "promptTemplates.emptyImage": "还没有安装图片 Prompt 模板。",
  "promptTemplates.emptyVideo": "还没有安装视频 Prompt 模板。",
  "promptTemplates.emptyNoMatch": "没有匹配的模板。",
  "promptTemplates.attributionFooter":
    "改编自公开 Prompt 库，每张卡片都链接到原作者。",
  "promptTemplates.openPreviewTitle": "打开 Prompt 与预览",
  "promptTemplates.sourcePrefix": "来源：",
  "promptTemplates.fetchError": "无法加载此模板正文。",
  "promptTemplates.promptLabel": "Prompt 正文",
  "promptTemplates.copyPrompt": "复制 Prompt",
  "promptTemplates.copyDone": "已复制！",
  "promptTemplates.modelHint": "建议模型：{model}",
  "promptTemplates.openSource": "查看原始来源",
  "promptTemplates.openFullscreen": "打开全屏预览",
  "promptTemplates.closeFullscreen": "关闭全屏预览",
  "promptTemplates.allSources": "所有来源",
  "promptTemplates.sourceFilterAria": "按来源筛选",
  "promptTemplates.retry": "重试",
  "connectors.title": "连接器",
  "connectors.subtitle": "可为实时看板提供数据的本地和未来数据源。",
  "connectors.account": "账号",
  "connectors.noAccount": "未连接",
  "connectors.tools": "工具",
  "connectors.connect": "连接",
  "connectors.disconnect": "断开连接",
  "connectors.authorizationPending": "等待授权中...",
  "connectors.authorizationPendingHint": "请在已打开的窗口中完成授权。",
  "connectors.cancelAuthorization": "取消",
  "connectors.configure": "配置",
  "connectors.unavailable": "不可用",
  "connectors.phaseStubTitle": "连接器 API 将在 Phase 3 提供；这里是预览入口。",
  "connectors.statusAvailable": "可用",
  "connectors.statusConnected": "已连接",
  "connectors.statusError": "错误",
  "connectors.statusDisabled": "已停用",
  "connectors.gateTitle": "添加 Composio API 密钥以继续",
  "connectors.gateBody": "在上方粘贴密钥并点击“保存密钥”，即可加载可用集成。",
  "connectors.aboutLabel": "简介",
  "connectors.detailsLabel": "详情",
  "connectors.statusLabel": "状态",
  "connectors.category.aiAgents": "AI 代理",
  "connectors.category.aiInfrastructure": "AI 基础设施",
  "connectors.category.accounting": "会计",
  "connectors.category.admin": "管理",
  "connectors.category.advertising": "广告",
  "connectors.category.analytics": "分析",
  "connectors.category.automation": "自动化",
  "connectors.category.cms": "CMS",
  "connectors.category.crm": "CRM",
  "connectors.category.calendar": "日历",
  "connectors.category.commerce": "电商",
  "connectors.category.communication": "沟通",
  "connectors.category.contacts": "联系人",
  "connectors.category.dataPlatform": "数据平台",
  "connectors.category.database": "数据库",
  "connectors.category.design": "设计",
  "connectors.category.developer": "开发者工具",
  "connectors.category.documentation": "文档",
  "connectors.category.erp": "ERP",
  "connectors.category.education": "教育",
  "connectors.category.email": "邮件",
  "connectors.category.events": "活动",
  "connectors.category.fieldService": "现场服务",
  "connectors.category.finance": "财务",
  "connectors.category.fitness": "健身",
  "connectors.category.forms": "表单",
  "connectors.category.gaming": "游戏",
  "connectors.category.hr": "人力资源",
  "connectors.category.hospitality": "酒店与款待",
  "connectors.category.itsm": "ITSM",
  "connectors.category.integration": "集成",
  "connectors.category.localization": "本地化",
  "connectors.category.logistics": "物流",
  "connectors.category.maps": "地图",
  "connectors.category.marketing": "营销",
  "connectors.category.media": "媒体",
  "connectors.category.meetings": "会议",
  "connectors.category.nonprofit": "非营利",
  "connectors.category.observability": "可观测性",
  "connectors.category.payments": "支付",
  "connectors.category.personal": "个人",
  "connectors.category.presentations": "演示文稿",
  "connectors.category.procurement": "采购",
  "connectors.category.product": "产品",
  "connectors.category.productivity": "生产力",
  "connectors.category.projectManagement": "项目管理",
  "connectors.category.recruiting": "招聘",
  "connectors.category.research": "研究",
  "connectors.category.salesIntelligence": "销售情报",
  "connectors.category.scheduling": "日程安排",
  "connectors.category.search": "搜索",
  "connectors.category.security": "安全",
  "connectors.category.signing": "签署",
  "connectors.category.social": "社交",
  "connectors.category.spreadsheets": "电子表格",
  "connectors.category.storage": "存储",
  "connectors.category.support": "支持",
  "connectors.category.surveys": "问卷",
  "connectors.category.tasks": "任务",
  "connectors.category.timeTracking": "时间追踪",
  "connectors.category.video": "视频",
  "connectors.category.whiteboard": "白板",
  "connectors.categoryLabel": "类别",
  "connectors.providerLabel": "提供方",
  "connectors.toolsSection": "工具",
  "connectors.toolsLoading": "正在加载工具…",
  "connectors.noToolsAvailable":
    "暂无可用工具，连接后即可发现此集成提供的能力。",
  "connectors.toolDetailsUnavailable":
    "无法获取工具详情,但此连接器报告了 {n} 个工具。",
  "connectors.loadMoreTools": "加载更多工具",
  "connectors.openDetailsAria": "查看 {name} 详情",
  "connectors.toolsBadgeNone": "暂无工具",
  "connectors.toolsBadgeOne": "{n} 个工具",
  "connectors.toolsBadgeMany": "{n} 个工具",
  "connectors.searchPlaceholder": "搜索连接器…",
  "connectors.searchAriaLabel": "按名称、提供方或工具搜索连接器",
  "connectors.searchClear": "清除搜索",
  "connectors.emptyNoMatchTitle": "没有匹配“{query}”的连接器",
  "connectors.emptyNoMatchBody": "换个关键词试试，或清除搜索以浏览完整目录。",
  "connectors.emptyNoMatchAction": "清除搜索",
  "newproj.tabPrototype": "原型",
  "newproj.tabLiveArtifact": "实时看板",
  "newproj.tabDeck": "幻灯片",
  "newproj.tabTemplate": "从模板",
  "newproj.tabMedia": "媒体",
  "newproj.tabOther": "其它",
  "newproj.tabPost": "帖子",
  "newproj.titlePrototype": "新建原型",
  "newproj.clientLabel": "客户",
  "newproj.titleLiveArtifact": "新建实时看板",
  "newproj.titleDeck": "新建幻灯片",
  "newproj.titleTemplate": "从模板开始",
  "newproj.titleImage": "新建图片",
  "newproj.titleVideo": "新建视频",
  "newproj.titleAudio": "新建音频",
  "newproj.titleMedia": "新建媒体",
  "newproj.titleOther": "新建项目",
  "newproj.titlePost": "新建帖子",
  "newproj.namePlaceholder": "项目名称",
  "newproj.fidelityLabel": "精度",
  "newproj.fidelityWireframe": "线框图",
  "newproj.fidelityHigh": "高保真",
  "newproj.toggleSpeakerNotes": "使用演讲备注",
  "newproj.toggleSpeakerNotesHint": "减少幻灯片上的文字，要点放到备注中。",
  "newproj.toggleAnimations": "加入动效",
  "newproj.toggleAnimationsHint": "在模板基础上叠加动效（入场、悬停、过渡）。",
  "newproj.targetPlatformsLabel": "目标平台",
  "newproj.targetPlatformsHint":
    "可多选。响应式 Web 仅覆盖浏览器断点；如需原生跨平台版本，请加入 iOS、Android、平板应用或桌面应用。",
  "newproj.platform.responsive.label": "响应式 Web",
  "newproj.platform.responsive.hint":
    "一套 Web 体验，适配桌面、平板和移动浏览器",
  "newproj.platform.webDesktop.label": "桌面 Web",
  "newproj.platform.webDesktop.hint": "浏览器优先的产品或落地页",
  "newproj.platform.mobileIos.label": "iOS 应用",
  "newproj.platform.mobileIos.hint": "iPhone 画框与 iOS 交互规范",
  "newproj.platform.mobileAndroid.label": "Android 应用",
  "newproj.platform.mobileAndroid.hint": "Pixel 画框与 Material 交互规范",
  "newproj.platform.tablet.label": "平板应用",
  "newproj.platform.tablet.hint": "原生风格的平板体验，支持分屏视图",
  "newproj.platform.desktopApp.label": "桌面应用",
  "newproj.platform.desktopApp.hint": "macOS/Windows 应用外观",
  "newproj.surfaceOptionsLabel": "配套界面",
  "newproj.includeLandingPage": "包含落地页",
  "newproj.includeLandingPageHint":
    "为广告、候补名单、发布活动、应用下载或产品说明添加一个响应式营销页面。",
  "newproj.includeOsWidgets": "包含系统小部件",
  "newproj.includeOsWidgetsHint":
    "为移动/平板应用添加平台原生的主屏幕、锁屏或快捷小部件。",
  "newproj.includeOsWidgetsDisabledHint":
    "选择 iOS、Android 或平板应用作为目标平台时可用。",
  "newproj.templateLabel": "模板",
  "newproj.noTemplatesTitle": "还没有模板",
  "newproj.noTemplatesBody":
    "打开任意项目，在文件查看器内的「分享」菜单将其保存为模板，模板将出现在这里。",
  "newproj.savedTemplate": "已保存的模板",
  "newproj.fileSingular": "个文件",
  "newproj.filePlural": "个文件",
  "newproj.create": "创建",
  "newproj.locationLabel": "保存到",
  "newproj.locationDefault": "Crie3 项目",
  "newproj.locationExternalBase": "外部基目录",
  "newproj.createLiveArtifact": "创建实时看板",
  "newproj.createFromTemplate": "基于模板创建",
  "newproj.createDisabledTitle":
    "请先在任意项目内通过「分享」菜单将其保存为模板。",
  "newproj.importClaudeZip": "导入 Claude Design ZIP",
  "newproj.importClaudeZipTitle": "导入 Claude Design 导出的 .zip 文件",
  "newproj.importingClaudeZip": "正在导入…",
  "newproj.openFolder": "打开文件夹",
  "newproj.openingFolder": "正在打开…",
  "newproj.importFailed": "导入失败",
  "newproj.importFailedWithReason": "导入失败：{reason}",
  "newproj.folderPickerUnavailable": "无法打开文件夹选择器。请更新 Crie3 后重试。",
  "newproj.privacyFooter": "默认情况下只有你能看到自己的项目。",
  "newproj.designSystem": "设计体系",
  "newproj.dsNoneFreeform": "不指定 — 自由发挥",
  "newproj.dsNoneSubtitleEmpty": "不使用体系 token，由你决定整体配色",
  "newproj.dsNoneSubtitleSelected": "跳过体系 token，由代理自行选择配色。",
  "newproj.dsCategoryFallback": "设计体系",
  "newproj.dsSearch": "搜索设计体系…",
  "newproj.dsModeAria": "选择模式",
  "newproj.dsModeSingle": "单选",
  "newproj.dsModeMulti": "多选",
  "newproj.dsNoneTitle": "不指定 — 自由发挥",
  "newproj.dsNoneSub": "跳过体系 token，由代理自行选择配色。",
  "newproj.dsEmpty": "没有匹配「{query}」的设计体系。",
  "newproj.dsFootSingular": "只作为灵感参考。",
  "newproj.dsFootPlural": "只作为灵感参考。",
  "newproj.dsFootClear": "清除",
  "newproj.dsBadgeDefault": "默认",
  "newproj.dsPrimaryFallback": "主体系",
  "newproj.surfaceImage": "图片",
  "newproj.surfaceVideo": "视频",
  "newproj.surfaceAudio": "音频",
  "newproj.modelLabel": "模型",
  "newproj.modelSearch": "搜索模型…",
  "newproj.modelEmpty": "没有匹配的模型。",
  "newproj.modelRecommended": "推荐",
  "newproj.modelMissingTitle": "选择模型",
  "newproj.modelMissingSub": "为此场景选一个模型。",
  "newproj.aspectLabel": "比例",
  "newproj.videoLengthLabel": "时长",
  "newproj.videoLengthSeconds": "{n} 秒",
  "newproj.audioKindLabel": "音频类型",
  "newproj.audioKindMusic": "音乐",
  "newproj.audioKindSpeech": "配音 / TTS",
  "newproj.audioKindSfx": "音效",
  "newproj.audioDurationLabel": "时长",
  "newproj.audioDurationSeconds": "{n} 秒",
  "newproj.voiceLabel": "声音",
  "newproj.voicePlaceholder": "提供商 voice id，可选",
  "newproj.connectorsLabel": "连接器",
  "newproj.connectorsHint": "实时看板可以从这些数据源拉取信息。",
  "newproj.connectorsEmptyTitle": "尚未配置连接器",
  "newproj.connectorsEmptyBody":
    "连接一个数据源，让实时看板加载真实数据而非占位内容。",
  "newproj.connectorsEmptyCta": "去配置连接器 →",
  "newproj.connectorsLoading": "正在加载连接器…",
  "newproj.connectorsCountOne": "已连接 {n} 个",
  "newproj.connectorsCountMany": "已连接 {n} 个",
  "newproj.connectorsManage": "管理",
  "newproj.promptTemplateLabel": "参考模板",
  "newproj.promptTemplateNoneTitle": "不指定 — 自由发挥",
  "newproj.promptTemplateNoneSub": "跳过模板库，自己描述需求",
  "newproj.promptTemplateRefSub": "参考模板",
  "newproj.promptTemplateSearch": "搜索模板…",
  "newproj.promptTemplateEmpty": "当前还没有此类型的模板。",
  "newproj.promptTemplateBodyLabel": "Prompt（可继续优化）",
  "newproj.promptTemplateOptimizeHint":
    "可以任意编辑 — 修改后的内容会作为 agent 生成时的参考。",
  "newproj.promptTemplateBodyEmpty": "正文为空 — agent 不会拿到模板参考。",
  "newproj.deleteTemplateTitle": "删除模板",
  "newproj.deleteTemplateConfirm": "确定删除「{name}」？此操作无法撤销。",
  "newproj.deleteTemplateConfirmCta": "删除模板",
  "newproj.deleteTemplateError": "无法删除该模板，请重试。",
  "designs.subRecent": "最近",
  "designs.subYours": "我的设计",
  "designs.filterAria": "筛选项目",
  "designs.searchPlaceholder": "搜索…",
  "designs.emptyNoProjects": "还没有项目。",
  "designs.emptyNoMatch": "没有匹配的项目。",
  "designs.deleteTitle": "删除项目",
  "designs.deleteConfirm": "确定删除「{name}」？",
  "designs.cardFreeform": "自由设计",
  "designs.badgeLive": "实时",
  "designs.liveArtifactBadgesAria": "实时看板标记",
  "designs.liveCount": "{n} 个实时",
  "designs.statusLive": "实时看板",
  "designs.statusArchived": "已归档",
  "designs.statusError": "错误",
  "designs.statusRefreshing": "刷新中…",
  "designs.statusRefreshFailed": "刷新失败",
  "designs.statusRefreshed": "已刷新",
  "designs.status.notStarted": "未开始",
  "designs.status.queued": "等待中",
  "designs.status.running": "运行中",
  "designs.status.awaitingInput": "等待回复",
  "designs.status.incomplete": "未完成",
  "designs.status.succeeded": "已完成",
  "designs.status.published": "已发布",
  "designs.status.failed": "失败",
  "designs.status.canceled": "已取消",
  "designs.viewToggleAria": "视图模式",
  "designs.viewGrid": "网格视图",
  "designs.viewKanban": "看板视图",
  "designs.kanbanEmptyColumn": "暂无设计",
  "designs.deleteAria": "删除项目 {name}",
  "designs.menuMore": "更多操作",
  "designs.menuRename": "重命名",
  "designs.menuDelete": "删除",
  "designs.renamePrompt": "为「{name}」输入新名称",
  "designs.selectMode": "选择",
  "designs.cancelSelect": "取消",
  "designs.deleteSelected": "删除所选",
  "designs.selectedCount": "已选择 {n} 项",
  "designs.deleteSelectedConfirm": "确定删除选中的 {n} 个项目？",
  "designs.deleteSelectedSuccess": "已成功删除 {n} 个项目。",
  "designs.deleteSelectedPartial": "已删除 {deleted} 个项目；{failed} 个失败。",
  "designs.tagPrototype": "原型",
  "designs.tagLiveArtifact": "实时看板",
  "designs.tagSlide": "幻灯片",
  "designs.tagMedia": "媒体",
  "designs.renameTitle": "重命名项目",
  "designs.renameSave": "确定",
  "designs.renameCancel": "取消",
  "examples.typeLabel": "类型",
  "examples.surfaceLabel": "类型",
  "examples.surfaceWeb": "网页",
  "examples.surfaceImage": "图片",
  "examples.surfaceVideo": "视频",
  "examples.surfaceAudio": "音频",
  "examples.scenarioLabel": "场景",
  "examples.modeAll": "全部",
  "examples.modePrototypeDesktop": "原型 · 桌面端",
  "examples.modePrototypeMobile": "原型 · 移动端",
  "examples.modeDeck": "幻灯片",
  "examples.modeDocument": "文档与模板",
  "examples.modeOrbit": "Orbit",
  "examples.modeLive": "实时",
  "examples.scenarioGeneral": "通用",
  "examples.scenarioEngineering": "工程",
  "examples.scenarioProduct": "产品",
  "examples.scenarioDesign": "设计",
  "examples.scenarioMarketing": "市场",
  "examples.scenarioSales": "销售",
  "examples.scenarioFinance": "财务",
  "examples.scenarioHr": "人力资源",
  "examples.scenarioOperations": "运营",
  "examples.scenarioSupport": "支持",
  "examples.scenarioLegal": "法务",
  "examples.scenarioEducation": "教育",
  "examples.scenarioPersonal": "个人",
  "examples.searchPlaceholder": "搜索示例…",
  "examples.searchAria": "按名称搜索示例",
  "examples.emptyNoSkills": "没有可用的技能，守护进程是否在运行？",
  "examples.emptyNoMatch": "没有匹配当前筛选的示例。",
  "examples.openPreview": "⤢ 打开预览",
  "examples.loadingPreview": "正在加载预览…",
  "examples.hoverPreview": "将鼠标悬停以查看预览",
  "examples.usePrompt": "使用此 Prompt",
  "examples.previewModalTitle": "在弹窗中查看完整预览",
  "examples.shareTitle": "分享此示例",
  "examples.shareLoadFirst": "请先悬停以加载预览",
  "examples.unavailablePlaceholder":
    "此技能未附带 {kind} 预览样例 — 打开查看详情",
  "examples.shareUnavailable": "此技能未附带 {kind} 预览样例可分享",
  "examples.shareMenu": "分享 ▾",
  "examples.exportPdfAllSlides": "导出为 PDF（全部幻灯片）",
  "examples.exportPptxLocked": "导出为 PPTX…（请先打开模板）",
  "examples.tagSlideDeck": "幻灯片",
  "examples.tagTemplate": "模板",
  "examples.tagDesignSystem": "设计体系",
  "examples.tagMobilePrototype": "移动端原型",
  "examples.tagDesktopPrototype": "桌面端原型",
  "examples.tagImage": "图片",
  "examples.tagVideo": "视频",
  "examples.tagAudio": "音频",
  "examples.previewLabel": "预览",
  "ds.surfaceLabel": "类型",
  "ds.surfaceWeb": "网页",
  "ds.surfaceImage": "图片",
  "ds.surfaceVideo": "视频",
  "ds.surfaceAudio": "音频",
  "ds.searchPlaceholder": "搜索设计体系…",
  "ds.emptyNoMatch": "没有匹配的设计体系。",
  "ds.badgeDefault": "默认",
  "ds.preview": "预览完整体系",
  "ds.previewTitle": "预览完整设计体系",
  "ds.categoryAll": "全部",
  "ds.categoryUncategorized": "未分类",
  "ds.showcase": "展示",
  "ds.tokens": "Token",
  "ds.specToggle": "DESIGN.md",
  "ds.specLoading": "正在加载 DESIGN.md…",
  "avatar.title": "账户与设置",
  "avatar.localCli": "本机 CLI",
  "avatar.anthropicApi": "Anthropic API",
  "avatar.useLocal": "使用本机 CLI",
  "avatar.useApi": "使用 API · BYOK",
  "avatar.codeAgent": "代码代理",
  "avatar.rescan": "重新扫描 PATH",
  "avatar.amrConsole": "Crie3 Cloud 账户",
  "avatar.amrConsoleMeta": "余额与充值",
  "avatar.settings": "设置",
  "avatar.backToProjects": "返回项目列表",
  "avatar.metaActive": "使用中",
  "avatar.metaOffline": "未运行",
  "avatar.metaSelected": "已选",
  "avatar.noAgentSelected": "尚未选择代理",
  "avatar.modelSection": "模型",
  "avatar.modelLabel": "模型",
  "avatar.reasoningLabel": "推理",
  "avatar.customSuffix": "（自定义）",
  "socialShare.openDesignSection": "分享 Crie3",
  "socialShare.openDesignTitle": "GitHub 上的 Crie3",
  "socialShare.openDesignText":
    "Crie3 是开源的设计智能工作区，可以生成、编辑、部署并交付设计产物。",
  "socialShare.openDesignCopyText": "{text}\n{url}",
  "socialShare.projectSection": "社媒分享",
  "socialShare.publishPageTitle": "发布分享页",
  "socialShare.publishPageSubtitle": "发布当前预览，以便分享到社媒平台。",
  "socialShare.projectTitle": "{title} · Crie3",
  "socialShare.projectText":
    "我用 Crie3 做了 {title}。查看已部署产物，也推荐收藏仓库：{repo}",
  "socialShare.projectCopyText":
    "我用 Crie3 做了 {title}\n{url}\nCrie3 仓库：{repo}",
  "socialShare.deployFirst": "先部署，再分享到社媒…",
  "socialShare.copied": "已复制",
  "socialShare.platform.x": "X",
  "socialShare.platform.linkedin": "LinkedIn",
  "socialShare.platform.facebook": "Facebook",
  "socialShare.platform.reddit": "Reddit",
  "socialShare.platform.telegram": "Telegram",
  "socialShare.platform.whatsapp": "WhatsApp",
  "socialShare.platform.weibo": "微博",
  "socialShare.platform.line": "LINE",
  "socialShare.platform.instagram": "Instagram",
  "socialShare.platform.xiaohongshu": "小红书",
  "inlineSwitcher.chipTitle": "切换 CLI / 模型",
  "inlineSwitcher.chipCli": "本地 CLI",
  "inlineSwitcher.chipByok": "自带 Key",
  "inlineSwitcher.modelDefault": "默认",
  "inlineSwitcher.noAgent": "未选择",
  "inlineSwitcher.modeLabel": "模式",
  "inlineSwitcher.agentLabel": "代理",
  "inlineSwitcher.providerLabel": "服务商",
  "inlineSwitcher.modelLabel": "模型",
  "inlineSwitcher.useCli": "使用本地 CLI",
  "inlineSwitcher.useByok": "使用自带 API Key",
  "inlineSwitcher.daemonOffline": "守护进程离线 — 打开设置",
  "inlineSwitcher.noAgentsDetected": "PATH 中未发现可用 CLI",
  "inlineSwitcher.openSettingsForModel": "在“设置”中配置该服务商",
  "inlineSwitcher.missingApiKey": "尚未填写 API Key — 在“设置”中添加。",
  "inlineSwitcher.openFullSettings": "打开执行设置",
  "inlineSwitcher.customSuffix": "（自定义）",
  "project.backToProjects": "返回项目列表",
  "project.brandReadyTitle": "{name} 设计体系已就绪",
  "project.brandReadyTitleGeneric": "你的设计体系已就绪",
  "project.brandReadyCta": "在设计体系中预览",
  "project.brandReadyDismiss": "忽略",
  "project.brandReadyRefineHint":
    "自动提取可能漏掉细节。大范围使用前先优化这套体系。",
  "project.brandReadyAiOptimize": "AI 优化",
  "project.brandReadyEditManually": "手动编辑",
  "project.brandReadyPreviewOpened": "已跳转到设计体系预览。",
  "project.metaFreeform": "自由设计",
  "project.customInstructions": "项目指令",
  "project.customInstructionsPlaceholder": "此项目的指令（每条消息都会注入）…",
  "project.resizeChatPanel": "调整聊天面板大小",
  "project.instructionsActive": "已生效 — 每条消息都会附带",
  "project.missing": "该项目已删除或不存在。",
  "chat.tabChat": "对话",
  "chat.tabComments": "评论",
  "chat.commentsSoon": "评论 — 即将上线",
  "chat.comments.attached": "已附加到对话",
  "chat.comments.emptyAttached": "没有已附加的评论。",
  "chat.comments.saved": "已保存的评论",
  "chat.comments.emptySaved": "没有已保存的评论。",
  "chat.comments.add": "添加",
  "chat.comments.addAll": "全部添加",
  "chat.comments.remove": "移除",
  "chat.comments.placeholder": "评论此元素…",
  "chat.comments.addSend": "添加并发送",
  "chat.comments.updateSend": "更新并发送",
  "chat.comments.removeAttachment": "移除评论附件",
  "chat.comments.removeAttachmentAria": "移除 {name} 的评论附件",
  "chat.comments.comment": "评论",
  "chat.comments.sendToChat": "发送到聊天",
  "chat.comments.sending": "发送中…",
  "chat.comments.edit": "编辑",
  "chat.comments.select": "选择",
  "chat.comments.selectAll": "全选",
  "chat.comments.deselect": "取消选择",
  "chat.comments.nSelected": "已选择 {n} 个",
  "chat.comments.pin": "图钉",
  "chat.comments.addNote": "添加备注",
  "chat.comments.savedToast": "评论已保存",
  "chat.comments.pinSavedToast": "图钉已保存",
  "chat.comments.pinAtCoords": "位于 {x}, {y}",
  "chat.comments.capturedItems": "{n} 个捕获项",
  "chat.comments.clear": "清除",
  "chat.comments.targetImage": "图片",
  "chat.comments.targetControl": "控件",
  "chat.comments.targetLink": "链接",
  "chat.comments.targetText": "文本",
  "chat.comments.targetSection": "分区",
  "chat.comments.targetPage": "页面",
  "chat.comments.targetArea": "区域",
  "chat.annotationNotePlaceholder": "为这个标记添加说明",
  "chat.annotationAttachImage": "添加图片",
  "chat.annotationAttachedImages": "已添加图片",
  "chat.annotationAttachedRemove": "移除最后一张图片",
  "chat.annotationAddToInput": "发送到输入框",
  "chat.annotationAddingToInput": "正在添加...",
  "chat.annotationQueue": "加入队列",
  "chat.annotationQueueing": "加入队列中...",
  "chat.annotationSubmitOptions": "提交选项",
  "chat.annotationSending": "发送中...",
  "chat.annotationSendDisabledReason": "当前正有任务在执行",
  "chat.annotationPreviewMissing": "无法截到下面的预览，请重试",
  "chat.annotationPreviewMissingInk":
    "无法截到下面的预览，请重试，避免只附带笔迹",
  "chat.annotationSentWithoutScreenshot":
    "未能截取预览，已发送标注（不含截图）。",
  "chat.annotationTimeout": "标注发送超时，请重试",
  "chat.annotationFailed": "标注发送失败，请重试",
  "chat.annotationProjectCreateFailed": "无法创建项目，标注未发送",
  "chat.annotationUploadFailed": "附件上传失败，请重试",
  "chat.conversationsTitle": "对话历史",
  "chat.conversationsAria": "对话历史",
  "chat.newConversation": "新建对话",
  "chat.newConversationsTitle": "新建对话",
  "chat.conversationsHeading": "对话",
  "chat.new": "新建",
  "chat.emptyConversations": "还没有对话。",
  "chat.deleteConversation": "删除对话",
  "chat.renameConversationLabel": "重命名「{title}」",
  "chat.deleteConversationConfirm": "确定删除「{title}」？该操作会删除其消息。",
  "chat.untitledConversation": "未命名对话",
  "chat.forkedConversationTitle": "{title} 分叉",
  "chat.forkConversationFailed": "无法分叉这个对话。",
  "chat.startTitle": "开始一个对话",
  "chat.startHint": "描述你想生成的内容，或从下面的示例开始：",
  "chat.brandBrowserAssistDesktopOnly":
    "浏览器辅助需要桌面应用，Crie3 才能读取实时浏览器页面。",
  "chat.brandBrowserAssistReadFailed":
    "无法读取浏览器页面。请确认品牌网站已打开并完全加载。",
  "chat.brandBrowserAssistMessage":
    "Crie3 需要浏览器辅助才能完成这次品牌提取。请先在 Browser 标签页清除页面拦截，然后在下方确认。",
  "brandEnrichment.title": "AI 优化",
  "brandEnrichment.body":
    "Crie3 会在后台运行更深度的抽取，自动带上合适的设计系统 skills，并原地更新这个系统。通常需要 10-20 分钟，你可以继续做别的事。",
  "brandEnrichment.cta": "AI 优化",
  "brandEnrichment.busy": "正在启动 AI 优化...",
  "brandExtractionTranscript.sourceDesignMd": "粘贴的 DESIGN.md",
  "brandExtractionTranscript.user": "从 {source} 抽取一个设计系统。",
  "brandExtractionTranscript.doneTitle": "{name} 的程序化抽取已完成。",
  "brandExtractionTranscript.doneBody":
    "我已经从 {source} 创建并注册了 {designSystemId} 设计系统。现在可以预览，也可以直接用于新设计。",
  "brandExtractionTranscript.next":
    "接下来，你可以选择：让 agent 消耗模型 token 做更深一轮语义化抽取并原地更新设计系统，或用这个已抽取的设计系统新建设计。",
  "chat.fillInputTitle": "点击填充到输入框",
  "chat.jumpToLatest": "回到最新",
  "chat.scrollToLatest": "滚动到最新",
  "chat.you": "你",
  "chat.openFile": "打开 {name}",
  "chat.copyPrompt": "复制提示词",
  "chat.copyErrorDiagnostic": "复制错误诊断信息",
  "chat.copyDone": "已复制！",
  "chat.formAnswersTitle": "你的回答",
  "chat.formAnswerSkipped": "已跳过",
  "chat.readingToggle": "图片测量信息",
  "chat.readingDark": "暗",
  "chat.readingMedium": "中等",
  "chat.readingLight": "亮",
  "chat.readingPortrait": "竖版",
  "chat.readingLandscape": "横版",
  "chat.readingSquare": "方形",
  "chat.readingCopyColor": "复制颜色",
  "chat.readingText": "识别的文字",
  "chat.readingPaletteUnavailable": "调色板不可用",
  "chat.readingFailed": "无法读取这张图片。",
  "chat.inspect.noEditableTargets": "未找到可编辑的文本或样式目标。",
  "chat.inspect.noCommentTargets": "未找到可评论的文本或视觉目标。",
  "chat.inspect.editHint": "在预览中选择文本或样式目标进行编辑。",
  "chat.inspect.commentHint": "在预览中选择文本或区域进行评论。",
  "chat.composerPlaceholder": "描述你想生成的内容…",
  "chat.activeFileEditingLabel": "编辑中",
  "chat.activeFilePlaceholder": "让 Crie3 修改 {file}...",
  "chat.designArtifactsShowMore": "再显示 {count} 个设计文件",
  "chat.mode.chat.label": "提问",
  "chat.mode.chat.title": "Ask 模式",
  "chat.mode.chat.summary":
    "适合快速问答、修改建议、规划和讨论，不默认创建新的设计产物。",
  "chat.mode.chat.solves":
    "用来澄清想法、调试提示词、比较方案，或询问已有稿子的改进点。",
  "chat.mode.chat.query1": "总结这份稿子，并指出还缺什么。",
  "chat.mode.chat.query2": "帮我判断这个落地页应该怎么组织结构。",
  "chat.mode.chat.query3": "看一下这个设计，给我具体的改进建议。",
  "chat.mode.plan.label": "规划",
  "chat.mode.plan.title": "规划模式",
  "chat.mode.plan.summary":
    "先生成可编辑的规划文档，等你确认和修改后，再交给 Design 生成最终产物。",
  "chat.mode.plan.solves":
    "适合 PRD、PPT 大纲、原型需求、线框图、分镜脚本，以及任何需要先确认方向的大需求。",
  "chat.mode.plan.query1": "先生成一份逐页 PPT 大纲。",
  "chat.mode.plan.query2": "先写 PRD，再基于 PRD 生成原型。",
  "chat.mode.plan.query3": "把这个想法整理成可编辑的设计规划文档。",
  "chat.mode.design.label": "设计",
  "chat.mode.design.title": "设计模式",
  "chat.mode.design.summary":
    "适合创建或修改具体设计产物，比如网页、原型、实时看板、幻灯片、图片、视频、HyperFrames、音频、数据看板和项目文件。",
  "chat.mode.design.solves":
    "当你希望 Crie3 生成文件、更新工作区，或把需求变成多模态可交付结果时使用。",
  "chat.mode.design.query1":
    "根据这段需求做一个产品发布落地页和 HyperFrames 原型。",
  "chat.mode.design.query2": "做一份 10 页投资人 Deck，并附上讲稿备注。",
  "chat.mode.design.query3": "为这次 campaign 生成图片、视频和音频创意。",
  "chat.mode.cardBestFor": "适合解决",
  "chat.mode.cardTry": "可以这样问",
  "chat.mode.cardCost": "预计消耗",
  "chat.mode.chat.cost": "较低",
  "chat.mode.chat.costNote": "只是对话，不生成任何文件，消耗最少。",
  "chat.mode.plan.cost": "中等",
  "chat.mode.plan.costNote": "先生成一份可编辑的方案文档，再进入生成阶段。",
  "chat.mode.design.cost": "较高",
  "chat.mode.design.costNote": "会生成文件和多模态内容，单次运行消耗可能最高。",
  "chat.composerHint": "⌘/Ctrl + Enter 发送 · 说清目标、内容、风格和格式",
  "chat.cliSettingsTitle": "CLI 与模型设置",
  "chat.cliSettingsAria": "打开 CLI 与模型设置",
  "chat.attachTitle": "附加文件（也可以粘贴/拖入）",
  "chat.addContextTitle": "添加内容",
  "chat.attachAria": "附加文件",
  "chat.importTitle": "导入素材（即将上线）",
  "chat.importLabel": "导入",
  "chat.importComingSoon": "即将上线",
  "chat.importSoon": "即将",
  "chat.importFig": "上传 .fig 文件",
  "chat.importGitHub": "连接 GitHub",
  "chat.importWeb": "抓取网页元素",
  "chat.importFolder": "关联代码目录",
  "chat.importSkills": "技能与设计体系",
  "chat.importProject": "引用其它项目",
  "chat.importDesignSystemHeader": "选择一个设计体系",
  "chat.importDesignSystemBack": "返回",
  "chat.importDesignSystemSearch": "搜索设计体系…",
  "chat.importDesignSystemEmpty": '没有匹配 "{query}" 的设计体系',
  "chat.importDesignSystemNone": "不指定 — 自由风格",
  "chat.importDesignSystemNoneSub": "本轮不锚定任何体系",
  "chat.importDesignSystemActive": "当前",
  "chat.importDesignSystemSwitched": "已切换设计体系为 {title}",
  "chat.importDesignSystemFailed": "切换设计体系失败，请重试。",
  "chat.importDesignSystemLoadFailed": "无法加载设计体系。",
  "browserUse.title": "灵感",
  "browserUse.summary":
    "{count} 个网页操作，优先展示素材提取、设计语言、动效、视觉校验和组件结构。",
  "browserUse.searchAria": "搜索灵感",
  "browserUse.searchPlaceholder": "搜索截图、字体、配色、a11y...",
  "browserUse.empty": "没有匹配的灵感",
  "browserUse.unavailable": "灵感暂不可用",
  "browserUse.added": "已加入输入框",
  // Design Browser
  "designBrowser.aria": "内置浏览器",
  "designBrowser.goBack": "后退",
  "designBrowser.goForward": "前进",
  "designBrowser.reload": "重新加载",
  "designBrowser.stopLoading": "停止加载",
  "designBrowser.viewportAria": "浏览器视口",
  "designBrowser.addressPlaceholder": "输入 URL 或搜索...",
  "designBrowser.addressAria": "浏览器地址",
  "designBrowser.savePageBrief": "保存页面简报",
  "designBrowser.menu": "浏览器菜单",
  "designBrowser.suggestion.reference": "参考",
  "designBrowser.suggestion.history": "历史",
  "designBrowser.menu.copyScreenshot": "复制截图",
  "designBrowser.menu.hardReload": "强制刷新",
  "designBrowser.menu.copyUrl": "复制 URL",
  "designBrowser.menu.openInBrowser": "在浏览器中打开",
  "designBrowser.menu.savePageBrief": "保存页面简报",
  "designBrowser.menu.clearBrowsingHistory": "清除浏览历史",
  "designBrowser.menu.clearCookies": "清除 Cookie",
  "designBrowser.menu.clearAllData": "清除全部数据",
  "designBrowser.status.noUrlToCopy": "没有可复制的 URL",
  "designBrowser.status.urlCopied": "URL 已复制",
  "designBrowser.status.openHttpUrlFirst": "请先打开 http URL",
  "designBrowser.status.openPageBeforeScreenshot": "请先打开页面再截图",
  "designBrowser.status.screenshotCopied": "截图已复制到剪贴板",
  "designBrowser.status.screenshotSaved": "截图已保存到项目",
  "designBrowser.status.screenshotFailed": "截图失败",
  "designBrowser.status.openPageBeforeBrief": "请先打开页面再保存简报",
  "designBrowser.status.briefSaveFailed": "保存简报失败",
  "designBrowser.status.desktopDataUnavailable": "当前环境无法访问桌面浏览器数据",
  "designBrowser.status.browserDataCleared": "浏览器数据已清除",
  "designBrowser.status.browserDataClearFailed": "清除浏览器数据失败",
  "designBrowser.status.historyCleared": "浏览历史已清除",
  "designBrowser.status.openPageBeforeTools": "请先打开页面再使用浏览器工具",
  "designBrowser.status.clickElementToComment": "点击页面元素添加评论",
  "designBrowser.status.clickElementToTune": "点击页面元素调参",
  "designBrowser.status.noElementSelected": "未选中浏览器元素",
  "designBrowser.status.addBrowserComment": "添加浏览器评论",
  "designBrowser.status.tuneElementThenSaveHtml": "调整元素后保存 HTML",
  "designBrowser.status.tuneLiveOnly": "非项目页面只能实时预览调参",
  "designBrowser.status.pickerFailed": "浏览器元素选择失败",
  "designBrowser.status.applyStyleFailed": "无法在浏览器页面应用样式",
  "designBrowser.status.editTextFailed": "无法在浏览器页面编辑文本",
  "designBrowser.status.onlyProjectHtmlCanSave": "只能保存项目内 HTML 页面",
  "designBrowser.status.htmlSaved": "HTML 修改已保存",
  "designBrowser.status.htmlSaveFailed": "HTML 保存失败",
  "designBrowser.status.commentSavingUnavailable": "当前无法保存评论",
  "designBrowser.status.commentSaved": "浏览器评论已保存",
  "designBrowser.status.commentSendingUnavailable": "当前无法发送评论",
  "designBrowser.comments.aria": "浏览器评论",
  "designBrowser.comments.openFor": "打开 {label} 的浏览器评论",
  "designBrowser.comment.dialog": "浏览器评论",
  "designBrowser.comment.elementFallback": "浏览器元素",
  "designBrowser.comment.close": "关闭浏览器评论",
  "designBrowser.comment.noteAria": "浏览器评论备注",
  "designBrowser.comment.placeholder": "描述需要修改或检查的问题...",
  "designBrowser.comment.addNote": "添加备注",
  "designBrowser.comment.saveComment": "保存评论",
  "designBrowser.comment.sending": "正在发送...",
  "designBrowser.comment.sendToChat": "发送到对话",
  "designBrowser.inspect.editTitle": "编辑 HTML 元素",
  "designBrowser.inspect.tuneTitle": "调整浏览器元素",
  "designBrowser.inspect.closeTune": "关闭浏览器调参",
  "designBrowser.inspect.colors": "颜色",
  "designBrowser.inspect.text": "文本",
  "designBrowser.inspect.fill": "填充",
  "designBrowser.inspect.type": "字体",
  "designBrowser.inspect.size": "字号",
  "designBrowser.inspect.weight": "字重",
  "designBrowser.inspect.spacing": "间距",
  "designBrowser.inspect.pad": "内边距",
  "designBrowser.inspect.radius": "圆角",
  "designBrowser.inspect.content": "内容",
  "designBrowser.inspect.elementText": "元素文本",
  "designBrowser.inspect.saving": "正在保存...",
  "designBrowser.inspect.saveHtml": "保存 HTML",
  "designBrowser.inspect.liveOnly": "仅实时预览",
  "designBrowser.reference.kicker": "Crie3 浏览器",
  "designBrowser.reference.title": "参考看板",
  "designBrowser.reference.subtitle": "精选灵感、真实产品 UI、动效、色彩、字体、素材和设计系统参考。打开任意站点即可边浏览边收集下一个产物所需的设计语言。",
  "designBrowser.reference.categoryAria": "参考分类",
  "designBrowser.reference.searchPlaceholder": "搜索参考...",
  "designBrowser.reference.searchAria": "搜索参考",
  "designBrowser.reference.clearSearch": "清除搜索",
  "designBrowser.reference.noMatches": "没有匹配“{query}”的参考。",
  "designBrowser.reference.clearFilters": "清除筛选",
  "designBrowser.reference.open": "打开",
  "designBrowser.reference.group.inspiration": "灵感",
  "designBrowser.reference.group.interfaces": "真实界面",
  "designBrowser.reference.group.motion": "动效",
  "designBrowser.reference.group.color": "色彩",
  "designBrowser.reference.group.type": "字体",
  "designBrowser.reference.group.icons": "图标",
  "designBrowser.reference.group.illustration": "插画",
  "designBrowser.reference.group.photography": "摄影",
  "designBrowser.reference.group.3d": "3D 与图形",
  "designBrowser.reference.group.mockups": "样机",
  "designBrowser.reference.group.systems": "设计系统",
  "designBrowser.reference.group.components": "组件",
  "designBrowser.reference.group.guidelines": "规范与无障碍",
  "designBrowser.reference.group.tools": "工具与资源",
  "designBrowser.reference.site.dribbble.detail": "设计作品和 UI 灵感。",
  "designBrowser.reference.site.behance.detail": "创意作品集和案例研究。",
  "designBrowser.reference.site.awwwards.detail": "获奖网站设计参考。",
  "designBrowser.reference.site.godly.detail": "现代网页设计精选。",
  "designBrowser.reference.site.land_book.detail": "落地页图库和版式模式。",
  "designBrowser.reference.site.mobbin.detail": "真实 App 界面和 UI 模式。",
  "designBrowser.reference.site.screenlane.detail": "来自 App 的最新 UI 设计模式。",
  "designBrowser.reference.site.pageflows.detail": "真实产品用户流程和引导。",
  "designBrowser.reference.site.uisources.detail": "头部 App 的交互模式。",
  "designBrowser.reference.site.collectui.detail": "按类别整理的每日 UI 集合。",
  "designBrowser.reference.site.gsap.detail": "生产级动画引擎和示例。",
  "designBrowser.reference.site.animations.detail": "动画模式和交互示例。",
  "designBrowser.reference.site.transitions.detail": "现代界面的转场模式。",
  "designBrowser.reference.site.motionsites.detail": "高品质动效和交互参考。",
  "designBrowser.reference.site.motion.detail": "滚动和时间轴动画灵感。",
  "designBrowser.reference.site.animography.detail": "动态字体和文字动效。",
  "designBrowser.reference.site.reactbits.detail": "React 闪光文字动效参考。",
  "designBrowser.reference.site.coolors.detail": "快速配色生成器。",
  "designBrowser.reference.site.colorhunt.detail": "精选配色方案。",
  "designBrowser.reference.site.realtimecolors.detail": "在真实 UI 中预览配色。",
  "designBrowser.reference.site.color_adobe.detail": "色轮和配色和谐规则。",
  "designBrowser.reference.site.happyhues.detail": "放在真实语境中的配色。",
  "designBrowser.reference.site.fonts_google.detail": "开源字体库。",
  "designBrowser.reference.site.fontshare.detail": "可商用的高质量免费字体。",
  "designBrowser.reference.site.typewolf.detail": "字体使用案例和搭配建议。",
  "designBrowser.reference.site.fontpair.detail": "字体搭配建议。",
  "designBrowser.reference.site.fontsinuse.detail": "真实设计中的字体案例。",
  "designBrowser.reference.site.thesvg.detail": "SVG 素材和矢量参考。",
  "designBrowser.reference.site.svglogos.detail": "适合产品和品牌稿的干净 SVG Logo。",
  "designBrowser.reference.site.icons_lobehub.detail": "产品和 AI 品牌界面图标。",
  "designBrowser.reference.site.icon_sets_iconify.detail": "20 万+ 开源图标集合。",
  "designBrowser.reference.site.lucide.detail": "简洁一致的开源图标集。",
  "designBrowser.reference.site.heroicons.detail": "Tailwind 出品的 SVG 图标。",
  "designBrowser.reference.site.svgrepo.detail": "免费 SVG 矢量和图标。",
  "designBrowser.reference.site.storyset.detail": "可定制矢量插画。",
  "designBrowser.reference.site.undraw.detail": "MIT 协议开源插画。",
  "designBrowser.reference.site.blush.detail": "可混搭组合的插画。",
  "designBrowser.reference.site.lummi.detail": "免费 AI 生成视觉素材。",
  "designBrowser.reference.site.whirrls.detail": "手绘风图片参考。",
  "designBrowser.reference.site.worldindots.detail": "点阵地图和数据可视化参考。",
  "designBrowser.reference.site.unsplash.detail": "免费高分辨率照片。",
  "designBrowser.reference.site.pexels.detail": "免费图库照片和视频。",
  "designBrowser.reference.site.pixabay.detail": "免版税图片和媒体素材。",
  "designBrowser.reference.site.cosmos.detail": "视觉发现和情绪板。",
  "designBrowser.reference.site.spline.detail": "浏览器中的 3D 设计工具。",
  "designBrowser.reference.site.threejs.detail": "WebGL 3D 参考和演示。",
  "designBrowser.reference.site.womp.detail": "易上手的浏览器 3D 创作。",
  "designBrowser.reference.site.pixcap.detail": "3D 图标、样机和场景。",
  "designBrowser.reference.site.shots.detail": "设备和浏览器样机。",
  "designBrowser.reference.site.mockuuups.detail": "拖拽式设备样机。",
  "designBrowser.reference.site.angle.detail": "3D 设备样机库。",
  "designBrowser.reference.site.rotato.detail": "动画 3D 产品样机。",
  "designBrowser.reference.site.impeccable.detail": "高质量风格和界面参考。",
  "designBrowser.reference.site.styles_refero.detail": "设计风格参考和视觉系统。",
  "designBrowser.reference.site.brandfetch.detail": "品牌素材、Logo 和识别资产。",
  "designBrowser.reference.site.designsystemsrepo.detail": "公开设计系统图库。",
  "designBrowser.reference.site.startups.detail": "头部创业公司的产品和品牌参考。",
  "designBrowser.reference.site.base_ui.detail": "用于自定义系统的无样式无障碍基础组件。",
  "designBrowser.reference.site.ui_shadcn.detail": "基于 Radix 和 Tailwind 的可组合 React 组件。",
  "designBrowser.reference.site.heroui.detail": "现代 React 组件库和设计系统。",
  "designBrowser.reference.site.radix_ui.detail": "无障碍低层 UI 原语。",
  "designBrowser.reference.site.react_spectrum_adobe.detail": "Adobe 出品的无障碍行为原语。",
  "designBrowser.reference.site.headlessui.detail": "面向 Tailwind 的无样式无障碍组件。",
  "designBrowser.reference.site.mui.detail": "基于 Material 的 React 组件生态。",
  "designBrowser.reference.site.mantine.detail": "功能完整的 React 组件和 Hooks。",
  "designBrowser.reference.site.chakra_ui.detail": "带主题 token 的无障碍 React 组件。",
  "designBrowser.reference.site.ant.detail": "企业级组件系统和模式。",
  "designBrowser.reference.site.ark_ui.detail": "跨现代框架的 Headless 组件。",
  "designBrowser.reference.site.daisyui.detail": "Tailwind CSS 组件类和主题。",
  "designBrowser.reference.site.developer_apple.detail": "Apple 平台设计规范。",
  "designBrowser.reference.site.m3_material.detail": "Google Material Design 3。",
  "designBrowser.reference.site.lawsofux.detail": "UX 原则和启发式规则。",
  "designBrowser.reference.site.webaim.detail": "颜色对比度检查器。",
  "designBrowser.reference.site.a11yproject.detail": "无障碍清单和模式。",
  "designBrowser.reference.site.toolfolio.detail": "设计工具、资源和集合。",
  "designBrowser.reference.site.getdesign.detail": "精选设计资源。",
  "designBrowser.reference.site.tasteskill.detail": "设计品味训练和评审参考。",
  "designBrowser.reference.site.uigoodies.detail": "手工精选设计资源。",
  "designBrowser.reference.site.sidebar.detail": "每天五条设计链接。",
  "designBrowser.reference.site.github.detail": "嵌入式浏览器工作流的参考实现。",
  "browserUse.category.assets": "素材提取",
  "browserUse.category.tokens": "设计语言",
  "browserUse.category.motion": "动效",
  "browserUse.category.visual": "视觉校验",
  "browserUse.category.structure": "组件结构",
  "browserUse.category.project": "项目运行",
  "browserUse.category.general": "通用操作",
  "browserUse.input.none": "无需输入",
  "browserUse.input.assetKind": "类型：images / svgs / media / fonts，最多 200",
  "browserUse.input.optionalSelector": "可选选择器",
  "browserUse.input.requirementSelector": "校验要求，可选选择器",
  "browserUse.input.selectorOptional": "可选选择器",
  "browserUse.input.scaleOne": "缩放 1x",
  "browserUse.input.selectorScaleTwo": "选择器，默认 2x",
  "browserUse.input.gridOverlay": "12 列，最大宽 1200，间距 24",
  "browserUse.input.bodySelector": "selector='body'",
  "browserUse.input.navigate": "URL、域名或搜索词",
  "browserUse.input.selector": "选择器",
  "browserUse.input.selectorText": "选择器和文本",
  "browserUse.input.scroll": "像素、top、bottom 或 page",
  "browserUse.input.terminalRun": "命令，超时 120 秒",
  "browserUse.input.command": "命令",
  "browserUse.input.maxChars": "最多 8000 字符",
  "browserUse.input.custom": "{input}",
  "browserUse.action.extract_logo.output":
    "从 header、nav、类名、位置、OG 图片和 favicon 中找出最可能的 Logo。",
  "browserUse.action.list_images.output":
    "枚举 img、srcset、source 和 CSS 背景图，并带尺寸和 alt。",
  "browserUse.action.download_assets.output":
    "下载素材文件夹，并生成支持 referer/cookie 的 _manifest.json。",
  "browserUse.action.extract_svgs.output":
    "提取内联 SVG 和外链 .svg，分别保存为 SVG 文件。",
  "browserUse.action.optimize_svgs.output": "输出优化后的 SVG 文件和压缩比例。",
  "browserUse.action.extract_colors.output":
    "频率加权配色板和 :root CSS 颜色变量，输出 palette.json 与 palette.html。",
  "browserUse.action.extract_fonts.output":
    "字体家族、字号、字重和 @font-face Top 列表，输出 typography.json。",
  "browserUse.action.extract_design_tokens.output":
    "圆角、阴影、间距和 CSS 变量，输出 tokens.json。",
  "browserUse.action.extract_type_scale.output":
    "标题、正文、按钮的字号阶梯、字重、行高和比例。",
  "browserUse.action.extract_buttons.output":
    "去重后的按钮样式库，输出 buttons.html 和 buttons.json。",
  "browserUse.action.extract_grid_system.output":
    "Grid/Flex 容器、方向、间距、列数和最大宽度，输出 layout.json。",
  "browserUse.action.extract_breakpoints.output":
    "响应式媒体查询断点，输出 breakpoints.json。",
  "browserUse.action.extract_gradients.output":
    "CSS 渐变，输出 gradients.css、gradients.json 和 HTML 预览。",
  "browserUse.action.extract_shadows.output":
    "box-shadow、text-shadow 和 drop-shadow，输出 shadows.json 和预览。",
  "browserUse.action.extract_easings.output":
    "过渡和动画缓动函数，输出 easings.json。",
  "browserUse.action.export_tokens.output":
    "导出 tokens.css、tokens.scss、tailwind.theme.js 和 style-dictionary.tokens.json。",
  "browserUse.action.extract_animations.output":
    "@keyframes、transition、transform 规则和动效库检测，输出 motion.css 与 motion.json。",
  "browserUse.action.validate_view.output": "截图路径和结构化视觉/布局问题。",
  "browserUse.action.audit_layout.output":
    "布局缺陷检测：溢出、越界、重叠、文字裁切，输出 audit.json。",
  "browserUse.action.audit_accessibility.output":
    "A11y 问题：选择器、标签、角色、焦点、对比度，以及必要截图。",
  "browserUse.action.responsive_screenshots.output":
    "mobile 390、tablet 834、desktop 1440 三档截图。",
  "browserUse.action.screenshot_full.output": "超出视口的整页长截图。",
  "browserUse.action.screenshot_element.output": "单元素截图，默认 2x。",
  "browserUse.action.screenshot_with_grid.output": "带布局栅格叠加的截图。",
  "browserUse.action.screenshot_dark_mode.output":
    "模拟 prefers-color-scheme: dark 后截图。",
  "browserUse.action.generate_styleguide.output":
    "一页式样式指南，包含配色、字号阶梯、圆角和阴影。",
  "browserUse.action.extract_html.output":
    "清洗后的自包含 HTML，移除 script、noscript 和内联事件属性。",
  "browserUse.action.extract_component_inventory.output":
    "重复组件模式、选择器、数量和截图。",
  "browserUse.action.extract_copy.output":
    "标题、CTA、正文和描述，输出 copy.md 与 copy.json。",
  "browserUse.action.extract_nav.output":
    "主导航和页脚链接，输出 sitemap.md 与 nav.json。",
  "browserUse.action.extract_forms.output":
    "表单字段、标签、校验提示和提交动作，输出 forms.json。",
  "browserUse.action.run_project.output":
    "识别 dev server URL 并在 Browser 标签中打开。",
  "browserUse.action.detect_project.output":
    "框架、包管理器、安装命令、dev 命令和端口。",
  "browserUse.action.page_info.output":
    "URL、标题、描述、OG 图片、主题色、favicon 和 viewport。",
  "browserUse.action.snapshot.output":
    "最多 120 个可见交互/文本元素，含 tag、label、href 和坐标。",
  "browserUse.action.navigate.output": "打开页面并返回 page_info。",
  "browserUse.action.click.output": "滚动到可见后点击第一个匹配元素。",
  "browserUse.action.type_text.output":
    "填写输入框，并触发 input/change 事件。",
  "browserUse.action.scroll.output": "当前和最大滚动位置。",
  "browserUse.action.extract_og_metadata.output":
    "Meta 标题/描述/canonical、OG/Twitter 卡片、社交图和主题色。",
  "browserUse.action.terminal_run.output": "stdout、stderr 和退出码。",
  "browserUse.action.terminal_run_background.output":
    "后台任务 id 和最近输出。",
  "browserUse.action.terminal_read.output": "共享终端最近输出。",
  "chat.designToolbox.title": "设计百宝箱",
  "chat.designToolbox.tooltip": "设计百宝箱",
  "chat.designToolbox.aria": "打开设计百宝箱",
  "chat.designToolbox.searchPlaceholder":
    "搜索 skills / MCP / plugins / connectors / design files…",
  "chat.designToolbox.searchAria": "搜索设计百宝箱资源",
  "chat.designToolbox.followupSection": "后续动作",
  "chat.designToolbox.resourcesSection": "全局资源",
  "chat.designToolbox.selected": "已选",
  "chat.designToolbox.noResources": "没有找到“{query}”相关资源。",
  "chat.designToolbox.badge.video": "视频",
  "chat.designToolbox.badge.image": "图像",
  "chat.designToolbox.badge.motion": "动效",
  "chat.designToolbox.badge.polish": "润色",
  "chat.designToolbox.action.auto-match.title": "智能匹配下一步",
  "chat.designToolbox.action.auto-match.badge": "匹配",
  "chat.designToolbox.action.auto-match.description":
    "先定义好看标准，再全局匹配 skills / MCP / plugins / connectors / files。",
  "chat.designToolbox.action.asset-search.title": "找图 / 找参考图",
  "chat.designToolbox.action.asset-search.badge": "素材",
  "chat.designToolbox.action.asset-search.description":
    "为当前设计搜索可用图片、参考截图、moodboard 和素材来源候选。",
  "chat.designToolbox.action.icon-workflow.title": "找 icon / 替换 icon",
  "chat.designToolbox.action.icon-workflow.badge": "图标",
  "chat.designToolbox.action.icon-workflow.description":
    "查找、生成或替换图标、SVG、Lucide icon 和视觉符号，并保持风格一致。",
  "chat.designToolbox.action.image-replace.title": "替换页面图片",
  "chat.designToolbox.action.image-replace.badge": "换图",
  "chat.designToolbox.action.image-replace.description":
    "审查当前配图，把薄弱的 hero、分区、背景或卡片图片替换成更合适的素材。",
  "chat.designToolbox.action.reference-extract.title": "参考图获取 / 风格提取",
  "chat.designToolbox.action.reference-extract.badge": "参考",
  "chat.designToolbox.action.reference-extract.description":
    "分析参考截图或网站，提取配色、字体、布局姿态、动效和素材方向。",
  "chat.designToolbox.action.motion.title": "加动画 / 动效",
  "chat.designToolbox.action.motion.badge": "动画",
  "chat.designToolbox.action.motion.description":
    "给当前 HTML 或页面元素加入入场、滚动、状态切换和微交互。",
  "chat.designToolbox.action.motion-polish.title": "动效润色",
  "chat.designToolbox.action.motion-polish.badge": "节奏",
  "chat.designToolbox.action.motion-polish.description":
    "检查现有动效的节奏、缓动、性能和 reduced-motion 兜底。",
  "chat.designToolbox.action.transition-motion.title": "设计过场动画",
  "chat.designToolbox.action.transition-motion.badge": "过场",
  "chat.designToolbox.action.transition-motion.description":
    "设计页面、场景、加载和状态切换过场，并补上克制节奏和 reduced-motion 兜底。",
  "chat.designToolbox.action.threejs-scene.title": "3D / Three.js 场景",
  "chat.designToolbox.action.threejs-scene.badge": "3D",
  "chat.designToolbox.action.threejs-scene.description":
    "加入或规划 Three.js、Spline、Vanta、粒子、WebGL、地图或 deck.gl 风格交互视觉。",
  "chat.designToolbox.action.anti-ai-polish.title": "反 AI 味美化",
  "chat.designToolbox.action.anti-ai-polish.badge": "去味",
  "chat.designToolbox.action.anti-ai-polish.description":
    "移除模板感、AI 紫蓝渐变、廉价卡片堆叠和空泛 copy。",
  "chat.designToolbox.action.visual-polish.title": "设计润色 / 可交付",
  "chat.designToolbox.action.visual-polish.badge": "润色",
  "chat.designToolbox.action.visual-polish.description":
    "审一次视觉层级、排版、间距、响应式、可访问性和交付状态。",
  "chat.designToolbox.action.image-gen.title": "生图 / 视觉参考",
  "chat.designToolbox.action.image-gen.badge": "生图",
  "chat.designToolbox.action.image-gen.description":
    "为当前页面生成分区视觉参考、素材、图标、社媒图或 moodboard。",
  "chat.designToolbox.action.chart-gen.title": "图表 / 图解生成",
  "chat.designToolbox.action.chart-gen.badge": "图表",
  "chat.designToolbox.action.chart-gen.description":
    "生成 ECharts、React Flow、图解、数据看板、关系图或数据可视化素材。",
  "chat.designToolbox.action.logo-gen.title": "logo / 品牌标识生成",
  "chat.designToolbox.action.logo-gen.badge": "Logo",
  "chat.designToolbox.action.logo-gen.description":
    "为当前品牌创建 logo 路线、字标、组合标、符号和身份系统生成 prompt。",
  "chat.designToolbox.action.plan-outline.title": "基于想法生成 PPT 大纲",
  "chat.designToolbox.action.plan-outline.badge": "规划",
  "chat.designToolbox.action.plan-outline.description":
    "先把粗略想法变成可编辑的 Markdown PPT 大纲，再创建幻灯片。",
  "chat.designToolbox.action.video-gen.title": "生视频 / 动画脚本",
  "chat.designToolbox.action.video-gen.badge": "视频",
  "chat.designToolbox.action.video-gen.description":
    "把设计转成短视频、Remotion / Hyperframes 分镜或可生成视频的 prompt。",
  "chat.designToolbox.kind.skill": "技能",
  "chat.designToolbox.kind.plugin": "插件",
  "chat.designToolbox.kind.mcp": "MCP",
  "chat.designToolbox.kind.mcpTemplate": "MCP 模板",
  "chat.designToolbox.kind.connector": "连接器",
  "chat.designToolbox.kind.designFile": "设计文件",
  "chat.designToolbox.context.browser": "浏览器",
  "chat.designToolbox.context.designFiles": "设计文件",
  "chat.designToolbox.context.designSystem": "设计体系",
  "chat.designToolbox.context.folder": "文件夹",
  "chat.designToolbox.context.terminal": "终端",
  "chat.designToolbox.context.sideChat": "侧边对话",
  "chat.designToolbox.context.liveArtifact": "实时看板",
  "chat.designToolbox.context.file": "文件",
  "chat.designToolbox.prompt.contextGeneric":
    "当前目标：当前打开的 HTML / 设计文件 / 网页元素。",
  "chat.designToolbox.prompt.contextSpecific": "当前目标：{kind} · {label}。",
  "chat.designToolbox.prompt.preserveDraft":
    "保留我输入框里已有的意图：{draft}",
  "chat.designToolbox.prompt.selectedSkill":
    "已选 skill：{skill}。请把它作为本轮主要工作流。",
  "chat.designToolbox.prompt.noSkill":
    "如果没有匹配到具体 skill，请先从当前可用 skills / MCP / plugins / connectors / design files 中选择最合适的组合。",
  "chat.designToolbox.prompt.autoMatchIntro":
    "请作为 Creative Director 总调度完成一套设计流程：",
  "chat.designToolbox.prompt.autoMatchStep1":
    "1. 先帮我定义“什么是好看的设计”：受众、业务目标、品牌气质、风格参考、信息密度、色彩/字体/动效/素材标准，以及不能出现的 AI 味/模板感。",
  "chat.designToolbox.prompt.autoMatchStep2":
    "2. 搜索并匹配上面的全量资源索引，不要只看设计百宝箱推荐项；需要时组合 skills、MCP、plugins、connectors 和 design files。",
  "chat.designToolbox.prompt.autoMatchStep3":
    "3. 如果目标或审美标准还不够清楚，用结构化 question-form 引导我选择，给出推荐默认项，并确保每个有限选项问题都有可编辑的自定义填写入口；如果已经足够清楚，直接执行下一步。",
  "chat.designToolbox.prompt.autoMatchStep4":
    "4. 按“诊断 -> 风格方向 -> 资源选择 -> 具体改动/生成 -> 验证”的顺序走完全程。每一步说明为什么选这些资源，以及下一步需要我确认什么。",
  "chat.designToolbox.prompt.assetSearch":
    "为当前设计寻找最合适的图片/参考素材。搜索现有文件、connectors、MCP、浏览器截图和生成工具，给出具体候选、使用方式、必要的授权/来源提醒；如果没有可用素材，给出可执行的生图 prompt。",
  "chat.designToolbox.prompt.iconWorkflow":
    "优化当前设计的 icon 系统：找出缺失图标，替换薄弱图标，保持描边/填充/圆角/线宽一致；优先使用现有图标库，库里没有合适图标时再生成 SVG/icon prompt。",
  "chat.designToolbox.prompt.imageReplace":
    "审查当前设计里的每个图片位，找出占位感或质量弱的配图，然后替换或指定更好的 hero、分区、背景、卡片和社媒图。保持布局不乱，并给出明确文件/prompt/来源选择。",
  "chat.designToolbox.prompt.referenceExtract":
    "把当前参考图/参考网站/design file 当作视觉输入，提取配色、字号阶梯、布局节奏、组件姿态、动效线索和素材风格，再应用到当前设计；不要逐字复制受保护的品牌资产。",
  "chat.designToolbox.prompt.motion":
    "请基于当前 HTML / 页面元素加入高质量动效：入场、滚动、状态切换、过场、Rive/Lottie 风格图标动效或 GSAP/Motion 微交互任选最有效的 1-2 处。保持克制，优先 transform / opacity，并加 prefers-reduced-motion 兜底。",
  "chat.designToolbox.prompt.planOutline":
    "基于这个想法创建或更新一份 Markdown PPT/Deck 规划文档。暂时不要生成最终 PPT。请包含逐页标题、页面目标、内容要点、视觉方向、所需数据/素材和开放问题。把它保存为 Design Files 里的 `.md` 文件，并告诉我需要 review 哪个文件。",
  "chat.designToolbox.prompt.motionPolish":
    "请审查并润色现有动效的节奏、缓动、性能和可访问性。修掉突兀、廉价或影响阅读的动画；必要时改成更细腻的时间线。",
  "chat.designToolbox.prompt.transitionMotion":
    "为当前设计规划高质量过场动画：页面/场景切换、加载承接、状态变化和分区衔接。需要时使用 GSAP/Motion/CSS，保持性能和克制节奏，并提供 reduced-motion 行为。",
  "chat.designToolbox.prompt.threejsScene":
    "为当前设计规划或实现一个聚焦的 Three.js/WebGL 视觉。可考虑 Three.js、Spline 风格场景、Vanta 背景、粒子系统、Mapbox/deck.gl 数据层或浏览器 Portal 效果，但必须有用并验证可渲染。",
  "chat.designToolbox.prompt.antiAiPolish":
    "请做一次反 AI 味美化：移除模板化布局、廉价渐变/光晕、无意义卡片堆叠和空泛文案；保持信息不丢失，直接改到更像真实设计师交付。",
  "chat.designToolbox.prompt.visualPolish":
    "请把这个设计打磨到可交付：检查视觉层级、排版、间距、响应式、按钮状态、空/加载/错误状态和可访问性，并直接完成最重要的修正。",
  "chat.designToolbox.prompt.imageGen":
    "请为当前设计生成下一步视觉资产方案：可以是分区参考图、hero 素材、插画、icon、社媒图或 moodboard。先判断最缺哪类图，再给可执行的生成 prompt / 文件计划。",
  "chat.designToolbox.prompt.chartGen":
    "为当前设计生成最合适的图表、图解或数据可视化。根据数据和用户目标，在 ECharts、React Flow、SVG/CSS 图解、雷达图、关系图、看板或 deck.gl/地图可视化之间选择。",
  "chat.designToolbox.prompt.logoGen":
    "为当前品牌创建 logo 和身份方向。输出多条字标、符号、组合标、配色、使用规则和生成 prompt 路线；确保结果原创，并能落到当前 artifact 里。",
  "chat.designToolbox.prompt.videoGen":
    "请把当前设计转成视频方向：生成短视频分镜、Hyperframes / Remotion 帧结构或 Sora/fal 可用 prompt。优先让现有 HTML / 页面内容自然变成镜头。",
  "chat.designToolbox.prompt.useSkill": "使用 {skill} 处理当前设计。",
  "chat.designToolbox.prompt.skillInstruction":
    "请先判断最合适的加工目标，再直接完成一轮具体改动；如果它依赖外部素材或 API，请给出可运行的替代方案或明确需要我补充什么。",
  "chat.designToolbox.prompt.selectedResource":
    "已选资源：{kind} · {title}（{id}）。",
  "chat.designToolbox.prompt.resourceDescription": "资源说明：{description}",
  "chat.designToolbox.prompt.pluginResource":
    "请把这个 plugin 当作当前设计流程的主要上下文。如果它暴露输入项或 GenUI，请在需要时引导我选择；如果不适合当前目标，请改选更合适的全局资源并说明原因。",
  "chat.designToolbox.prompt.mcpResource":
    "请优先使用这个 MCP 能力完成当前设计下一步。需要外部素材、网页截图、图像/视频生成或数据时，先判断它能否完成，再给出可执行计划。",
  "chat.designToolbox.prompt.mcpTemplateResource":
    "这个 MCP 是可配置模板。如果它是完成当前设计最需要的工具，请先引导我完成配置；如果已有替代资源可用，请先用替代资源继续。",
  "chat.designToolbox.prompt.connectorResource":
    "请在需要真实数据、素材、账号内容或外部工作流时使用这个 connector；使用前先说明会读取/写入什么，必要时让我确认。",
  "chat.designToolbox.prompt.fileResource":
    "请把这个 design file 作为当前设计对象或参考资产，基于它完成下一步加工；如果需要同时比较其他文件，请从全量 design files 中继续搜索。",
  "chat.designToolbox.prompt.resourceIndex":
    "全局资源索引：skills({skills})、plugins({plugins})、MCP({mcpEnabled} enabled / {mcpTemplates} templates)、connectors({connectors} connected)、design files({files})。",
  "chat.designToolbox.prompt.searchableSkills": "可搜索 skills",
  "chat.designToolbox.prompt.searchablePlugins": "可搜索 plugins",
  "chat.designToolbox.prompt.availableMcp": "可用 MCP",
  "chat.designToolbox.prompt.connectedConnectors": "已连接 connectors",
  "chat.designToolbox.prompt.referenceDesignFiles": "可参考 design files",
  "chat.designToolbox.prompt.mcpTemplateName": "{name} template",
  "chat.designToolbox.prompt.processRule":
    "流程规则：先定义审美目标和约束，再搜索/匹配资源；需要用户选择时生成结构化 question-form，并为有限选项保留可编辑的自定义答案，确认后继续执行。",
  "chat.designToolbox.prompt.moreSuffix": "，+{count} more",
  "chat.designToolbox.prompt.compactLine": "{label}：{values}{suffix}。",
  "chat.mentionTabsAria": "提及来源",
  "chat.mentionTabAll": "全部",
  "chat.mentionTabTabs": "标签页",
  "chat.mentionTabPlugins": "插件",
  "chat.mentionTabSkills": "技能",
  "chat.mentionTabMcp": "MCP",
  "chat.mentionTabConnectors": "连接器",
  "chat.mentionTabFiles": "设计文件",
  "chat.mentionNoResults": "没有找到“{query}”的结果。",
  "chat.mentionSearchPrompt":
    "搜索设计文件、标签页、插件、技能、MCP 服务器和连接器。",
  "chat.mentionSectionTabs": "标签页",
  "chat.mentionSectionPlugins": "插件",
  "chat.mentionSectionSkills": "技能",
  "chat.mentionSectionMcp": "MCP",
  "chat.mentionSectionConnectors": "连接器",
  "chat.mentionSectionFiles": "设计文件",
  "chat.mentionActiveSkill": "已启用",
  "chat.mentionUseMcpTitle": "使用 {name}",
  "chat.mentionUseConnectorTitle": "使用 {name}",
  "chat.mentionPluginOfficial": "官方",
  "chat.mentionPluginMine": "我的插件",
  "chat.linkedFolderRemoveAria": "移除关联文件夹 {path}",
  "chat.linkedFolderNotFound": "文件夹不存在",
  "chat.linkedFolderAlready": "该文件夹已关联",
  "chat.linkedFolderPickError": "无法打开文件夹选择器",
  "chat.queuedHeader": "已排队",
  "chat.queuedToSend": "待发送",
  "chat.queuedEditQueuedTaskAria": "编辑排队任务",
  "chat.queuedSave": "保存",
  "chat.queuedCancel": "取消",
  "chat.queuedReorder": "拖动调整顺序",
  "chat.queuedEdit": "编辑",
  "chat.queuedMore": "个排队",
  "chat.queuedFollowUpFallback": "已排队的后续任务",
  "chat.send": "发送",
  "chat.stop": "停止",
  "chat.removeAria": "移除 {name}",
  'chat.contextKind.current': '当前',
  'chat.contextKind.browser': '浏览器',
  'chat.contextKind.designFiles': '设计文件',
  'chat.contextKind.designSystem': '设计系统',
  'chat.contextKind.folder': '文件夹',
  'chat.contextKind.project': '项目',
  'chat.contextKind.localCode': '本地代码',
  'chat.contextKind.terminal': '终端',
  'chat.contextKind.sideChat': '侧边对话',
  'chat.contextKind.liveArtifact': '实时作品',
  'chat.contextKind.file': '文件',
  "chat.starterPreacher1Title": "信息系列封面",
  "chat.starterPreacher1Tag": "系列",
  "chat.starterPreacher1Prompt": "为期四周的信息系列封面——系列标题使用大号、易记的字体,副标题传达系列的应许,底部一条低调的日期条。1080×1350,并附 1920×1080 投影版。标题在缩略图尺寸下仍需清晰,并为教会 Logo 留出位置。",
  "chat.starterPreacher2Title": "证道金句卡",
  "chat.starterPreacher2Tag": "金句",
  "chat.starterPreacher2Prompt": "承载信息中最有力一句话的信息流卡片——引言占据画面大部分,下方低调署名,如有经文则附上出处。1080×1350,高对比度,每张卡片只讲一个要点,不让任何元素与文字争抢注意力。",
  "chat.starterPreacher3Title": "主旨轮播图",
  "chat.starterPreacher3Tag": "社交",
  "chat.starterPreacher3Prompt": "展开信息核心要点的 5 页轮播图——封面点出信息所回应的张力,三页每页承载一个要点,结尾页将其应用到这一周的生活。1080×1350,每页文字简短,节奏适合在手机上阅读。",
  "chat.starterPreacher4Title": "讲道竖屏剪辑",
  "chat.starterPreacher4Tag": "Reels",
  "chat.starterPreacher4Prompt": "从证道的一个段落剪出的 45 秒竖屏脚本——前 3 秒的钩子、段落本身、结尾的邀请。包含屏幕字幕建议、各剪辑点的位置以及结尾呼召。1080×1920,中心安全区。",
  "chat.starterWorship1Title": "歌词幻灯片",
  "chat.starterWorship1Tag": "歌词",
  "chat.starterWorship1Prompt": "用于投影的歌词幻灯片——每屏一段歌词,大字号高对比,不使用连字符,不让任何短语跨屏断开。1920×1080,深色底浅色字,字号大到会场后排也能看清。",
  "chat.starterWorship2Title": "歌单卡片",
  "chat.starterWorship2Tag": "歌单",
  "chat.starterWorship2Prompt": "承载主日敬拜歌单的卡片——按顺序列出歌曲及各自的调,并注明带领者。1080×1350,歌曲与调之间层级分明,在手机上一眼可读。",
  "chat.starterWorship3Title": "排练快拍",
  "chat.starterWorship3Tag": "排练",
  "chat.starterWorship3Prompt": "两条竖版快拍组成的排练通知——第一条以日期、时间、地点为主,第二条列出每人需要携带的物品。1080×1920,大字号,中心安全区,确保在任何手机上都不被裁切。",
  "chat.starterWorship4Title": "播放列表封面",
  "chat.starterWorship4Tag": "播放列表",
  "chat.starterWorship4Prompt": "本月敬拜播放列表的方形封面——播放列表名称使用有力的字体,视觉处理在缩小为图标后仍可辨识,并为事工名称留出位置。1080×1080,在 100×100 像素下仍清晰可读。",
  "chat.starterMedia1Title": "YouTube 缩略图",
  "chat.starterMedia1Tag": "缩略图",
  "chat.starterMedia1Prompt": "一张 YouTube 视频缩略图——最多四个词的超大字体,高对比度,右侧留出放置人物抠像的空间。1280×720,在推荐列表的手机宽度下文字仍清晰可读。",
  "chat.starterMedia2Title": "内容轮播图",
  "chat.starterMedia2Tag": "轮播图",
  "chat.starterMedia2Prompt": "围绕一个主题的 7 页轮播图——封面给出明确承诺,五页每页承载一个要点,结尾页引导关注或收藏。1080×1350,各页层级统一,文字无需放大即可阅读。",
  "chat.starterMedia3Title": "播客封面",
  "chat.starterMedia3Tag": "播客",
  "chat.starterMedia3Prompt": "一张播客封面——节目名称为主体,一行简短副标题说明节目内容,视觉处理在缩小后仍可辨识。3000×3000,并按 55×55 像素检查可读性,这是各应用中的实际显示尺寸。",
  "chat.starterMedia4Title": "竖屏剪辑",
  "chat.starterMedia4Tag": "Reels",
  "chat.starterMedia4Prompt": "从较长内容剪出的 30 秒竖屏脚本——3 秒钩子、承载单一要点的中段、带行动号召的结尾。包含屏幕字幕以及各剪辑点的位置。1080×1920,中心安全区。",
  "chat.starterImage1Title": "经文背景",
  "chat.starterImage1Tag": "经文配图",
  "chat.starterImage1Prompt": "为经文卡片设计一张背景图:琥珀色的温暖日出天空,顶部带柔和的玫瑰色与深蓝色,稀疏轻柔的云层,光线从左下方升起。构图简洁,上方三分之二留白,便于之后叠加经文文字。画面中不含文字、不含人物,带细微胶片颗粒感,1080×1350 竖版质感。",
  "chat.starterImage2Title": "讲道系列封面",
  "chat.starterImage2Tag": "系列",
  "chat.starterImage2Prompt": "为讲道系列设计一张极简封面背景:带纹理的深绿色底,一件象征性物件——燃着小火苗的油灯——置于中偏右,柔和的侧向戏剧光,拉长的柔和阴影,左侧留出大量负空间,便于之后加入系列标题。不含文字、不含人物,方形裁切。",
  "chat.starterImage3Title": "小组插画",
  "chat.starterImage3Tag": "插画",
  "chat.starterImage3Prompt": "一幅扁平矢量插画:温馨客厅中的小组聚会——五位不同年龄的人围坐成松散的圆圈,温暖的台灯光,中间桌上放着一本翻开的圣经。克制的五色配色(奶油色、赤陶色、深绿色、琥珀色、近黑色),不使用渐变,细线条点缀,仅家具下方有柔和投影。",
  "chat.starterVideoShot1Title": "礼拜清晨",
  "chat.starterVideoShot1Tag": "电影感",
  "chat.starterVideoShot1Prompt": "一个 5 秒的电影感镜头:清晨阳光透过空教堂的彩色玻璃窗洒入,光束中尘埃缓缓漂浮,镜头沿中央过道缓慢推向圣坛。无人物、无文字叠加,温暖而安静。",
  "chat.starterVideoShot2Title": "祷告之手",
  "chat.starterVideoShot2Tag": "氛围",
  "chat.starterVideoShot2Prompt": "一个 6 秒的特写:黄金时刻里一双饱经风霜、合十祷告的手,浅景深,镜头轻缓推进,温暖侧光中飘着柔和的尘埃微粒。无对白,安静的环境声,克制的运动。",
  "chat.starterVideoShot3Title": "敬拜逆光",
  "chat.starterVideoShot3Tag": "循环",
  "chat.starterVideoShot3Prompt": "一个适合循环播放的 5 秒敬拜屏幕镜头:高举双手的剪影映在柔和的琥珀色与蓝色逆光中,带轻薄雾气,缓慢细微的运动,面部不聚焦,画面无文字。平静、敬虔的氛围。",
  "chat.starterVideoFrames1Title": "系列标题展示",
  "chat.starterVideoFrames1Tag": "HTML-in-canvas",
  "chat.starterVideoFrames1Prompt": "制作一个 5 秒的合成:干净的深色画布上呈现讲道系列的粗体展示标题。让一枚圆形镜片从左向右扫过标题,经过时以细微的玻璃折射扭曲下方的字母。使用 HyperFrames html-in-canvas——捕获文字 DOM,并通过 vfx-liquid-glass 风格的通道在其上运行镜片着色器。标题用纯 CSS;玻璃效果为 WebGL 图层。",
  "chat.starterVideoFrames2Title": "打字经文",
  "chat.starterVideoFrames2Tag": "叠加层",
  "chat.starterVideoFrames2Prompt": "制作一个合成:一行经文在深色画布上逐字打出——衬线字体,随文字出现逐渐增强的柔光,并通过 html-in-canvas 在实时 DOM 上叠加淡淡的扫描线和轻柔的暗角。经文文字保持为真实 CSS,在着色器通道下依然像素级锐利。结尾定格完整句子停留两拍。",
  "chat.starterVideoFrames3Title": "礼拜前倒计时",
  "chat.starterVideoFrames3Tag": "倒计时",
  "chat.starterVideoFrames3Prompt": "构建一个 6 秒的礼拜前倒计时:深色画布上从 5 数到 1 的大号数字,每次切换都是一次干净利落的短促故障效果——RGB 通道分离、短暂的帧抖动、然后干脆复位。通过 html-in-canvas 捕获数字,让字体在故障通道下保持 CSS 级锐利,结尾以平静的全屏“欢迎”画面收束。",
  "chat.starterAudio1Title": "礼拜欢迎词",
  "chat.starterAudio1Tag": "语音",
  "chat.starterAudio1Prompt": "A 30-second warm welcome voiceover for the start of a service — unhurried, smiling tone, a beat of pause between sentences. Script: 'We are so glad you are here. This hour is set apart — take a breath, quiet your heart. Welcome home.'",
  "chat.starterAudio2Title": "灵修朗读",
  "chat.starterAudio2Tag": "语音",
  "chat.starterAudio2Prompt": "A 45-second calm devotional read, low and measured, with breath between sentences and an intimate close-mic quality. Script: 'The Lord is my shepherd; I shall not want. He makes me lie down in green pastures. He leads me beside still waters. He restores my soul.'",
  "chat.starterAudio3Title": "活动邀请",
  "chat.starterAudio3Tag": "语音",
  "chat.starterAudio3Prompt": "A 20-second upbeat event invitation for social media — bright, energetic, but not salesy. Script: 'This is the weekend. One night of worship, word and communion — and your seat is waiting. Sign-ups are open. Bring someone who needs it.'",
  "ds.loadingSystem": "正在加载设计系统...",
  "ds.openingWorkspace": "正在打开工作区...",
  "dsCreate.figmaUrlInvalid": "请输入 Figma 文件链接(https://figma.com/file/… 或 /design/…)。",
  "dsCreate.extractionAlreadyStarting": "提取已在启动中,请等待当前请求完成。",
  "dsCreate.prepareProjectFailed": "无法准备设计系统项目。",
  "dsCreate.confirmTitle": "Crie3 将提取你的设计系统。",
  "dsCreate.confirmBody": "You'll land in a project that fills in live — logo, palette, typography, imagery — as it measures your brand. Keep the tab open.",
  "dsCreate.startingExtraction": "正在开始提取...",
  "dsCreate.extractDesignSystem": "提取设计系统",
  "dsCreate.addingSourceMaterial": "正在添加源素材...",
  "common.fileSystemReadError": "无法读取部分拖入的文件或文件夹。请确认它们仍然存在,然后重试。",
  "dsCreate.browseFolder": "浏览文件夹",
  "dsCreate.dropZoneSelections": "{label} 已选项",
  "dsCreate.assetEmptyFile": "(空文件)",
  "dsCreate.assetNoPreview": "此文件类型不支持内嵌预览。",
  "dsCreate.assetDropAria": "添加文件——拖放、粘贴或点击浏览",
  "dsCreate.assetDropTitle": "拖放、粘贴,或 ",
  "dsCreate.assetDropBrowse": "浏览",
  "dsCreate.assetDropHint": "图片、字体、Logo、PDF、幻灯片、HTML——每个不超过 12 MB",
  "dsCreate.assetStagedAria": "待处理素材",
  "dsCreate.assetRemoveAria": "移除 {name}",
  "dsCreate.assetClosePreview": "关闭预览",
  "dsCreate.heroShowcasePalette": "调色板",
  "dsCreate.heroShowcaseTypeScale": "字号层级",
  "dsCreate.heroShowcaseComponents": "组件",
  "dsCreate.heroShowcaseBtnPrimary": "主按钮",
  "dsCreate.heroShowcaseBtnGhost": "Ghost",
  "dsFonts.missingAddFiles": "添加品牌字体文件",
  "dsFonts.missingKeepSubstitutes": "保留替代字体",
  "workspace.uploadErrorDismiss": "关闭",
  "chat.searchConversations": "搜索对话",
  "chat.noConversationsMatch": "没有匹配的对话。",
  "chat.chipKindDesignSystem": "Design System",
  "workspace.searchTabsPlaceholder": "搜索标签页",
  "workspace.noTabsFound": "未找到标签页",
  "newproj.modalTitle": "新建项目",
  "newproj.closeEsc": "关闭(Esc)",
  "newproj.creating": "正在创建项目…",
  "newproj.scrollTabsLeft": "向左滚动项目类型",
  "newproj.scrollTabsRight": "向右滚动项目类型",
  "newproj.targetPlatforms": "目标平台",
  "newproj.pickPlatform": "选择平台",
  "home.blankProjectFailed": "无法创建空白项目。请确认守护进程可以连接。",
  "home.templatePickerUnavailable": "当前环境不支持模板选择器。",
  "home.referenceFolderMissing": "所选的参考文件夹已不可用。请先移除或重新选择,再开始运行。",
  "home.startRunFailed": "启动运行失败。请确认守护进程可以连接,然后重试。",
  "figmaImport.notFigFile": "That isn't a .fig file. Export your Figma file as .fig (File → Save local copy) and drop it here.",
  "figmaImport.noProject": "无法打开用于导入的项目。",
  "figmaImport.invalidUrl": "请输入 Figma 文件链接(https://figma.com/file/… 或 /design/…)。",
  "figmaImport.tabUploadFig": "上传 .fig",
  "figmaImport.tabUrl": "Figma 链接",
  "workspace.sideChatNeedsAgent": "Side Chat 需要一个本地代理。请在顶栏中选择。",
  "workspace.sideChatPickAgent": "请先选择本地代理(顶栏)。",
  "automations.validationTitle": "请为此自动化添加标题。",
  "automations.validationPrompt": "请为定时对话添加提示词。",
  "settings.noMatchingModels": "没有匹配的模型",
  "manualEdit.resetElement": "重置元素",
  "assistant.designSystemLocked": "已选择当前设计系统。视觉方向已锁定。",
  "designFiles.pluginFolders": "插件文件夹",
  "preview.printFailed": "打印失败。请重新尝试导出 PDF,或使用浏览器版本。",
  "preview.popupBlocked": "Popup blocked! Click the popup-blocked icon in your browser address bar (or browser menu), choose \"Always allow pop-ups\" for this site, then retry Export PDF.",
  "pluginsHome.filtersAria": "插件筛选",
  "pluginsHome.savedToast": "已保存 {title}。",
  "pluginsHome.saveFailedToast": "无法在此浏览器中保存该插件。",
  "settings.skillUserImported": "用户导入的技能",
  "settings.skillDescriptionPlaceholder": "这个技能是做什么的?代理应该在什么时候使用它?",
  "settings.skillDetailUnavailable": "守护进程未返回完整的技能详情。请重试后再使用此技能。",
  "settings.skillExamplePrompt": "示例提示词",
  "entry.navPrimaryAria": "主导航",
  "chat.pluginsMyPlugins": "我的插件",
  "chat.pluginsSearchPlaceholder": "搜索插件…",
  "chat.skillsSearchPlaceholder": "搜索技能…",
  "chat.example1Title": "编辑风路演 PPT",
  "chat.example1Tag": "杂志",
  "chat.example1Prompt":
    "为一家正在融种子轮的设计工作室制作 10 张编辑风路演 PPT —— 瑞士网格布局，超大号衬线标题加粗体首字下沉，等宽字体的章节编号，留白充足，整页大图与文字密集页穿插出现。封面、愿景、市场、产品、增长、团队、融资诉求、联系方式。",
  "chat.example2Title": "SaaS 分析仪表盘",
  "chat.example2Tag": "数据",
  "chat.example2Prompt":
    "为一款面向开发者的 SaaS 设计一份信息密度高的分析仪表盘 —— 顶部 KPI 条带（含周环比变化）、两张堆叠折线图（MRR 与活跃工作区）、全球使用热力图、留存矩阵、客户排行榜以及实时事件流。深色主题，等宽数字，迷你图作为点缀。",
  "chat.example3Title": "长滚动年度报告",
  "chat.example3Tag": "编辑",
  "chat.example3Prompt":
    "为一家关注气候议题的非营利机构制作互动式年度报告 —— 长滚动编辑式布局，混合大段引言区块、数据可视化（堆叠柱状图、动态计数器、项目地点分布的等值线地图）、摄影分隔页、捐赠者墙，以及最终行动号召。现代衬线正文、无衬线图表标签、大地纸张配色。",
  'home.recommendation.eyebrow': '为你推荐',
  'home.recommendation.primaryCta': '开始创作',
  'home.recommendation.change': '换一换',
  'home.recommendation.browseAll': '全部类型',
  'home.recommendation.defaultProjectName': '新建项目',
  'home.recommendation.startFailed': '无法开始创建，请重试。',
  'studio.firstArtifactHint.title': '你的第一个设计已就绪',
  'studio.firstArtifactHint.body': '试试直接编辑和标注，满意后随时导出分享。',
  'studio.firstArtifactHint.dismiss': '知道了',
  'home.starter.product_ui_prototype.title': '从可编辑的产品原型开始',
  'home.starter.product_ui_prototype.desc': '基于你的目标，从一个可点击、可反复打磨的界面开始。',
  'home.starter.product_ui_prototype.firstPrompt': '为 [你的产品] 设计一个可编辑的产品原型，包含关键页面和清晰的核心流程。',
  'home.starter.product_ui_component.title': '从可复用组件开始',
  'home.starter.product_ui_component.desc': '先做一个组件，再把它组合成完整页面。',
  'home.starter.product_ui_component.firstPrompt': '设计一个可复用的 [组件名称] 组件，包含它的主要状态和变体。',
  'home.starter.product_ui_lowfi.title': '从低保真原型开始',
  'home.starter.product_ui_lowfi.desc': '先勾勒结构，再逐步提升保真度。',
  'home.starter.product_ui_lowfi.firstPrompt': '为 [你的产品] 制作主要页面的低保真线框图。',
  'home.starter.marketing_landing.title': '从落地页开始',
  'home.starter.marketing_landing.desc': '把你的营销活动变成一个可直接上线的落地页。',
  'home.starter.marketing_landing.firstPrompt': '为 [你的产品] 设计一个落地页，包含主视觉、核心卖点和清晰的行动号召。',
  'home.starter.marketing_multivariant.title': '从多个落地页版本开始',
  'home.starter.marketing_multivariant.desc': '在确定方案前，先生成几个版本进行对比。',
  'home.starter.marketing_multivariant.firstPrompt': '为 [你的产品] 制作 3 个落地页版本，采用不同的主视觉文案以便对比。',
  'home.starter.internal_dashboard.title': '从内部仪表盘开始',
  'home.starter.internal_dashboard.desc': '从贴合你工作流程的仪表盘布局开始。',
  'home.starter.internal_dashboard.firstPrompt': '设计一个内部仪表盘，展示 [关键指标]，并配有筛选器和数据表格。',
  'home.starter.internal_report.title': '从报表开始',
  'home.starter.internal_report.desc': '描述你想看到的数据和字段。',
  'home.starter.internal_report.firstPrompt': '制作一个报表页面，汇总 [描述你关心的数据、字段和指标]。',
  'home.starter.ministry_versiculo.title': 'Start with a verse card',
  'home.starter.ministry_versiculo.desc': 'A card with the text large and legible, in your own brand colours.',
  'home.starter.ministry_versiculo.firstPrompt': 'Create a verse card for the feed with [verse reference], large legible type, at 1080×1080.',
  'home.starter.ministry_evento.title': 'Start with an event announcement',
  'home.starter.ministry_evento.desc': 'The invitation artwork with date, time and place up front.',
  'home.starter.ministry_evento.firstPrompt': 'Create the announcement artwork for [event name] with date, time, address and the logo, at 1080×1080.',
  'home.starter.ministry_carrossel.title': 'Start with a carousel',
  'home.starter.ministry_carrossel.desc': 'A sequence of screens that opens on the hook and closes on the invitation.',
  'home.starter.ministry_carrossel.firstPrompt': 'Create a 5-screen carousel about [topic], opening with a hook and closing with a clear invitation.',
  'home.starter.ministry_reels.title': 'Start with a sermon cut',
  'home.starter.ministry_reels.desc': 'A short vertical clip with captions burned in.',
  'home.starter.ministry_reels.firstPrompt': 'Create a 30-second vertical cut from [the sermon excerpt], with on-screen captions and the preacher name.',
  'home.starter.ministry_louvor.title': 'Start with worship artwork',
  'home.starter.ministry_louvor.desc': 'The lyric the church is singing, sized for the feed.',
  'home.starter.ministry_louvor.firstPrompt': 'Create artwork with a lyric excerpt from [song], high contrast and readable on a phone.',
  'home.starter.ministry_serie.title': 'Start with a series cover',
  'home.starter.ministry_serie.desc': 'The campaign identity, ready to carry the pieces that follow.',
  'home.starter.ministry_serie.firstPrompt': 'Create the cover for the [series name] series with room for the title, the subtitle and the dates it runs.',
  'home.starter.ministry_avisos.title': 'Start with the weekly announcements',
  'home.starter.ministry_avisos.desc': 'The whole schedule in one piece, legible from a distance.',
  'home.starter.ministry_avisos.firstPrompt': 'Create the weekly announcements artwork with [the announcements], each with day, time and place.',
  'home.starter.ministry_site.title': 'Start with the ministry site',
  'home.starter.ministry_site.desc': 'A page with the essentials: who you are, where you meet and how to join.',
  'home.starter.ministry_site.firstPrompt': 'Create a page for [ministry name] with an introduction, meeting times, address and a way to get in touch.',
  'home.starter.ministry_projecao.title': 'Start with the service slides',
  'home.starter.ministry_projecao.desc': 'High-contrast screens built for the projector.',
  'home.starter.ministry_projecao.firstPrompt': 'Create the projection slides for the [day] service with [the verse or the lyric], one idea per screen and high contrast.',
  'home.starter.ministry_identidade.title': 'Start with the visual identity',
  'home.starter.ministry_identidade.desc': 'Colours, type and logo gathered for every piece that follows.',
  'home.starter.ministry_identidade.firstPrompt': 'Build the visual identity for [ministry name] with a colour palette, typography and logo usage.',
  'home.starter.general_menu.title': '从你的第一个项目开始',
  'home.starter.general_menu.desc': '描述你想要的内容，我们会生成一个可编辑的初始版本。',
  'home.starter.general_menu.firstPrompt': '为 [描述你想制作的内容] 生成一个可编辑的初始版本。',
  "chat.example4Title": "产品动效视频",
  "chat.example4Tag": "视频",
  "chat.example4Prompt":
    "为一款生产力 App 发布制作 15 秒动效视频分镜：开场钩子、UI 局部特写、动态排版、功能转场、结尾 logo 和 CTA。请写清时间轴、镜头描述、转场方式、画面文案和节奏感。",
  "preview.usePlugin": "使用插件",
  "preview.usePluginOnly": "不带提示词使用",
  "preview.usePluginOnlyDesc": "使用插件结构，但不加载示例提示词",
  "preview.replicateContent": "使用",
  "preview.replicateContentDesc": "使用示例提示词复现预览",
  "preview.duplicateTemplate": "Remix",
  "preview.duplicateTemplateDesc": "将这个示例 Remix 成可编辑的新项目",
  "preview.shareMenu": "分享",
  "preview.exportMenu": "导出",
  "preview.shareTemplateBadge": "模板",
  "preview.shareToX": "X / Twitter",
  "preview.shareToReddit": "Reddit",
  "preview.shareToFacebook": "Facebook",
  "preview.shareToLinkedIn": "LinkedIn",
  "preview.shareToInstagram": "Instagram",
  "preview.shareToXiaohongshu": "小红书",
  "preview.copyTemplateLink": "复制模板链接",
  "preview.copyShareText": "复制分享文案",
  "preview.shareSocialGroup": "分享到社媒",
  "preview.shareCopyGroup": "复制",
  "preview.shareExportGroup": "导出文件",
  "preview.shareCopied": "已复制",
  "preview.shareCopyFailed": "复制失败",
  "preview.shareTextDefault": "Crie3 模板：{title}",
  "preview.openInNewTab": "在新标签页中打开",
  "preview.exit": "⤓ 退出",
  "preview.fullscreen": "⤢ 全屏",
  "preview.closeTitle": "关闭（Esc）",
  "preview.loading": "正在加载{label}…",
  "preview.errorTitle": "无法加载此示例。",
  "preview.errorBody":
    "示例 HTML 加载失败。请确认 Crie3 正在运行后重试。",
  "preview.retry": "重试",
  "preview.unavailableTitle": "{noun}暂未附带预览样例。",
  "preview.unavailableBody": "请在对话中运行此 Prompt 来生成 {kind} 产物。",
  "preview.nounSkill": "此技能",
  "preview.nounPlugin": "此插件",
  "preview.nounTemplate": "此模板",
  "preview.showSidebar": "展开{label}",
  "preview.hideSidebar": "收起{label}",
  "misc.savedTemplate": "已保存的模板",
  "misc.primary": "主体系",
  "misc.designSystem": "设计体系",
  "workspace.designFiles": "设计文件",
  "workspace.focusMode": "专注工作区",
  "workspace.showChat": "显示聊天",
  "workspace.hideChat": "隐藏对话",
  "workspace.closeTab": "关闭标签页",
  "workspace.deleteFileConfirm": "从项目文件夹中删除「{name}」？",
  "workspace.deleteSelectedFilesConfirm":
    "从项目文件夹中删除选中的 {n} 个文件？",
  "workspace.deleteSelectedFilesPartial": "有 {n} 个文件删除失败。",
  "workspace.openFromDesignFiles": "请从",
  "workspace.designFilesLink": "设计文件",
  "workspace.loadingSketch": "正在加载草图…",
  "workspace.newTab": "新建标签页",
  "workspace.tabsBarAria": "Crie3 标签页",
  "workspace.openTabsAria": "已打开的标签页",
  "workspace.searchFilesPlaceholder": "搜索标签页或文件…",
  "workspace.openTabs": "打开标签页",
  "workspace.openFile": "打开文件",
  "workspace.noFilesMatch": "没有匹配的文件",
  "workspace.allFiles": "全部",
  "workspace.createNew": "新建",
  "workspace.tabOpen": "已打开",
  "workspace.sideChatContextBanner": "已集成当前会话上下文",
  "workspace.sideChatDefaultTitle": "侧边对话",
  "workspace.newTerminal": "新建终端",
  "workspace.newTerminalDescription": "在新标签页中打开项目目录的终端",
  "workspace.newBrowser": "新建浏览器",
  "workspace.newBrowserDescription":
    "在新标签页中打开内置浏览器，用于参考站点和设计研究",
  "workspace.newSketchDescription":
    "绘制粗略布局和标注，作为 agent 的设计上下文",
  "workspace.terminalStarting": "正在启动项目终端…",
  "workspace.terminalStartingDescription": "正在连接项目目录，通常只需几秒。",
  "workspace.terminalSessionEnded": "会话已结束",
  "workspace.terminalReconnecting": "正在重新连接…",
  "workspace.terminalStartFailed": "无法启动终端会话",
  "workspace.terminalRestart": "重新启动",
  "workspace.browserTab": "Browser",
  "workspace.browserTabNumbered": "Browser {n}",
  "workspace.uploadFailed": "Upload failed for {count} file(s){detail}.",
  "workspace.uploadFailedDetail": "Upload failed for {count} file(s) ({detail}).",
  "workspace.uploadPartialFailed": "Uploaded {uploaded} file(s), but {failed} failed{detail}.",
  "workspace.renamePendingSketchConflict": "A pending sketch named \"{name}\" is already open. Save or close it before renaming.",
  "memory.storagePathCopy": "Memory storage path — click to copy",
  "memory.advanced": "Advanced",
  "memory.advancedHint": "Inspect or edit the underlying memory index.",
  "memory.flowOnboarding": "Onboarding",
  "memory.flowBrandContext": "Brand context",
  "memory.flowChatSignals": "Chat signals",
  "memory.howCopy": "Memory is gathered automatically from profile setup, project and brand extraction, connected apps, and useful facts learned during chats. The saved list below is the review surface; everything else stays quiet unless you open Add or Advanced.",
  "memory.areasAria": "Memory areas",
  "memory.addManually": "Add manually",
  "memory.addManuallyCaption": "Write a fact or preference",
  "memory.addManuallyHint": "Add facts, preferences, or project context yourself. Fixed assistant behavior lives in Instructions / Rules.",
  "memory.importFromApps": "Import from apps",
  "memory.importFromAppsCaption": "Scan connected tools",
  "memory.importFromAppsHint": "Choose apps to scan for design preferences, project context, and visual references. Nothing is scanned until you select an app.",
  "memory.loading": "Loading",
  "memory.connectedCount": "{count} connected",
  "memory.manage": "Manage",
  "memory.chooseSources": "Choose sources",
  "memory.chooseSourcesHint": "Select connected apps first. Crie3 only scans the apps you choose.",
  "memory.selectedCount": "{count} selected",
  "memory.connectorListAria": "Connected memory apps",
  "memory.connectorReadTools": "{count} read tools",
  "memory.connectorCheckingStatus": "Checking connection status…",
  "memory.connectorAuthPending": "Finish authorization in your browser, then return here",
  "memory.connectorNotConnected": "Connect this app before extraction",
  "memory.connectorUseForExtraction": "Use {name} for memory extraction",
  "memory.selected": "Selected",
  "memory.select": "Select",
  "memory.connectAria": "Connect {name}",
  "memory.reconnectAria": "Reconnect {name}",
  "memory.checking": "Checking",
  "memory.waiting": "Waiting",
  "memory.connecting": "Connecting",
  "memory.reconnect": "Reconnect",
  "memory.connect": "Connect",
  "memory.selectedOfConnectedOne": "Selected {selected} of {total} connected app.",
  "memory.selectedOfConnectedOther": "Selected {selected} of {total} connected apps.",
  "memory.scanningApps": "Scanning apps",
  "memory.selectAppsToScan": "Select apps to scan",
  "memory.scanSelectedApps": "Scan selected apps",
  "memory.suggestedMemories": "Suggested memories",
  "memory.suggestedMemoriesHint": "Review design-related memories before saving them.",
  "memory.suggestionSourceFallback": "Connected apps",
  "memory.saving": "Saving",
  "memory.saveSelected": "Save selected",
  "memory.discard": "Discard",
  "memory.diagnosticsAria": "Connected app read status",
  "memory.lastScan": "Last scan",
  "memory.bytesRead": "{size} read",
  "memory.noData": "No data",
  "memory.recentScans": "Recent scans",
  "memory.runHistoryAria": "Connected app memory run status",
  "memory.attemptRead": "Read {name}",
  "memory.attemptFailed": "Could not read {name}",
  "memory.attemptSkipped": "Skipped {name}",
  "memory.savedMemory": "Saved memory",
  "memory.savedMemoryHint": "Saved facts, preferences, and project context available to future chats.",
  "memory.savedCount": "{count} saved",
  "memory.extractionCountOne": "{count} extraction",
  "memory.extractionCountOther": "{count} extractions",
  "memory.emptyHintBefore": "Tell the assistant a fact in chat — e.g.",
  "memory.emptyHintExample": "I prefer dark mode",
  "memory.emptyHintAfter": "— and it will be saved here automatically.",
  "memory.memoryTree": "Memory tree",
  "memory.memoryTreeHint": "Technical view of the same saved memories. Most users only need the saved-memory list above.",
  "memory.nodeCountOne": "{count} node",
  "memory.nodeCountOther": "{count} nodes",
  "designFiles.title": "设计文件",
  "designFiles.upload": "上传文件",
  "designFiles.pasteText": "粘贴为文本文件",
  "designFiles.newSketch": "新建草图",
  "designFiles.empty": "生成的设计会出现在这里",
  "designFiles.refresh": "刷新",
  "designFiles.delete": "删除",
  "designFiles.searchPlaceholder": "搜索文件…",
  "designFiles.up": "上一级",
  "designFiles.back": "返回",
  "designFiles.crumbs": "项目",
  "designFiles.rowMenu": "行菜单",
  "designFiles.openInTab": "在标签页中打开",
  "designFiles.download": "下载",
  "designFiles.downloadSelected": "下载选中的 {n} 个文件为 ZIP",
  "designFiles.deleteSelected": "删除 {n} 个",
  "designFiles.clearSelection": "取消选择",
  "designFiles.selectPage": "全选此页",
  "designFiles.selectAll": "全选",
  "designFiles.dropTitle": "⤓ 把文件拖到这里",
  "designFiles.dropDesc":
    "图片、文档、参考资料或文件夹 — 智能体都会用作上下文。",
  "designFiles.dropLabel": "拖拽文件到这里",
  "designFiles.upload.title": "上传文件",
  "designFiles.paste.title": "创建文档",
  "designFiles.upload.label": "上传",
  "designFiles.paste.label": "创建文档",
  "designFiles.documentTemplate.titleFallback": "文档",
  "designFiles.documentTemplate.goalHeading": "目标",
  "designFiles.documentTemplate.goalBody":
    "说明希望 Crie3 基于这份文档生成、修改或判断什么。",
  "designFiles.documentTemplate.capabilitiesHeading": "如何使用这份文档",
  "designFiles.documentTemplate.capabilityMarkdown":
    "可以自由使用 Markdown：标题、表格、清单、链接、引用、代码块和图片。",
  "designFiles.documentTemplate.capabilityAgent":
    "Crie3 agent 可以读取、编辑这份文件，并把它作为项目上下文。",
  "designFiles.documentTemplate.capabilityImages":
    "可以粘贴图片，或把图片拖到编辑器里；上传后的图片会插入到当前光标位置。",
  "designFiles.documentTemplate.scenarioHeading": "场景说明",
  "designFiles.documentTemplate.scenario.prototype":
    "做原型时，写清楚产品目标、目标用户、流程、页面、模块、交互状态、响应式断点，以及颜色、字体、间距、圆角、动效等 design tokens。",
  "designFiles.documentTemplate.scenario.wireframe":
    "做线框图时，描述用户流程、页面清单、布局层级、内容区块、低保真约束，以及视觉设计前需要验证的问题。",
  "designFiles.documentTemplate.scenario.mobile":
    "做移动应用时，列出目标平台、页面、导航模型、手势、原生模式、设备尺寸、状态和移动端 design tokens。",
  "designFiles.documentTemplate.scenario.slideDeck":
    "做幻灯片时，写成分页 PPT 大纲：每页包含标题、目的、核心信息、证据、视觉方向、讲稿备注和导出要求。",
  "designFiles.documentTemplate.scenario.document":
    "做文档时，定义受众、语气、章节结构、资料来源、引用或数据、版式预期和 PDF/导出要求。",
  "designFiles.documentTemplate.scenario.image":
    "做图片时，说明主体、比例、构图、视觉风格、品牌 tokens、参考文件和负向约束。",
  "designFiles.documentTemplate.scenario.video":
    "做视频时，写出分镜：场景、时长、字幕、动效、素材、音频备注和输出格式。",
  "designFiles.documentTemplate.scenario.hyperframes":
    "做 HyperFrames 时，描述 HTML 动态内容：场景、时间线、字幕、音频响应点、转场和录制/导出要求。",
  "designFiles.documentTemplate.scenario.audio":
    "做音频时，定义人声或音乐方向、时长、情绪、脚本或文案、节奏、发音备注和最终用途。",
  "designFiles.documentTemplate.scenario.liveArtifact":
    "做实时看板时，说明数据源、刷新频率、组件、筛选、交互、空/加载/错误状态，以及提醒或自动化要求。",
  "designFiles.documentTemplate.scenario.designSystem":
    "做设计系统时，列出品牌目标、tokens、字体、颜色、间距、组件、素材、参考和需要遵守/避免的规则。",
  "designFiles.documentTemplate.scenario.default":
    "描述受众、交付物、必需内容、参考、约束，以及什么状态算完成。",
  "designFiles.documentTemplate.nextHeading": "下一步",
  "designFiles.documentTemplate.nextBody":
    "检查并编辑这份文档，然后让 Crie3 基于它生成、修改或执行操作。",
  "designFiles.previewOpen": "打开",
  "designFiles.previewClose": "关闭预览",
  "designFiles.modified": "修改于 {time} · {size}",
  "designFiles.weeksAgo": "{n} 周前",
  "designFiles.groupBy": "分组方式",
  "designFiles.groupByKind": "类型",
  "designFiles.groupByModified": "修改时间",
  "designFiles.filterBy": "按类型筛选",
  "designFiles.filterClear": "清除",
  "designFiles.filterCount": "{n} 种类型",
  "designFiles.expandGroup": "展开",
  "designFiles.collapseGroup": "折叠",
  "designFiles.sectionPages": "页面",
  "designFiles.sectionScripts": "脚本",
  "designFiles.sectionImages": "图片",
  "designFiles.sectionSketches": "草图",
  "designFiles.sectionLiveArtifacts": "实时看板",
  "designFiles.sectionOther": "其它",
  "designFiles.modifiedToday": "今天",
  "designFiles.modifiedYesterday": "昨天",
  "designFiles.modifiedPrevious7Days": "最近 7 天",
  "designFiles.modifiedPrevious30Days": "最近 30 天",
  "designFiles.modifiedOlder": "更早",
  "designFiles.showMore": "再显示 {n} 个",
  "designFiles.kindHtml": "HTML 页面",
  "designFiles.kindImage": "图片",
  "designFiles.kindSketch": "草图",
  "designFiles.kindText": "文本",
  "designFiles.kindCode": "脚本",
  "designFiles.kindPdf": "PDF",
  "designFiles.kindDocument": "文档",
  "designFiles.kindPresentation": "演示文稿",
  "designFiles.kindSpreadsheet": "电子表格",
  "designFiles.kindLiveArtifact": "实时看板",
  "designFiles.kindBinary": "二进制",
  "designFiles.kindFolder": "文件夹",
  "designFiles.folderCount": "{n} 个文件",
  "designFiles.newFolderTitle": "新建文件夹",
  "designFiles.newFolderLabel": "文件夹名称",
  "designFiles.moveTitle": "移动到文件夹",
  "designFiles.moveLabel": "目标文件夹",
  "designFiles.moveRoot": "项目根目录",
  "designFiles.moveNewFolder": "新建文件夹…",
  "designFiles.move": "移动",
  "designFiles.copyPath": "复制文件地址",
  "designFiles.copiedPath": "已复制路径",
  "designFiles.copyLocalPath": "复制本地文件路径",
  "designFiles.copiedLocalPath": "已复制本地文件路径",
  "designFiles.deleteFolderConfirm": "删除文件夹「{name}」及其全部内容?",
  "designFiles.folderCreated": "已创建文件夹「{name}」",
  "designFiles.folderDeleted": "已删除文件夹「{name}」",
  "designFiles.filesMoved": "已移动 {n} 项到 {dest}",
  "designFiles.colName": "名称",
  "designFiles.colKind": "类型",
  "designFiles.colModified": "修改时间",
  "designFiles.perPage": "显示",
  "designFiles.all": "全部",
  "designFiles.prev": "上一页",
  "designFiles.next": "下一页",
  "designFiles.jumpToPage": "跳转到页面",
  "designFiles.pageInfo": "{start}–{end} / {total}",
  "designFiles.sectionFolders": "文件夹",
  "designFiles.sectionStylesheets": "样式表",
  "designFiles.sectionDocuments": "文档",
  "designFiles.kindStylesheet": "样式表",
  "designFiles.modifiedExt": "修改于 {time} · {size} · {ext}",
  "designFiles.usefulInfoLabel": "使用提示",
  "designFiles.usefulInfoTip": "双击任意文件可在独立标签页中打开。",
  "designFiles.usefulInfoTip2": "在聊天中输入 @ 即可把文件引用为上下文。",
  "designFiles.usefulInfoTip4":
    "选好设计系统再生成，结果会与品牌风格保持一致。",
  "designFiles.usefulInfoTip5":
    "没有想法？试试首页 Community 的插件模板，一键生成同款。",
  "designFiles.usefulInfoTip9":
    "把图片、文档甚至整个文件夹拖到当前面板，智能体都会用作上下文。",
  "designFiles.usefulInfoTip10":
    "点「新建草图」手绘一个布局，让智能体照着生成。",
  "designFiles.usefulInfoTip11":
    "在预览中圈选任意元素发表评论，智能体会针对性修改。",
  "designFiles.usefulInfoTip12": "生成结果不满意？直接圈选标注比重新描述更快。",
  "designFiles.usefulInfoTip13": "设计可以一键导出为 PDF、图片或独立 HTML。",
  "designFiles.usefulInfoTip14":
    "满意的项目可通过「分享」菜单保存为模板，下次直接复用。",
  "designFiles.usefulInfoTip15": "部署后可以直接生成社媒分享卡片。",
  "quickSwitcher.placeholder": "打开标签页或文件…",
  "quickSwitcher.empty": "此项目中没有文件",
  "quickSwitcher.noMatches": "无匹配项",
  "quickSwitcher.navigate": "导航",
  "quickSwitcher.open": "打开",
  "quickSwitcher.close": "关闭",
  "pasteDialog.title": "粘贴文本",
  "pasteDialog.hint": "将保存到项目文件夹中，名称随你定。",
  "pasteDialog.fileNameLabel": "文件名",
  "pasteDialog.namePlaceholder": "notes.txt",
  "pasteDialog.contentLabel": "内容",
  "pasteDialog.contentPlaceholder": "在此粘贴任何内容…",
  "pasteDialog.save": "保存",
  "pasteDialog.cancel": "取消",
  "sketch.save": "保存草图",
  "sketch.cancel": "取消",
  "sketch.saving": "保存中…",
  "sketch.saved": "已保存",
  "sketch.tooltipMainMenu": "主菜单：保存、导出、帮助和画布设置",
  "sketch.tooltipLock": "锁定当前工具，连续绘制同一种元素",
  "sketch.tooltipHand": "抓手工具：拖动画布视图，不选择元素",
  "sketch.tooltipSelection": "选择工具：选中、移动、缩放或编辑画布元素",
  "sketch.tooltipRectangle": "矩形工具：绘制矩形或卡片区域",
  "sketch.tooltipDiamond": "菱形工具：绘制判断节点或分支结构",
  "sketch.tooltipEllipse": "椭圆工具：绘制圆形或椭圆",
  "sketch.tooltipArrow": "箭头工具：绘制方向关系或流程连接",
  "sketch.tooltipLine": "直线工具：绘制分隔线或简单连接线",
  "sketch.tooltipFreedraw": "手绘工具：自由绘制线条",
  "sketch.tooltipText": "文本工具：在画布上添加可编辑文字",
  "sketch.tooltipImage": "图片工具：插入图片素材",
  "sketch.tooltipEraser": "橡皮擦：删除画布上的元素",
  "sketch.tooltipFrame": "框架工具：把一块画布区域组织成框架",
  "sketch.tooltipEmbeddable": "Web 嵌入仅支持有效的 https:// 或 http:// 链接",
  "sketch.tooltipLaser": "激光笔：临时指示画布内容，不修改元素",
  "sketch.tooltipMoreTools": "更多工具：打开框架、Web 嵌入、激光笔等工具",
  "sketch.tooltipDirty": "尚未保存",
  "sketch.tooltipClean": "已保存",
  "fileViewer.empty": "请选择一个文件查看。",
  "fileViewer.loading": "加载中…",
  "fileViewer.exportPptx": "导出为 PPTX",
  "fileViewer.openInNewTab": "在新标签页中打开",
  "fileViewer.copyPath": "复制路径",
  "fileViewer.copied": "已复制！",
  "fileViewer.share": "分享",
  "fileViewer.binaryMeta": "二进制 · {size}",
  "fileViewer.binaryNote":
    "二进制文件（{size} 字节）。请下载或在本地打开查看。",
  "fileViewer.pdfMeta": "PDF · {size}",
  "fileViewer.documentMeta": "文档",
  "fileViewer.presentationMeta": "演示文稿",
  "fileViewer.spreadsheetMeta": "电子表格",
  "fileViewer.previewUnavailable": "无法生成预览，请下载或打开文件查看。",
  "fileViewer.download": "下载",
  "fileViewer.open": "打开",
  "fileViewer.imageMeta": "图片 · {size}",
  "fileViewer.reactMeta": "React 组件 · {size}",
  "fileViewer.sketchMeta": "草图 · {size}",
  "fileViewer.markdownStreamingMeta": "正在流式预览…",
  "fileViewer.markdownErrorMeta": "预览可能不完整（生成错误）。",
  "fileViewer.markdownStreamingStatus": "正在流式生成…显示部分 Markdown。",
  "fileViewer.markdownErrorStatus": "生成错误。正在显示最后可用内容。",
  "fileViewer.markdownSaving": "保存中...",
  "fileViewer.markdownSaveFailed": "保存失败",
  "fileViewer.markdownSaved": "已保存",
  "fileViewer.markdownAutoSaved": "已自动保存 · {time}",
  "fileViewer.markdownAutoSaveHint": "自动保存已开启",
  "fileViewer.markdownViewMode": "Markdown 视图模式",
  "fileViewer.split": "分栏",
  "fileViewer.markdownEditor": "Markdown 编辑器",
  "fileViewer.markdownEditorPlaceholder": "输入这份文档的备注、需求或说明...",
  "fileViewer.markdownPreview": "Markdown 预览",
  "fileViewer.videoMeta": "视频 · {size}",
  "fileViewer.audioMeta": "音频 · {size}",
  "fileViewer.reload": "重新加载",
  "fileViewer.reloadDisk": "从磁盘重新加载",
  "fileViewer.copy": "复制",
  "fileViewer.copyTitle": "复制文件内容",
  "fileViewer.saveDisabled": "保存（只读预览）",
  "fileViewer.save": "保存",
  "fileViewer.preview": "预览",
  "fileViewer.source": "代码",
  "fileViewer.tweaks": "调整",
  "fileViewer.tweaksUnavailable": "此作品中没有调整面板",
  "fileViewer.jsxModuleTitle": "无独立预览",
  "fileViewer.jsxModuleBody": "此文件是由其他页面加载的组件模块。",
  "fileViewer.jsxModuleCta": "请打开渲染它的页面：",
  "fileViewer.comment": "注释",
  "fileViewer.edit": "编辑",
  "fileViewer.draw": "绘制",
  "fileViewer.mark": "标记",
  "fileViewer.markTool": "标记工具",
  "fileViewer.boxSelect": "框选",
  "fileViewer.textTool": "文本",
  "fileViewer.textAnnotationRemove": "删除文本",
  "fileViewer.screenshot": "截图",
  "manualEdit.layers": "图层",
  "manualEdit.editableCount": "{count} 个可编辑元素",
  "manualEdit.hiddenBadge": "隐藏",
  "manualEdit.title": "手动编辑器",
  "manualEdit.fallbackTitle": "编辑",
  "manualEdit.movePanel": "移动编辑面板",
  "manualEdit.editParams": "编辑参数",
  "manualEdit.closePanel": "关闭编辑面板",
  "manualEdit.selectLayer": "选择图层",
  "manualEdit.empty": "在预览中点击元素,或选择一个图层。",
  "manualEdit.noEditableLayers": "未找到可编辑图层。",
  "manualEdit.noClass": "无类名",
  "manualEdit.tabsAria": "手动编辑选项卡",
  "manualEdit.tabContent": "内容",
  "manualEdit.tabStyle": "样式",
  "manualEdit.tabAttributes": "属性",
  "manualEdit.tabHtml": "HTML",
  "manualEdit.tabSource": "源码",
  "manualEdit.attributesJson": "属性 JSON",
  "manualEdit.selectedHtml": "选中元素的 HTML",
  "manualEdit.fullSource": "完整作品源码",
  "manualEdit.applyContent": "应用内容",
  "manualEdit.applyStyle": "应用样式",
  "manualEdit.applyAttributes": "应用属性",
  "manualEdit.applyHtml": "应用 HTML",
  "manualEdit.applySource": "应用源码",
  "manualEdit.invalidAttributes": "属性 JSON 格式无效。",
  "manualEdit.changes": "修改记录",
  "manualEdit.undo": "撤销",
  "manualEdit.redo": "重做",
  "manualEdit.noChanges": "尚未进行手动修改。",
  "manualEdit.imageUrl": "图片 URL",
  "manualEdit.altText": "替代文本",
  "manualEdit.label": "标签",
  "manualEdit.text": "文本",
  "manualEdit.href": "链接地址",
  "manualEdit.textColor": "文本颜色",
  "manualEdit.background": "背景",
  "manualEdit.fontSize": "字号",
  "manualEdit.weight": "字重",
  "manualEdit.align": "对齐方式",
  "manualEdit.padding": "内边距",
  "manualEdit.margin": "外边距",
  "manualEdit.radius": "圆角",
  "manualEdit.border": "边框",
  "manualEdit.width": "宽度",
  "manualEdit.minHeight": "最小高度",
  "manualEdit.deleteElement": "删除元素",
  "manualEdit.deleteElementConfirm": "删除选中元素？可以使用撤销恢复。",
  "manualEdit.uploadImage": "上传图片",
  "manualEdit.uploadingImage": "正在上传图片…",
  "manualEdit.uploadImageFailed": "无法上传图片。",
  "manualEdit.focusSlides": "聚焦幻灯片",
  "manualEdit.showPanels": "显示面板",
  "manualEdit.sectionContent": "CONTENT",
  "manualEdit.sectionImage": "IMAGE",
  "manualEdit.sectionPage": "PAGE",
  "manualEdit.sectionTypography": "TYPOGRAPHY",
  "manualEdit.sectionSize": "SIZE",
  "manualEdit.sectionLayout": "LAYOUT",
  "manualEdit.sectionBox": "BOX",
  "manualEdit.font": "Font",
  "manualEdit.size": "Size",
  "manualEdit.color": "Color",
  "manualEdit.line": "Line",
  "manualEdit.tracking": "Tracking",
  "manualEdit.height": "Height",
  "manualEdit.gap": "Gap",
  "manualEdit.direction": "Direction",
  "manualEdit.justify": "Justify",
  "manualEdit.fill": "Fill",
  "manualEdit.opacity": "Opacity",
  "manualEdit.borderStyle": "Style",
  "manualEdit.baseSize": "Base size",
  "manualEdit.pageStylesUnavailable": "Page styles are available only for full HTML documents.",
  "manualEdit.targetContainer": "Container",
  "manualEdit.targetImage": "Image",
  "manualEdit.targetLink": "Link",
  "manualEdit.targetText": "Text",
  "manualEdit.pickColor": "Pick {label}",
  "manualEdit.decrease": "{label} decrease",
  "manualEdit.increase": "{label} increase",
  "fileViewer.zoomOut": "缩小",
  "fileViewer.zoomIn": "放大",
  "fileViewer.resetZoom": "重置缩放",
  "fileViewer.viewportAria": "预览视口",
  "fileViewer.viewportDesktop": "桌面端",
  "fileViewer.viewportDesktopTitle": "全宽桌面预览",
  "fileViewer.viewportTablet": "平板端",
  "fileViewer.viewportTabletTitle": "平板预览 820 × 1180(现代竖屏基线)",
  "fileViewer.viewportMobile": "移动端",
  "fileViewer.viewportMobileTitle": "移动端预览 390 × 844",
  "fileViewer.reloadAria": "重新加载",
  "fileViewer.previousSlide": "上一张",
  "fileViewer.nextSlide": "下一张",
  "fileViewer.slideNavAria": "幻灯片导航",
  "fileViewer.speakerNotes": "演讲者备注",
  "fileViewer.speakerNotesSlide": "第 {current} / {total} 页",
  "fileViewer.speakerNotesEmpty": "这一页还没有演讲者备注。",
  "fileViewer.speakerNotesEdit": "编辑",
  "fileViewer.speakerNotesSave": "保存备注",
  "fileViewer.speakerNotesSaving": "保存中...",
  "fileViewer.speakerNotesSaved": "已保存",
  "fileViewer.speakerNotesSaveFailed": "无法保存演讲者备注。",
  "fileViewer.speakerNotesPlaceholder": "为这一页添加演讲者备注...",
  "fileViewer.presenterReset": "重置",
  "fileViewer.present": "演示",
  "fileViewer.presentInTab": "在当前标签页",
  "fileViewer.presentFullscreen": "全屏",
  "fileViewer.presentNewTab": "新标签页",
  "fileViewer.exitPresentation": "退出演示",
  "fileViewer.shareLabel": "分享",
  "fileViewer.shareMenuShareLink": "分享",
  "fileViewer.shareMenuPublishOnline": "发布到线上",
  "fileViewer.shareMenuDownload": "下载",
  "fileViewer.shareMenuPresentation": "演示文稿",
  "fileViewer.shareMenuSourceFiles": "源文件",
  "fileViewer.shareMenuSave": "保存",
  "fileViewer.copyShareLink": "复制分享链接",
  "fileViewer.openSharePage": "打开分享页面",
  "fileViewer.shareLinkRequiresDeploy": "先发布到线上以获取链接",
  "fileViewer.shareLinkPublishGuide": "先发布线上，即可分享 ↑",
  "fileViewer.shareAfterGenerationComplete": "生成完成后可分享",
  "fileViewer.copyProviderLink": "复制 {provider} 链接",
  "fileViewer.copyCloudflareLink": "复制 Cloudflare 链接",
  "fileViewer.screenshotCopying": "正在复制截图…",
  "fileViewer.screenshotCopied": "截图已保存到剪贴板",
  "fileViewer.screenshotClipboardDenied": "浏览器拒绝写入剪贴板",
  "fileViewer.screenshotPreviewLoading": "预览还在加载，请稍后再试",
  "fileViewer.screenshotCaptureFailed": "无法截取预览，请重试",
  "fileViewer.exportPdf": "导出为 PDF",
  "fileViewer.exportPdfAllSlides": "导出为 PDF（全部幻灯片）",
  "fileViewer.exportPptxBusy": "请等待当前任务完成。",
  "fileViewer.exportPptxHint": "请求代理将此设计转换为 PPTX。",
  "fileViewer.exportPptxNa": "此处暂不支持导出 PPTX。",
  "fileViewer.exportZip": "下载为 .zip",
  "fileViewer.exportHtml": "导出为独立 HTML",
  "fileViewer.exportMd": "导出为 Markdown",
  "fileViewer.exportImage": "导出为图片",
  "fileViewer.exportVideo": "视频 (MP4)",
  "fileViewer.exportVideoOneCard": "视频只能从单张卡片录制。这个轮播有多张卡片，而 Instagram 每条帖子只接受一个视频。",
  "fileViewer.exportVideoNotAnimated": "这个作品没有任何动画，没有可录制的视频。请下载为图片。",
  "fileViewer.exportVideoFailed": "无法生成视频，请重试。",
  "fileViewer.exportVideoBusy": "正在生成其他作品，请稍等片刻再试。",
  "fileViewer.exportPptxImages": "导出为 PPTX（图片）",
  "fileViewer.exportPptxEditable": "导出为 PPTX（可编辑）",
  "fileViewer.exportPptxEditableHint": "原生可编辑形状与文字(非像素级还原)",
  "fileViewer.exportPptxModalSubtitle": "选择导出方式后点击导出。",
  "fileViewer.exportPptxScreenshot": "截图 PPTX",
  "fileViewer.exportPptxScreenshotHint":
    "每页一张图,像素级 100% 还原,但不可编辑。",
  "fileViewer.exportPptxConfirm": "导出",
  "fileViewer.exportPptxRecommended": "推荐",
  "fileViewer.exportingProgress": "正在导出…",
  "fileViewer.exportSlideProgress": "正在导出第 {current}/{total} 页…",
  "fileViewer.exportingElapsed": "正在导出… {seconds} 秒",
  "fileViewer.exportSlideEta":
    "正在导出第 {current}/{total} 页 · 约剩 {seconds} 秒",
  "fileViewer.exportFailed": "导出失败，请重试。",
  "fileViewer.exportDone": "导出完成",
  "fileViewer.exportImageFailed":
    "无法生成该作品的图片。请重试，或下载为 PDF。",
  "fileViewer.exportImageDegraded": "Downloaded a reduced version: without the photo you attached, and at screen size rather than the piece's own. Try again — if it repeats, tell us and we will look into it.",
  "fileViewer.exportImageModalSubtitle":
    "选择图片格式后，将当前预览下载为图片。",
  "fileViewer.exportImageFormatLabel": "格式",
  "fileViewer.exportImageSaving": "正在保存图片…",
  "fileViewer.exportImageSaved": "图片已保存",
  "fileViewer.exportImageDownloadStarted": "已开始下载",
  "fileViewer.exportImageDownloadDetails":
    "如果没有弹出保存窗口，请在浏览器下载目录中查看 {filename}。",
  "fileViewer.exportJsx": "导出为 JSX",
  "fileViewer.exportReactHtml": "导出预览 HTML",
  "fileViewer.exportStarted": "已开始导出",
  "fileViewer.saveAsTemplate": "保存为模板…",
  "fileViewer.savingTemplate": "正在保存模板…",
  "fileViewer.savedTemplate": "已保存为「{name}」",
  "fileViewer.savedTemplateFail": "保存模板失败，请重试。",
  "fileViewer.templateNamePrompt": "模板名称",
  "fileViewer.templateNameDefault": "未命名模板",
  "fileViewer.templateDescPrompt": "简短描述（可选 — 这个模板用于什么场景？）",
  "liveArtifact.refresh.button": "刷新",
  "liveArtifact.refresh.buttonTitle": "刷新此实时看板",
  "liveArtifact.refresh.loadingTitle": "正在加载实时看板…",
  "liveArtifact.refresh.noSourceTitle": "暂无可刷新来源。",
  "liveArtifact.refresh.running": "刷新中…",
  "liveArtifact.refresh.runningMessage":
    "正在刷新数据和预览，可能需要一点时间。",
  "liveArtifact.refresh.runningAction": "刷新成功前会继续显示上一次预览。",
  "liveArtifact.refresh.successOne": "刷新完成，数据已更新。",
  "liveArtifact.refresh.successMany": "刷新完成，数据已更新。",
  "liveArtifact.refresh.successAction": "预览已使用最新提交的数据重新加载。",
  "liveArtifact.refresh.previousFailure": "上次刷新失败：{message}",
  "liveArtifact.refresh.failureAction":
    "请检查「刷新历史」，修复来源或权限问题后重试。",
  "liveArtifact.refresh.networkFailure": "刷新请求失败。请检查网络连接后重试。",
  "liveArtifact.refresh.genericFailure": "刷新失败。",
  "liveArtifact.refresh.statusNever": "不可刷新",
  "liveArtifact.refresh.statusReady": "可刷新",
  "liveArtifact.refresh.statusSucceeded": "已是最新",
  "liveArtifact.refresh.statusFailed": "刷新失败",
  "liveArtifact.refresh.statusRunning": "正在刷新",
  "liveArtifact.refresh.statusRunningDescription": "刷新任务正在进行中。",
  "liveArtifact.refresh.statusSucceededDescription": "上次刷新已成功完成。",
  "liveArtifact.refresh.statusFailedDescription": "上次刷新未能成功完成。",
  "liveArtifact.refresh.statusReadyDescription":
    "已配置可刷新的数据源，但暂无正在进行的任务。",
  "liveArtifact.refresh.statusNeverDescription":
    "该实时看板尚未配置刷新数据源。",
  "liveArtifact.refresh.eventStarted": "已开始",
  "liveArtifact.refresh.eventSucceeded": "已成功",
  "liveArtifact.refresh.eventFailed": "失败",
  "liveArtifact.refresh.eventStartedDetail": "刷新已开始…",
  "liveArtifact.refresh.sourcesUpdatedOne": "已更新 {n} 个数据源",
  "liveArtifact.refresh.sourcesUpdatedMany": "已更新 {n} 个数据源",
  "liveArtifact.refresh.timelineEmpty":
    "本次会话还没有刷新记录。点击「刷新」即可记录时间线，或等待自动任务完成。",
  "liveArtifact.refresh.heroLastRefreshedLabel": "上次刷新",
  "liveArtifact.refresh.heroLastRefreshedNever": "从未",
  "liveArtifact.refresh.justNow": "刚刚",
  "liveArtifact.refresh.factCreated": "创建时间",
  "liveArtifact.refresh.factLastUpdated": "最后更新",
  "liveArtifact.refresh.factUnknown": "未知",
  "liveArtifact.refresh.persistedTitle": "持久化刷新记录",
  "liveArtifact.refresh.persistedHint": "来自 refreshes.jsonl 的条目",
  "liveArtifact.refresh.persistedEmpty": "尚无持久化的刷新记录。",
  "liveArtifact.refresh.persistedStatusSucceeded": "成功",
  "liveArtifact.refresh.persistedStatusRunning": "进行中",
  "liveArtifact.refresh.persistedStatusFailed": "失败",
  "liveArtifact.refresh.persistedStatusCancelled": "已取消",
  "liveArtifact.refresh.persistedStatusSkipped": "已跳过",
  "liveArtifact.refresh.sessionTitle": "会话活动",
  "liveArtifact.refresh.sessionHint": "本标签页打开期间观察到的事件",
  "liveArtifact.refresh.docSourceTitle": "文档来源",
  "liveArtifact.refresh.docSourceHint": "已配置的数据源",
  "liveArtifact.refresh.docSourceType": "类型",
  "liveArtifact.refresh.docSourceTool": "工具",
  "liveArtifact.refresh.docSourceConnector": "连接器",
  "liveArtifact.refresh.debugSummary": "高级调试元数据",
  "liveArtifact.refresh.debugNote":
    "可能包含连接器 ID、文件名、来源元数据以及内部 artifact 路径。",
  "liveArtifact.viewer.tabPreview": "预览",
  "liveArtifact.viewer.tabCode": "代码",
  "liveArtifact.viewer.tabData": "数据",
  "liveArtifact.viewer.tabRefreshHistory": "刷新历史",
  "liveArtifact.viewer.dataEmpty": "没有可用的 data.json 缓存。",
  "liveArtifact.viewer.code.templateHeading": "模板 HTML",
  "liveArtifact.viewer.code.renderedHeading": "渲染后 HTML",
  "liveArtifact.viewer.code.templateHelp":
    "用于配合 data.json 生成预览的可编辑模板。",
  "liveArtifact.viewer.code.renderedHelp":
    "Preview 当前加载的已生成 index.html。",
  "liveArtifact.viewer.code.variantAria": "代码版本",
  "liveArtifact.viewer.code.variantTemplate": "模板",
  "liveArtifact.viewer.code.variantRendered": "已渲染",
  "liveArtifact.viewer.code.loading": "正在加载代码…",
  "liveArtifact.viewer.code.unavailable": "代码尚不可用。",
  "liveArtifact.viewer.code.empty": "此代码文件为空。",
  "fileViewer.deployToVercel": "部署到 Vercel",
  "fileViewer.redeployToVercel": "重新部署",
  "fileViewer.deployingToVercel": "正在部署到 Vercel…",
  "fileViewer.deployProviderLabel": "部署平台",
  "fileViewer.vercelProvider": "Vercel",
  "fileViewer.cloudflarePagesProvider": "Cloudflare Pages",
  "fileViewer.deployToProvider": "部署到 {provider}",
  "fileViewer.redeployToProvider": "重新部署到 {provider}",
  "fileViewer.deployingToProvider": "正在部署到 {provider}…",
  "fileViewer.preparingPublicLink": "正在准备公开链接…",
  "fileViewer.copyDeployLink": "复制链接",
  "fileViewer.deployModalTitle": "部署",
  "fileViewer.deployModalSubtitle": "使用所选平台账号部署当前 HTML 预览。",
  "fileViewer.vercelToken": "Vercel 令牌",
  "fileViewer.vercelTokenGetLink": "获取 Vercel token",
  "fileViewer.vercelTokenPlaceholder": "粘贴你的 Vercel token",
  "fileViewer.vercelTokenReuseHint": "将使用已保存的令牌。输入新令牌可替换。",
  "fileViewer.vercelTokenRequired": "请先输入并保存 Vercel 令牌。",
  "fileViewer.cloudflareApiToken": "Cloudflare API 令牌",
  "fileViewer.cloudflareApiTokenGetLink": "获取 API token",
  "fileViewer.cloudflareApiTokenPlaceholder": "粘贴你的 Cloudflare API 令牌",
  "fileViewer.cloudflareApiTokenReuseHint":
    "将使用已保存的 Cloudflare API 令牌。输入新令牌可替换。",
  "fileViewer.cloudflareApiTokenRequired":
    "请先输入并保存 Cloudflare API 令牌。",
  "fileViewer.cloudflareApiTokenScopeHint":
    "创建 API token 时勾选 Pages Edit；自定义域名需 Zone Read / DNS Edit。",
  "fileViewer.vercelTeamId": "团队 ID",
  "fileViewer.vercelTeamSlug": "团队标识",
  "fileViewer.cloudflareAccountId": "账户 ID",
  "fileViewer.cloudflareAccountIdHint": "可在 Cloudflare 控制台中找到账户 ID。",
  "fileViewer.cloudflareAccountIdRequired":
    "请先输入并保存 Cloudflare 账户 ID。",
  "fileViewer.cloudflareZoneLabel": "域名",
  "fileViewer.cloudflareZonePlaceholder": "保存 Cloudflare 设置后加载域名",
  "fileViewer.cloudflareZoneRequired": "请先选择一个 Cloudflare 域名。",
  "fileViewer.cloudflareZonesLoading": "正在加载 Cloudflare 域名…",
  "fileViewer.cloudflareZonesRefresh": "刷新域名",
  "fileViewer.cloudflareZonesLoadFailed": "无法加载 Cloudflare 域名。",
  "fileViewer.cloudflareZonesEmpty":
    "此账号下未找到活跃的完整 Cloudflare 域名。",
  "fileViewer.cloudflareDomainPrefixLabel": "子域名前缀",
  "fileViewer.cloudflareDomainPrefixPlaceholder": "demo",
  "fileViewer.cloudflareDomainPrefixInvalid":
    "请仅使用单个 DNS 标签:小写字母、数字和连字符。",
  "fileViewer.cloudflareHostnamePreview": "自定义域名预览:{hostname}",
  "fileViewer.cloudflareCustomDomainHint":
    "可选：绑定自定义域名。不填也会生成 pages.dev 链接。",
  "fileViewer.cloudflarePagesDevLinkLabel": "pages.dev URL",
  "fileViewer.cloudflareCustomDomainLinkLabel": "自定义域名",
  "fileViewer.optional": "可选",
  "fileViewer.vercelPreviewOnly": "当前仅部署 Preview。",
  "fileViewer.cloudflarePagesPreviewHint":
    "Cloudflare Pages 使用 Direct Upload。",
  "fileViewer.savingConfig": "保存中…",
  "fileViewer.deployConfigSaveFailed": "保存 Vercel 设置失败。",
  "fileViewer.deployFailed": "部署失败，请检查 Vercel 设置后重试。",
  "fileViewer.deployProviderConfigSaveFailed": "无法保存 {provider} 设置。",
  "fileViewer.deployProviderFailed": "{provider} 部署失败。请检查设置后重试。",
  "fileViewer.deployResultLabel": "部署链接",
  "fileViewer.deployLinkReady": "已就绪",
  "fileViewer.deploySuccessToast": "部署已成功上传",
  "fileViewer.deploySuccessToastDetails": "{provider} · {url}",
  "fileViewer.deployLinkPreparingLabel": "公开链接准备中",
  "fileViewer.deployLinkDelayed": "站点已经部署，平台仍在准备公开链接。",
  "fileViewer.deployLinkFailed": "自定义域名失败",
  "fileViewer.deployLinkProtectedLabel": "部署访问保护已开启",
  "fileViewer.deployLinkProtected":
    "站点已部署，但此预览链接要求登录后才能访问。请关闭 Deployment Protection 或使用自定义域名。",
  "fileViewer.retryLink": "立即重试",
  "questionForm.submit": "提交",
  "questionForm.skip": "跳过",
  "questionForm.locked": "已回答",
  "conv.switch": "切换对话",
  "conv.label": "对话",
  "conv.heading": "对话历史",
  "conv.new": "+ 新建",
  "conv.empty": "还没有对话。",
  "conv.untitled": "未命名对话",
  "conv.renameTooltip": "双击重命名",
  "conv.delete": "删除对话",
  "conv.deleteConfirm": "确定删除「{title}」？该操作会删除其消息。",
  "agentPicker.label": "代理",
  "agentPicker.modeChoose": "选择执行模式",
  "agentPicker.localCli": "本机 CLI",
  "agentPicker.daemonOff": "守护进程未运行",
  "agentPicker.byok": "API · BYOK",
  "agentPicker.selectAgent": "选择已检测到的代码代理 CLI",
  "agentPicker.noAgents": "PATH 中未发现代理",
  "agentPicker.notInstalled": "未安装",
  "agentPicker.rescan": "重新扫描 PATH 中的代理",
  "tool.openInTab": "在标签页中打开 {name}",
  "tool.open": "打开",
  "tool.todos": "待办",
  "tool.todosExpand": "展开任务",
  "tool.todosCollapse": "收起任务",
  "tool.todosDone": "完成",
  "tool.todosDismiss": "关闭任务列表",
  "tool.write": "写入",
  "tool.edit": "编辑",
  "tool.read": "读取",
  "tool.delete": "删除",
  "tool.bash": "Bash",
  "tool.glob": "Glob",
  "tool.grep": "Grep",
  "tool.fetch": "抓取",
  "tool.search": "搜索",
  "tool.lines": "{n} 行",
  "tool.changeSingular": "处变更",
  "tool.changePlural": "处变更",
  "tool.in": "于 {path}",
  "tool.hide": "隐藏",
  "tool.output": "输出",
  "tool.running": "运行中…",
  "tool.error": "错误",
  "tool.done": "完成",
  "assistant.role": "助手",
  "assistant.workingLabel": "执行中",
  "assistant.doneLabel": "已完成",
  "assistant.copyMarkdown": "复制回复 Markdown",
  "assistant.forkConversation": "从这里分叉",
  "assistant.forkingConversation": "正在分叉…",
  "assistant.shareToOpenDesign": "Upstream PR",
  "assistant.shareToOpenDesignBusy": "正在准备投稿…",
  "assistant.feedbackPrompt": "反馈",
  "assistant.feedbackPositive": "有帮助",
  "assistant.feedbackNegative": "没有帮助",
  "assistant.feedbackReasonTitle": "选择原因",
  "assistant.feedbackReasonPositiveMatched": "理解了我的需求",
  "assistant.feedbackReasonPositiveVisual": "视觉效果满意",
  "assistant.feedbackReasonPositiveUseful": "结构有帮助",
  "assistant.feedbackReasonPositiveEasy": "方便继续修改",
  "assistant.feedbackReasonPositiveDesignSystem": "严格按照设计系统生成",
  "assistant.feedbackReasonNegativeMissed": "没有理解需求",
  "assistant.feedbackReasonNegativeVisual": "视觉效果不理想",
  "assistant.feedbackReasonNegativeIncomplete": "产物不完整",
  "assistant.feedbackReasonNegativeHard": "不方便使用",
  "assistant.feedbackReasonNegativeDesignSystem": "没有严格按照设计系统生成",
  "assistant.feedbackReasonOther": "其他",
  "assistant.feedbackReasonPlaceholder": "补充说明...",
  "assistant.feedbackReasonSubmit": "提交",
  "assistant.emptyResponseLabel": "无输出",
  "assistant.emptyResponseMessage":
    "服务商结束了请求，但没有返回文本或设计产物。请尝试更换模型或服务商、检查额度，或重试。",
  "assistant.unfinishedLabel": "已停止，仍有未完成任务",
  "assistant.unfinishedSummary": "剩余 {n} 个任务",
  "assistant.unfinishedMore": "还有 {n} 个",
  "assistant.continueRemaining": "继续剩余任务",
  "chat.resumeRunCta": "继续运行",
  "assistant.outTokens": "{n} 输出",
  "assistant.producedFiles": "本轮产出的文件",
  "assistant.openFile": "打开",
  "assistant.downloadFile": "下载",
  "nextStep.title": "下一步",
  "nextStep.more": "更多",
  "nextStep.share": "分享",
  "nextStep.download": "下载",
  "nextStep.contribute": "贡献社区",
  "nextStep.planGenerateTitle": "生成产物",
  "nextStep.planGenerateBody":
    "以已确认的 Markdown 规划文档为依据生成下一版产物。",
  "nextStep.planImproveTitle": "继续优化文档",
  "nextStep.planImproveBody": "先把当前规划文档补完整，再进入最终生成。",
  "nextStep.planGeneratePrompt":
    "以 `{file}` 作为唯一事实来源。先读取这份文档，保留其中已经确定的决策，然后生成与文档匹配的最终设计产物。如果它是逐页大纲，就生成 PPT/Deck；如果它是 PRD 或原型规划，就生成原型或线框图；如果它是分镜或创意 brief，就生成对应的视觉/媒体产物。生成前请指出你无法自行解决的阻塞 TODO 或矛盾点。",
  "nextStep.planImprovePrompt":
    "读取 `{file}`，并直接在原文件中优化这份可编辑规划文档。收紧范围，补齐薄弱章节，增加验收标准；仍需要用户输入的地方保留 TODO / open question。暂时不要生成最终设计产物。",
  "nextStep.planImproveArtifactTitle": "继续优化产物",
  "nextStep.planImproveArtifactBody":
    "基于当前产物继续打磨，而不是回到规划阶段。",
  "nextStep.planImproveArtifactPrompt":
    "直接优化 `{artifact}`。保留当前已经可用的产物和行为，优先改进产品结构、视觉层级、交互细节和内容表达。完成后总结改动文件和仍需注意的风险。",
  "nextStep.planMergeTitle": "融合文档与产物",
  "nextStep.planMergeBody": "把规划意图和已生成产物对齐，让两者一起推进。",
  "nextStep.planMergePrompt":
    "同时读取 `{document}` 和 `{artifact}`。把文档视为意图来源，把产物视为当前实现，然后融合两者：让产物对齐已确认决策，只在文档过时时更新文档，仍未确定的内容保留 TODO / open question。保留当前已可用的行为，最后总结文档和产物分别改了什么。",
  "nextStep.brandAiOptimizeTitle": "深化抽取设计系统",
  "nextStep.brandAiOptimizeBody":
    "启动 agent 消耗模型 token，重新抽取来源内容，并原地更新这个设计系统。",
  "nextStep.brandCreateDesignTitle": "用此系统新建设计",
  "nextStep.brandCreateDesignBody":
    "基于已抽取的颜色、字体、素材和设计规范创建一个新设计。",
  "nextStep.createDesignBusy": "正在新建设计...",
  "assistant.thinking": "思考中",
  "assistant.thought": "思考完毕",
  "assistant.thoughtFor": "已深度思考（用时 {s} 秒）",
  "assistant.systemReminder": "系统提示",
  "assistant.possiblePromptInjection": "可能的提示词注入",
  "assistant.waitingFirstOutput": "等待首批输出中",
  "assistant.statusBootingAgent": "正在启动代理",
  "assistant.statusPreparing": "准备中…",
  "assistant.statusStarting": "启动中",
  "assistant.statusRequesting": "正在发送请求",
  "assistant.statusThinking": "思考中",
  "assistant.statusStreaming": "流式输出中",
  "assistant.slowHint":
    "耗时比平时更久。一般 5–10 秒内会出现表单，可以「停止」后重新表述。",
  "assistant.verbEditing": "编辑",
  "assistant.verbWriting": "写入",
  "assistant.verbReading": "读取",
  "assistant.verbSearching": "搜索",
  "assistant.verbRunning": "运行",
  "assistant.verbTodos": "待办",
  "assistant.verbFetching": "抓取",
  "assistant.verbCalling": "调用",
  "qf.answered": "已回答",
  "qf.choose": "请选择…",
  "qf.customLabel": "自定义填写",
  "qf.customPlaceholder": "输入你自己的答案…",
  "qf.otherOption": "其他",
  "qf.required": "必填",
  "qf.lockedSubmitted": "答案已发送，代理将在本次会话后续使用。",
  "qf.lockedPrev": "该表单来自此前的对话。",
  "qf.hint": "挑选合适的选项；可选项可以跳过，代理会使用合理的默认值。",
  "qf.submitDefault": "发送答案",
  "qf.submitDisabledTitle": "请先填写必填项",
  "qf.submitTitle": "发送答案",
  "qf.cardSelected": "已选",
  "qf.cardRefs": "参考：",
  "qf.cardSampleText": "飞燕环宇 · 0123",
  "questions.tabLabel": "问题",
  "questions.banner": "想先跟你确认几个小问题～",
  "questions.bannerAnswered": "已回答这些问题",
  "questions.continue": "继续",
  "questions.generating": "正在生成问题…",
  "questions.skipAll": "一键跳过",
  "questions.autoSkipHint": "倒计时结束后将自动继续",
  "questions.submitting": "正在提交…",
  "sketch.toolSelect": "选择（占位）",
  "sketch.toolPen": "钢笔",
  "sketch.toolText": "文本",
  "sketch.toolRect": "矩形",
  "sketch.toolArrow": "箭头",
  "sketch.toolEraser": "橡皮擦",
  "sketch.color": "颜色",
  "sketch.strokeSize": "描边粗细",
  "sketch.undo": "撤销",
  "sketch.clear": "清空",
  "sketch.close": "关闭",
  "sketch.closeConfirm": "关闭草图并放弃未保存的更改吗？",
  "sketch.textPrompt": "请输入文本：",
  "sketch.textModalTitle": "添加文本",
  "critiqueTheater.userFacingName": "设计评审团",
  "critiqueTheater.roleDesigner": "设计师",
  "critiqueTheater.roleCritic": "评审",
  "critiqueTheater.roleBrand": "品牌",
  "critiqueTheater.roleA11y": "无障碍",
  "critiqueTheater.roleCopy": "文案",
  "critiqueTheater.roundLabel": "第 {n} 轮 / 共 {m} 轮",
  "critiqueTheater.mustFix": "{n} 项必改",
  "critiqueTheater.composite": "综合分",
  "critiqueTheater.threshold": "阈值",
  "critiqueTheater.consensus": "共识",
  "critiqueTheater.interrupt": "中断",
  "critiqueTheater.interrupting": "正在中断…",
  "critiqueTheater.interrupted": "已中断",
  "critiqueTheater.degradedHeading": "本次评审不可用",
  "critiqueTheater.degradedReasonMalformed": "评审块格式错误，解析器已拒绝。",
  "critiqueTheater.degradedReasonOversize": "评审输出超出了安全字节预算。",
  "critiqueTheater.degradedReasonAdapter": "适配器 {adapter} 不支持评审协议。",
  "critiqueTheater.degradedReasonProtocol":
    "适配器 {adapter} 使用了不支持的协议版本。",
  "critiqueTheater.degradedReasonMissingArtifact": "运行结束但未产出最终产物。",
  "critiqueTheater.replay": "回放",
  "critiqueTheater.replaySpeed": "回放速度",
  "critiqueTheater.readOnly": "只读",
  "critiqueTheater.shippedSummary":
    "已于第 {round} 轮发布 · 综合分 {composite}",
  "critiqueTheater.interruptedSummary":
    "已于第 {round} 轮中断 · 最佳综合分 {composite}",
  "critiqueTheater.shippedBadge": "已发布",
  "critiqueTheater.belowThresholdBadge": "低于阈值",
  "critiqueTheater.timedOutBadge": "已超时",
  "critiqueTheater.failedHeading": "运行失败",
  "critiqueTheater.failedReasonCliExit":
    "智能体 CLI 在评审完成前以非零状态退出。",
  "critiqueTheater.failedReasonPerRoundTimeout": "某一轮超出了时间预算。",
  "critiqueTheater.failedReasonTotalTimeout": "整次运行超出了总时间预算。",
  "critiqueTheater.failedReasonOrchestrator": "编排器内部错误。",
  "critiqueTheater.transcriptEmpty":
    "暂无可回放的会话记录。运行一次评审即可记录。",
  "critiqueTheater.transcriptLoading": "正在加载会话记录…",
  "critiqueTheater.transcriptError": "无法加载会话记录：{error}",
  "critiqueTheater.replaySpeedPaused": "暂停",
  "critiqueTheater.replaySpeedInstant": "瞬时",
  "critiqueTheater.replaySpeedLive": "实时",
  "critiqueTheater.replaySpeedFast": "快进",
  "critiqueTheater.settingsNav": "设计评审团",
  "critiqueTheater.settingsNavHint": "为代理运行启用五人设计评审",
  "critiqueTheater.settingsEnabledLabel": "在代理运行期间显示设计评审团",
  "critiqueTheater.settingsEnabledDescription":
    "启用后，五人评审面板会在代理生成时同时显示，并在交付前对结果评分。你可以随时中断。",
  "critiqueTheater.settingsEnabledProjectHint":
    "已为该项目保存。该项目的新运行将在服务端经过设计评审团。",
  "critiqueTheater.settingsEnabledNoProjectHint":
    "打开项目后此设置才会服务端持久化；目前仅修改浏览器本地偏好。",
  "pet.title": "宠物",
  "pet.subtitle":
    "「显示宠物」控制它是否出现在工作区；下方可以选择内置、自定义或社区宠物。",
  "pet.navTitle": "宠物",
  "pet.navHint": "领养与自定义",
  "pet.tabBuiltIn": "内置",
  "pet.tabBuiltInHint": "Crie3 内置的精选宠物 — 一键领养。",
  "pet.builtInEmpty":
    "暂时无法加载内置宠物。等本地服务恢复后,刷新「社区」页签再试。",
  "pet.tabCustom": "自定义",
  "pet.tabCustomHint": "自己取名、选符号或上传精灵图。",
  "pet.tabCommunity": "社区",
  "pet.tabCommunityHint": "来自 Codex 的孵化宠物 — 领养或用 AI 生成新的。",
  "pet.tabsAria": "选择宠物",
  "pet.adopt": "领养",
  "pet.adoptedBadge": "已领养",
  "pet.adoptCallout": "领养一只宠物",
  "pet.changePet": "更换宠物",
  "pet.wake": "显示宠物",
  "pet.tuck": "隐藏宠物",
  "pet.wakeTitle": "在工作区显示宠物。尚未选择时，会默认使用第一只内置宠物。",
  "pet.tuckTitle": "从工作区隐藏宠物。",
  "pet.settingsTitle": "打开宠物设置",
  "pet.useCustom": "使用我的宠物",
  "pet.customTitle": "自定义你的宠物",
  "pet.customHint": "挑一个名字、表情和主题色，浮窗会即时更新。",
  "pet.customGreetingPlaceholder": "来自宠物的问候…",
  "pet.fieldName": "名字",
  "pet.fieldGlyph": "表情",
  "pet.fieldGlyphHint": "建议使用单个 emoji（例如 🐝、🦄、🐢）。",
  "pet.fieldGreeting": "问候语",
  "pet.fieldAccent": "主题色",
  "pet.fieldAccentCustom": "自定义颜色",
  "pet.fieldAccentDefault": "默认主题色",
  "pet.overlayAria": "宠物伙伴",
  "pet.spriteAria": "{name} — 拖动可移动，点击与它互动",
  "pet.spriteTitle": "{name} 来打招呼啦！点击聊天。",
  "pet.taskSummarySingle": "正在执行 {count} 个 Agent 任务。",
  "pet.taskSummaryMultiple":
    "正在执行 {count} 个 Agent 任务，分布在 {projects} 个项目。",
  "pet.taskSummaryRecentSingle": "最近完成 {count} 个 Agent 任务。",
  "pet.taskSummaryRecentMultiple": "最近完成 {count} 个 Agent 任务。",
  "pet.taskListAria": "执行中的 Agent 任务",
  "pet.taskOpenProject": "打开 {project}",
  "pet.taskGroup.running": "正在执行",
  "pet.taskGroup.queued": "等待中",
  "pet.taskGroup.recent": "最近完成",
  "pet.idleQuote.leonardo.text": "学习从不会使心灵疲惫。",
  "pet.idleQuote.leonardo.author": "列奥纳多·达·芬奇",
  "pet.idleQuote.michelangelo.text":
    "我看见天使在大理石中，于是不断雕刻，直到让他自由。",
  "pet.idleQuote.michelangelo.author": "米开朗基罗",
  "pet.idleQuote.bernini.text": "有两样东西能帮助雕塑家：光与影。",
  "pet.idleQuote.bernini.author": "吉安·洛伦佐·贝尼尼",
  "pet.idleQuote.raphael.text": "作画时，人并不思考。",
  "pet.idleQuote.raphael.author": "拉斐尔",
  "pet.idleQuote.caravaggio.text": "作品若不是从生活中来，终究只是细枝末节。",
  "pet.idleQuote.caravaggio.author": "卡拉瓦乔",
  "pet.idleQuote.rodin.text":
    "最重要的是被打动、去爱、去希望、去颤抖、去生活。",
  "pet.idleQuote.rodin.author": "奥古斯特·罗丹",
  "pet.composerTitle": "宠物 — 唤醒、收起或选一只",
  "pet.composerMenuTitle": "宠物",
  "pet.composerMenuHint": "小贴士：输入 /pet 即可切换",
  "pet.composerOpenSettings": "管理宠物",
  "pet.welcomeTeaserTitle": "领养一只宠物",
  "pet.welcomeTeaserBody": "一只小小的浮窗伙伴，会陪着你工作。",
  "pet.welcomeTeaserCta": "挑一只",
  "pet.imageUpload": "上传形象",
  "pet.imageReplace": "替换形象",
  "pet.imageRemove": "改用 emoji",
  "pet.imageHintIdle":
    "支持 PNG / JPG / WebP / GIF / SVG。要做精灵动画？传一张横向序列图并设置帧数。",
  "pet.imageHintActive":
    "正在使用你上传的形象。把帧数设为 > 1 即可让横向序列图动起来。",
  "pet.fieldFrames": "帧数",
  "pet.fieldFramesHint": "1 = 静态；> 1 = 横向序列图。",
  "pet.fieldFps": "速度 (fps)",
  "pet.fieldFpsHint": "控制序列图的播放速度。",
  "pet.atlasImport": "导入 Codex 精灵图",
  "pet.atlasImportTitle": "导入 hatch-pet 8x9 / 192x208 精灵图(PNG 或 WebP)。",
  "pet.atlasPickerTitle": "选择动画行",
  "pet.atlasPickerHint":
    "Codex 宠物自带 9 个动画状态。默认会保留完整精灵图,这样宠物会根据悬停、拖拽方向、长时间空闲自动切换动画。也可以只保留一个循环。",
  "pet.atlasCancel": "丢弃精灵图",
  "pet.atlasAdopt": "锁定这一行",
  "pet.atlasAdoptFull": "使用完整精灵图(动态)",
  "pet.atlasAdoptFullTitle":
    "保留全部动画行,让宠物对悬停、拖拽方向以及长时间空闲做出反应。",
  "pet.atlasAdoptRowTitle": "只把高亮的这一行切成单循环条带。",
  "pet.atlasActiveHint":
    "动态精灵图已启用 — 宠物会根据你的交互(悬停、拖拽、空闲)自动切换动画。",
  "pet.atlasRow.idle": "待机",
  "pet.atlasRow.running-right": "向右跑",
  "pet.atlasRow.running-left": "向左跑",
  "pet.atlasRow.waving": "挥手",
  "pet.atlasRow.jumping": "跳跃",
  "pet.atlasRow.failed": "失败",
  "pet.atlasRow.waiting": "等待",
  "pet.atlasRow.running": "奔跑",
  "pet.atlasRow.review": "审视",
  "pet.hatchTitle": "用 AI 孵化新宠物",
  "pet.hatchHint":
    "通过聊天调用内置的 hatch-pet 技能生成 Codex 风格的精灵图,完成后回到这里导入。",
  "pet.hatchConcept": "宠物概念(可选)",
  "pet.hatchConceptPlaceholder": "例如:一只穿着毛衣的像素风柴犬",
  "pet.hatchCopy": "复制提示词",
  "pet.hatchCopied": "已复制!",
  "pet.hatchFoot": "技能保存好宠物后,回到这里点击「导入 Codex 精灵图」即可。",
  "pet.slashPopoverAria": "斜杠命令",
  "pet.slashPopoverTitle": "命令",
  "pet.slashPopoverHint": "↑↓ 切换 · 回车选择 · esc 关闭",
  "pet.slashPet": "切换、领养或跳转到宠物设置。",
  "pet.slashPetWake": "唤醒漂浮的宠物。",
  "pet.slashPetTuck": "把宠物收起来。",
  "pet.slashHatch": "调用 hatch-pet 技能生成一只 Codex 宠物。",
  "pet.slashHatchArg": "<概念>",
  "pet.slashSearch": "通过 OD research 命令搜索网页。",
  "pet.slashSearchArg": "<查询>",
  "pet.codexTitle": "最近孵化",
  "pet.codexSubtitle": "hatch-pet 技能打包的宠物会出现在这里,可一键领养。",
  "pet.codexSubtitleWithDir": "正在扫描 {dir},查找 hatch-pet 技能打包的宠物。",
  "pet.codexEmpty": "还没有孵化的宠物。在聊天中输入 /hatch 来生成一只。",
  "pet.codexLoading": "正在查找已孵化的宠物…",
  "pet.codexRefresh": "刷新",
  "pet.codexAdopt": "领养",
  "pet.codexAdopting": "领养中…",
  "pet.communitySync": "下载社区宠物",
  "pet.communitySyncing": "下载中…",
  "pet.communitySyncTitle":
    "从 Codex Pet Share 与 j20 Hatchery 同步最新宠物到 ~/.codex/pets/。",
  "pet.communitySyncDone": "已同步 {wrote} 个新宠物（共 {total} 个）。",
  "pet.communitySyncFailed": "同步失败：{error}",
  "pet.codexBundled": "内置",
  "pet.codexBundledTitle": "Crie3 内置宠物，无需下载。",
  "settings.notifications": "通知",
  "settings.notificationsHint": "任务完成时的声音和桌面通知",
  "settings.notifyCompletionSound": "完成提示音",
  "settings.notifyCompletionSoundHint": "一轮任务结束时播放，默认关闭",
  "settings.notifySuccessSound": "成功音色",
  "settings.notifyFailureSound": "失败音色",
  "settings.notifyDesktop": "桌面通知",
  "settings.notifyDesktopHint": "窗口不在前台时弹出系统通知",
  "settings.notifyDesktopBlocked": "浏览器已拒绝通知权限，请在站点设置中开启",
  "settings.notifyDesktopUnsupported": "当前环境不支持桌面通知",
  "settings.notifyTest": "测试通知",
  "settings.notifyTestSent":
    "测试通知已发送；如果没有弹窗，请检查浏览器和系统通知设置。",
  "settings.notifyTestFailed": "通知调用失败，请检查浏览器和系统通知设置。",
  "settings.notifySoundDing": "叮",
  "settings.notifySoundChime": "风铃",
  "settings.notifySoundTwoToneUp": "上行双音",
  "settings.notifySoundPluck": "拨弦",
  "settings.notifySoundBuzz": "蜂鸣",
  "settings.notifySoundTwoToneDown": "下行双音",
  "settings.notifySoundThud": "低响",
  "settings.skills": "技能",
  "settings.skillsHint": "智能体在任务中可以调用的功能技能",
  "settings.skillsNew": "新建技能",
  "settings.skillsEmpty": "请在左侧选择一个技能，或新建一个。",
  "settings.skillsEdit": "编辑",
  "settings.skillsDelete": "删除",
  "settings.skillsDeleteConfirm": "确认删除",
  "settings.skillsName": "名称",
  "settings.skillsTriggers": "触发词（逗号或换行分隔）",
  "settings.skillsDescription": "描述",
  "settings.skillsBody": "SKILL.md 内容",
  "settings.skillsCreate": "创建",
  "settings.skillsSave": "保存",
  "settings.skillsSaving": "保存中…",
  "settings.skillsOverrideCreate": "创建用户覆盖",
  "settings.skillsOverrideSave": "另存为用户覆盖",
  "settings.skillsBuiltInOverrideWarning":
    "编辑此内置技能会创建一份用户覆盖。在你删除该覆盖之前，内置条目将从列表中隐藏。是否继续？",
  "settings.skillsFiles": "文件",
  "settings.skillsNoFiles": "该技能目录下暂无文件。",
  "settings.skillsNameRequired": "技能名称为必填项。",
  "settings.skillsBodyRequired": "技能内容为必填项。",
  "settings.designSystems": "设计系统",
  "settings.designSystemsHint": "管理首页 Gallery 中显示的设计系统",
  "settings.designSystemsInstalled": "已安装",
  "settings.designSystemsAdd": "添加设计系统",
  "settings.designSystemsHiddenCount": "{count} 个已从首页 Gallery 隐藏",
  "settings.designSystemsShowAll": "显示全部",
  "settings.designSystemsShowHidden": "显示隐藏项",
  "settings.designSystemsSource": "来源",
  "settings.designSystemsSourceLocal": "本地",
  "settings.designSystemsSourceGithub": "GitHub",
  "settings.designSystemsSourceShadcn": "shadcn",
  "settings.designSystemsShadcnReference": "shadcn 注册表引用",
  "settings.designSystemsImportShadcn": "从 shadcn 导入",
  "settings.designSystemsStructure": "结构",
  "settings.designSystemsModeHybrid": "混合",
  "settings.designSystemsModeNormalized": "规范化",
  "settings.designSystemsModeVerbatim": "原样保留",
  "settings.designSystemsCraft": "工艺",
  "settings.designSystemsCraftColor": "颜色",
  "settings.designSystemsCraftAccessibility": "无障碍",
  "settings.designSystemsGithubUrl": "GitHub URL",
  "settings.designSystemsProjectPath": "项目路径",
  "settings.designSystemsImportGithub": "从 GitHub 导入",
  "settings.designSystemsImportProject": "从项目导入",
  "settings.designSystemsImportedStatus": "已导入 {title}",
  "settings.designSystemsViewImported": "查看导入的设计系统",
  "settings.designSystemsCategory": "分类",
  "settings.designSystemsAllCategories": "所有分类",
  "settings.designSystemsShowInHomeGallery": "在首页 Gallery 中显示",
  "settings.projectLocations": "项目位置",
  "settings.projectLocationsHint": "工作区存储根目录",
  "settings.projectLocationsDescription":
    "添加可包含多个 Crie3 项目文件夹的工作基目录。新项目会作为所选基目录内的一个文件夹保存。",
  "settings.projectLocationsSaveError":
    "无法保存项目位置。请检查每个路径都是可访问的文件夹。",
  "settings.projectLocationsSaved": "项目位置已保存。",
  "settings.projectLocationsScanError": "无法扫描项目位置。",
  "settings.projectLocationsScanComplete":
    "扫描完成：已导入 {imported} 个，已有 {existing} 个。",
  "settings.projectLocationsNoFolderSelected": "未选择文件夹。",
  "settings.projectLocationsDuplicate": "这个工作基目录已添加。",
  "settings.projectLocationsWorkBaseMeta":
    "工作基目录 · 项目会作为子文件夹创建在这里",
  "settings.projectLocationsAddFolder": "添加文件夹…",
  "settings.projectLocationsDefaultBadge": "默认位置",
  "settings.projectLocationsMakeDefault": "设为默认",
  "settings.projectLocationsDefaultSaved": "默认项目位置已更新。",
  "settings.librarySkills": "技能",
  "settings.libraryDesignSystems": "设计系统",
  "settings.librarySearch": "搜索...",
  "settings.libraryAll": "全部",
  "settings.libraryPreview": "预览",
  "settings.libraryPreviewClose": "关闭",
  "settings.libraryLoading": "加载中...",
  "settings.libraryNoResults": "没有匹配的项目。",
  "settings.libraryEnabled": "已启用",
  "settings.libraryDisabled": "已禁用",
  "settings.connectorsNavHint": "外部系统连接",
  "settings.connectorsHint": "管理此设备的连接器和工具提供商设置。",
  "settings.connectorsComposioApiKey": "Composio API 密钥",
  "settings.connectorsSavedTitle": "已保存到本地 daemon",
  "settings.connectorsSavedWithTail": "已保存 · ••••{tail}",
  "settings.connectorsSaved": "已保存",
  "settings.connectorsGetApiKey": "获取 API 密钥",
  "settings.connectorsReplaceKeyPlaceholder": "粘贴新密钥以替换已保存的密钥",
  "settings.connectorsApiKeyPlaceholder": "粘贴 Composio API 密钥",
  "settings.connectorsClear": "清除",
  "settings.connectorsClearConfirmTitle": "清除已保存的 Composio API 密钥？",
  "settings.connectorsClearConfirmBody":
    "删除密钥会断开此工作区下所有的 Composio 连接器。已连接的账号、OAuth 授权和工具访问权限都将被一并移除。",
  "settings.connectorsClearConfirmContinue": "继续",
  "settings.connectorsClearFinalTitle": "此操作会断开所有连接器",
  "settings.connectorsClearFinalBody":
    "该操作无法撤销。粘贴新密钥后，需要从头重新连接每个集成。",
  "settings.connectorsClearFinalConfirm": "删除密钥并断开",
  "settings.connectorsClearArming": "稍等\u2026",
  "settings.connectorsClearCancel": "取消",
  "settings.connectorsSaveKey": "保存密钥",
  "settings.connectorsSaveKeyTitle": "将此密钥发送到本地 daemon",
  "settings.connectorsKeySaving": "保存中…",
  "settings.connectorsKeySaved": "已保存 ✓",
  "settings.connectorsKeyError":
    "保存密钥失败。请确认本地 daemon 已启动后再试。",
  "settings.connectorsHelpSaved":
    "你的密钥会解锁下方目录，并保留在本地 daemon 中。粘贴新密钥可替换，或清除以移除。",
  "settings.connectorsHelpUnsaved":
    "尚未保存 — 点击「保存密钥」即可把它存入本地 daemon，并解锁下方目录。",
  "settings.connectorsHelpEmpty":
    "添加密钥以解锁下方目录。密钥会本地存储在 daemon 中，绝不会通过环境变量发送。",
  "settings.connectorsLoadingSavedKey": "正在从本地 daemon 中检查已保存的密钥…",
  "settings.autosaveSaving": "保存中…",
  "settings.autosaveSaved": "所有更改已保存",
  "settings.autosaveError": "保存更改失败。本地 daemon 可能不在线。",
  "settings.libraryToggleLabel": "切换",
  "settings.memory": "记忆",
  "settings.memoryHint": "后续对话可复用的事实和上下文",
  "settings.customInstructionsTitle": "全局规则",
  "settings.customInstructionsHint":
    "Crie3 每次对话都应遵守的固定指令。事实、偏好和项目上下文请保存为记忆。",
  "settings.customInstructionsPlaceholder":
    '例如："始终使用 TypeScript。优先使用函数式组件。保持回复简洁。"',
  "settings.memoryDescription":
    "控制已保存的事实、偏好和项目上下文是否会在后续对话中复用。",
  "settings.memoryEnabled": "已启用",
  "settings.memoryDisabled": "已关闭",
  "settings.memoryEnableLabel": "启用记忆注入",
  "settings.memoryDisabledBanner":
    "记忆当前已关闭。已有的事实文件保留在磁盘上，但不会被注入到新对话，也不会从新对话中提取新事实。",
  "settings.memoryNew": "新建记忆",
  "settings.memoryEdit": "编辑",
  "settings.memoryDelete": "删除",
  "settings.memoryPreview": "预览",
  "settings.memoryEmpty": "还没有记忆。",
  "settings.memoryEmptyHintZh": "记住: 用户偏好深色主题",
  "settings.memoryEmptyHintEn": "I prefer dark mode",
  "settings.memoryName": "例如：UI 偏好",
  "settings.memoryDesc": "一句话 — 这条记忆是关于什么的？",
  "settings.memoryBody": "- 规则一\n- 规则二\n\n为什么：可选\n何时适用：可选",
  "settings.memoryBodyHint":
    "先用 bullet 列出规则，再补「为什么」和「何时适用」（可选）。支持 Markdown。也可以点上方示例直接载入。",
  "settings.memoryStartersLabel": "不知道写什么？点一下填到表单里：",
  "settings.memoryStarterUserName": "我的角色",
  "settings.memoryStarterUserDesc": "我是一名前端工程师，在做 SaaS 设计工具",
  "settings.memoryStarterUserBody":
    "- 角色：高级前端工程师\n- 技术栈：React、TypeScript、Vite\n- 方向：设计 / 协作工具\n- 时区：GMT+8（Asia/Shanghai）\n\n何时适用：任何对话里举例时优先用前端 / Web 场景。",
  "settings.memoryStarterFeedbackName": "UI 偏好",
  "settings.memoryStarterFeedbackDesc": "深色主题、字号偏大、信息密度低",
  "settings.memoryStarterFeedbackBody":
    "- 主题：默认深色\n- 正文字号：≥ 18px\n- 信息密度：留白多一些，一屏不要塞太多东西\n\n为什么：长时间使用眼睛不容易累。\n何时适用：让你画 UI、网页、PPT 时都按这个走。",
  "settings.memoryStarterProjectName": "当前项目",
  "settings.memoryStarterProjectDesc":
    "Crie3 v0.5 — 聊天驱动的设计编辑器",
  "settings.memoryStarterProjectBody":
    "- 目标：本季度交付聊天驱动的编辑体验\n- 优先级：流式渲染、本地多模态、离线优先\n- 技术栈：Next.js 16、Express daemon、SQLite\n\n何时适用：与本项目相关的所有对话。",
  "settings.memorySaveHint": "不会自动保存 — 点击「创建」/「保存」才生效。",
  "settings.memoryIndexSaveHint":
    "索引不会自动保存 — 改完后点击「保存索引」才生效。",
  "settings.memoryIndexUnsaved": "有未保存的修改",
  "settings.memoryFlashCreated": "✓ 已创建",
  "settings.memoryFlashSaved": "✓ 已保存",
  "settings.memoryFlashDeleted": "✓ 已删除",
  "settings.memoryFlashIndexSaved": "✓ 索引已保存",
  "settings.memoryFlashPathCopied": "✓ 路径已复制",
  "settings.memoryNameLabel": "标题",
  "settings.memoryTypeLabel": "类型",
  "settings.memoryDescLabel": "描述",
  "settings.memoryBodyLabel": "内容",
  "settings.memoryTypeUser": "用户",
  "settings.memoryTypeFeedback": "反馈",
  "settings.memoryTypeProject": "项目",
  "settings.memoryTypeReference": "引用",
  "settings.memoryTypeProfile": "画像",
  "settings.memoryTypeRule": "规则",
  "settings.memoryTabMemories": "记忆",
  "settings.memoryTabMemoriesCaption": "查看和管理已保存的记忆",
  "settings.memoryTabHow": "工作原理",
  "settings.memoryTabHowCaption": "两个循环及其控制项",
  "settings.memoryAddDisclosure": "添加或导入记忆",
  "settings.memoryAddDisclosureHint": "画像、手动录入或已连接的应用",
  "settings.memoryProfileTab": "工作画像",
  "settings.memoryProfileTabCaption": "你是谁以及你的默认偏好",
  "settings.memoryProfileTitle": "你的工作画像",
  "settings.memoryProfileHint":
    "关于你和你默认偏好的几条事实。记忆会在每次任务前注入这些信息，让智能体从一句简短的描述中推断出你的意图。",
  "settings.memoryProfileName": "工作画像",
  "settings.memoryProfileDescription":
    "助手应复用的角色、公司、领域、受众、品味与默认偏好。",
  "settings.memoryProfileSave": "保存画像",
  "settings.memoryProfileSaving": "保存中…",
  "settings.memoryProfileSaved": "画像已保存",
  "settings.memoryProfileRole": "角色",
  "settings.memoryProfileRolePlaceholder": "例如：创始人、设计师、PM",
  "settings.memoryProfileCompany": "公司 / 团队",
  "settings.memoryProfileCompanyPlaceholder": "例如：Acme、增长团队",
  "settings.memoryProfileDomain": "领域",
  "settings.memoryProfileDomainPlaceholder":
    "例如：B2B SaaS、fintech、devtools",
  "settings.memoryProfileAudience": "主要受众",
  "settings.memoryProfileAudiencePlaceholder": "例如：高管、工程师、终端用户",
  "settings.memoryProfileAesthetic": "审美 / 品味",
  "settings.memoryProfileAestheticPlaceholder":
    "例如：简洁有编辑感、浅色背景、充裕留白",
  "settings.memoryProfileDeliverables": "默认交付物",
  "settings.memoryProfileDeliverablesPlaceholder":
    "例如：落地页、幻灯片、单页文档",
  "settings.memoryProfileLocale": "地区 / 语言",
  "settings.memoryProfileLocalePlaceholder":
    "例如：English (US)、Simplified Chinese",
  "settings.memoryProfileGoals": "当前目标",
  "settings.memoryProfileGoalsPlaceholder":
    "例如：上线新的定价页、提升试用流程的转化率",
  "settings.memoryHooksTitle": "记忆钩子",
  "settings.memoryHooksHint":
    "选择记忆的哪些部分自动运行。上方的总开关可以一次性关闭全部。",
  "settings.memoryHooksProfileLabel": "使用我的画像",
  "settings.memoryHooksProfileDesc": "将你的工作画像注入到每个任务中。",
  "settings.memoryHooksRewriteLabel": "改写简短请求",
  "settings.memoryHooksRewriteDesc": "PRE：将简短请求扩写为完整的任务简报。",
  "settings.memoryHooksVerifyLabel": "自检输出",
  "settings.memoryHooksVerifyDesc":
    "POST：依据你的规则核对结果，然后展示评分卡。",
  "settings.memoryHooksExtractionLabel": "从对话中学习",
  "settings.memoryHooksExtractionDesc": "从对话轮次中捕获有用的事实与偏好。",
  "artifact.odCardTaskBriefChip": "已应用记忆 · 查看简报",
  "artifact.odCardScorecardTitle": "自检",
  "artifact.odCardScorecardStatusPass": "通过",
  "artifact.odCardScorecardStatusPartial": "部分通过",
  "artifact.odCardScorecardStatusFail": "需改进",
  "artifact.odCardRuleKicker": "建议规则",
  "artifact.odCardRuleNameLabel": "名称",
  "artifact.odCardRuleDescriptionLabel": "描述",
  "artifact.odCardRuleAssertionLabel": "须满足",
  "artifact.odCardRuleCheckLabel": "如何核查",
  "artifact.odCardRuleRationaleLabel": "原因",
  "artifact.odCardRuleKeep": "保留",
  "artifact.odCardRuleEdit": "编辑",
  "artifact.odCardRuleDone": "完成",
  "artifact.odCardRuleDiscard": "丢弃",
  "artifact.odCardRuleSaving": "保存中…",
  "artifact.odCardRuleSaved": "已将“{name}”保存为规则",
  "artifact.odCardRuleError": "无法保存规则，请重试。",
  "artifact.odCardBrandAssistDone": "已确认浏览器辅助",
  "artifact.odCardBrandAssistKicker": "需要浏览器辅助：{reason}",
  "artifact.odCardBrandAssistBody":
    "在浏览器中打开品牌网站，让 Crie3 继续提取此设计体系。",
  "artifact.odCardBrandAssistError": "无法启动浏览器辅助，请重试。",
  "artifact.odCardBrandAssistWorking": "正在启动...",
  "artifact.odCardBrandAssistConfirm": "打开浏览器辅助",
  "settings.memoryIndex": "MEMORY.md（索引）",
  "settings.memoryIndexSave": "保存索引",
  "settings.memoryIndexReset": "重置",
  "settings.memoryToastChanged": "记忆已更新",
  "settings.memoryToastClickHint": "查看",
  "settings.memoryAll": "全部",
  "settings.memoryExtractions": "抽取历史",
  "settings.memoryExtractionsHint":
    "最近的 LLM 抽取记录。每次对话结束后，启发式正则会先跑，LLM 抽取在后台异步进行。",
  "settings.memoryExtractionsEmpty":
    "暂无抽取记录。下一次对话结束后会出现在这里。",
  "settings.memoryExtractionsRefresh": "刷新",
  "settings.memoryExtractionsRefreshing": "刷新中…",
  "settings.memoryExtractionPhaseRunning": "抽取中…",
  "settings.memoryExtractionPhaseSuccess": "成功",
  "settings.memoryExtractionPhaseSkipped": "已跳过",
  "settings.memoryExtractionPhaseFailed": "失败",
  "settings.memoryExtractionSkipNoProvider": "未配置 API key，LLM 抽取未运行。",
  "settings.memoryExtractionSkipDisabled": "记忆功能已关闭。",
  "settings.memoryExtractionSkipEmpty": "用户消息为空，没有可抽取的内容。",
  "settings.memoryExtractionSkipNoMatch": "本轮没有命中任何正则规则。",
  "settings.memoryExtractionKindHeuristic": "正则",
  "settings.memoryExtractionKindLlm": "LLM",
  "settings.memoryExtractionProviderEnv": "环境变量",
  "settings.memoryExtractionProviderMediaConfig": "媒体设置",
  "settings.memoryExtractionProviderOverride": "记忆设置",
  "settings.memoryExtractionProposed": "候选",
  "settings.memoryExtractionWritten": "写入",
  "settings.memoryExtractionDuration": "耗时",
  "settings.memoryExtractionDelete": "删除",
  "settings.memoryVerifyTitle": "Recent verifications",
  "settings.memoryVerifyStatusPass": "Approved",
  "settings.memoryVerifyStatusFail": "Not approved",
  "settings.memoryVerifyStatusMissing": "Not verified",
  "settings.memoryVerifyRules": "{covered} of {active} rules checked",
  "settings.memoryVerifyUncovered": "Rules the turn never addressed:",
  "settings.memoryVerifyArtifact": "In the delivered file:",
  "settings.memoryVerifyRowsFailed": "{failed} of {total} checks failed",
  "settings.memoryExtractionsClear": "清空",
  "settings.memoryExtractionsClearTitle": "清空整个抽取历史",
  "settings.memoryExtractionsClearConfirm":
    "确定要清空整个抽取历史吗？此操作无法撤销。",
  "settings.memoryNoProviderBannerTitle": "LLM 抽取未启用",
  "settings.memoryNoProviderBannerBody":
    "未找到可用的 API key，LLM 抽取已跳过。可以在媒体提供商里填入 OpenAI key，或设置环境变量 ANTHROPIC_API_KEY / OPENAI_API_KEY 来启用。启发式抽取仍在运行。",
  "settings.libraryInstall": "安装",
  "settings.libraryInstallGithub": "GitHub",
  "settings.libraryInstallLocal": "本地路径",
  "settings.libraryInstallUrl": "https://github.com/owner/repo",
  "settings.libraryInstallPath": "/path/to/skill-folder",
  "settings.libraryInstallButton": "安装",
  "settings.libraryUninstall": "卸载",
  "settings.libraryBuiltIn": "内置",
  "settings.libraryInstalled": "已安装",
  "notify.successTitle": "任务已完成",
  "notify.failureTitle": "任务失败",
  "notify.successBody": "一轮回答已经写完。",
  "notify.failureBody": "本轮任务出错，请查看错误信息。",
  "updater.available": "有可用更新",
  "updater.availableBody":
    "Crie3 {version} 可用。下载安装完成后即可打开安装器。",
  "updater.checking": "正在检查更新",
  "updater.download": "下载更新",
  "updater.downloading": "正在下载更新",
  "updater.downloadingPercent": "正在下载更新 {percent}%",
  "updater.done": "完成",
  "updater.failed": "更新失败",
  "updater.installerOpenBody":
    "安装器已打开。Crie3 正在退出，以便你完成更新。",
  "updater.installerOpened": "安装器已打开",
  "updater.later": "稍后",
  "updater.allowSilentUpdates": "允许静默更新",
  "updater.openFailedFallback": "无法打开安装器。",
  "updater.installRestart": "安装并重启",
  "updater.installingRestart": "正在安装并重启…",
  "updater.openInstaller": "安装更新",
  "updater.opening": "正在打开安装器…",
  "updater.payloadReadyGeneric":
    "Crie3 更新已就绪。Crie3 会关闭并自动重启。",
  "updater.payloadReadyVersion":
    "Crie3 {version} 已就绪。Crie3 会关闭并自动重启。",
  "updater.quitButton": "退出 Crie3",
  "updater.quitFailedBody":
    "安装器已打开，但 Crie3 无法退出。替换应用前请先退出 Crie3。",
  "updater.quitFailedTitle": "无法退出",
  "updater.quitting": "正在退出…",
  "updater.ready": "更新已就绪",
  "updater.readyGeneric": "新版本已就绪。Crie3 会关闭并打开安装器。",
  "updater.readyVersion":
    "Crie3 {version} 已就绪。Crie3 会关闭并打开安装器。",
  "updater.upToDate": "您已经是最新版本啦",

  "whatsNew.cta": "看看有什么新功能",
  "whatsNew.dismissAria": "关闭更新亮点",

  'designBrowser.copyScreenshot': '复制截图',
  'designBrowser.hardReload': '强制刷新',
  'designBrowser.copyUrl': '复制 URL',
  'designBrowser.openExternal': '在外部打开',
  'designBrowser.downloadPage': '下载页面',
  'designBrowser.downloadPageBusy': '正在下载页面...',
  'designBrowser.clearHistory': '清空历史',
  'designBrowser.clearCookies': '清除 Cookie',
  'designBrowser.clearAllData': '清除所有浏览器数据',
  'designBrowser.status.openHttpFirst': '请先打开 http 或 https 页面。',
  'designBrowser.status.openBeforeScreenshot': '请先打开页面再截图。',
  'designBrowser.status.openBeforeBrief': '请先打开页面再保存简报。',
  'designBrowser.status.openBeforeDownload': '请先打开页面再保存快照。',
  'designBrowser.status.pageSnapshotStarted': '正在保存页面快照...',
  'designBrowser.status.pageSnapshotUnsupported': '当前页面无法归档。',
  'designBrowser.status.pageSnapshotFailed': '页面快照保存失败。',
  'designBrowser.status.pageSnapshotSaved': '已保存页面快照（HTML + CSS）。',
  'designBrowser.status.viewDesignFiles': '查看设计文件',
  'designBrowser.status.downloadAssistHint': '第 2 步：在这里点击“下载页面”，等待页面快照保存成功，然后回到左侧“下一步”卡片点击“继续提取”。',
  'settings.amrBalance': '余额',
  'settings.amrPlan': '套餐',
  'settings.amrUpgrade': '升级',
  'settings.amrModelUpgradeHint': '升级后使用',
  'settings.updateCheck': '检查更新',
  'settings.updateNow': '立即更新',
  'settings.updateRecheck': '重新检查',
  'settings.updateRetry': '重试',
  'settings.updateViewReleases': '查看发布记录',
  'settings.updateActionFailed': '无法完成更新操作。',
  'settings.updateQuitFailed': '安装程序已打开，但 Crie3 未能自动退出。',
  'settings.updateStatusNotChecked': '未检查更新',
  'settings.updateStatusDevelopment': '开发环境不支持应用内更新。',
  'settings.updateStatusUnsupported': '当前环境不支持应用内更新。',
  'settings.updateStatusChecking': '正在检查更新…',
  'settings.updateStatusUpToDate': '您已经是最新版本。',
  'settings.updateStatusAvailable': '发现新版本 {version}，正在准备下载',
  'settings.updateStatusAvailableUnknown': '发现新版本，正在准备下载',
  'settings.updateStatusDownloading': '正在下载更新…',
  'settings.updateStatusDownloadingPercent': '正在下载更新 {percent}%。',
  'settings.updateStatusReady': '版本 {version} 已准备好安装。',
  'settings.updateStatusReadyUnknown': '更新已准备好安装。',
  'settings.updateStatusInstalling': '正在安装更新…',
  'settings.updateStatusFailed': '检查失败，请重试',
  'designs.menuDuplicate': '复制项目',
  'project.typePrototype': '原型',
  'project.typeDeck': '幻灯片',
  'project.typeTemplate': '模板',
  'project.typeImage': '图片',
  'project.typeVideo': '视频',
  'project.typeAudio': '音频',
  'chat.brandBrowserLocalSnapshotMissing': '此 URL 没有已保存的页面快照。',
  'chat.brandBrowserLocalSnapshotReadFailed': '无法读取已保存的页面快照。',
  'chat.brandBrowserSnapshotSaveFailed': '无法从浏览器保存页面快照。',
  'chat.brandBrowserAssistDownloadGuideTitle': '已打开 Browser',
  'chat.brandBrowserAssistDownloadGuideDetails': '第 1 步：打开或切到右侧 Browser tab，并完成必要的人机验证。第 2 步：点击 More，再点击“下载页面”。第 3 步：等待页面快照保存成功提示。第 4 步：回到左侧“下一步”卡片，点击“继续提取”继续程序化抽取。',
  'designFiles.projectMenu': '项目操作',
  'designFiles.createDesignSystemFromProject': '基于此项目创建设计系统',
  'designFiles.duplicateProject': '复制项目',
  'fileViewer.versions.entry': '版本',
  'fileViewer.versions.title': '版本管理',
  'fileViewer.versions.countOne': '1 个版本',
  'fileViewer.versions.countMany': '{count} 个版本',
  'fileViewer.versions.current': '当前',
  'fileViewer.versions.sourceAi': 'AI 编辑',
  'fileViewer.versions.sourceManual': '手动编辑',
  'fileViewer.versions.sourceRestore': '回退生成',
  'fileViewer.versions.restoredFrom': '从 v{version} 回退',
  'fileViewer.versions.versionLabel': '版本 {version}',
  'fileViewer.versions.listAria': '文件版本',
  'fileViewer.versions.loading': '正在加载版本...',
  'fileViewer.versions.empty': '暂无版本。',
  'fileViewer.versions.loadFailed': '无法加载版本。',
  'fileViewer.versions.previewFailed': '无法加载此版本预览。',
  'fileViewer.versions.previewLoading': '正在加载版本预览...',
  'fileViewer.versions.noPrompt': '未记录提示词',
  'fileViewer.versions.noPromptBody': '此版本没有记录提示词。',
  'fileViewer.versions.promptTitle': '提示词',
  'fileViewer.versions.copyPrompt': '复制提示词',
  'fileViewer.versions.fullscreen': '全屏预览',
  'fileViewer.versions.open': '打开预览',
  'fileViewer.versions.currentHelp': '这已经是当前版本。',
  'fileViewer.versions.restoreHelp': '切换会把此 HTML 恢复为新的当前版本。',
  'fileViewer.versions.restore': '切换到此版本',
  'fileViewer.versions.restoreConfirmTitle': '切换到此版本？',
  'fileViewer.versions.restoreConfirmCta': '切换',
  'fileViewer.versions.restoring': '切换中...',
  'fileViewer.versions.restoreFailed': '无法切换到此版本。',
  'fileViewer.versions.restoreSuccess': '已切换到此版本。',
  'nextStep.createDesignSystemTitle': '创建设计系统',
  'nextStep.createDesignSystemBody': '复制当前项目为设计系统工作区，并基于所有当前文件和参考启动 agent 生成。',
  'nextStep.createDesignSystemBusy': '正在创建设计系统...',
  'nextStep.projectContinueTitle': '继续处理',
  'nextStep.projectGenerateArtifactTitle': '生成产物',
  'nextStep.designSystemAiRefineTitle': 'AI 优化设计系统',
  'nextStep.designSystemAuditKitTitle': '审查 tokens 和组件套件',
  'nextStep.brandCreateDesignPrompt': '用「{designSystem}」设计系统创建一个新设计。',
  'nextStep.brandContinueExtractionTitle': '继续抽取',
  'nextStep.brandContinueExtractionBody': 'Browser 标签页完成验证后，读取当前页面并继续填充已保存的设计系统。',
  'nextStep.brandContinueExtractionBusy': '正在继续抽取...',
  'nextStep.brandContinueAiExtractionTitle': '继续 agent 抽取',
  'nextStep.brandContinueAiExtractionProgrammaticBody': '如果程序化抽取仍无法完成，使用当前 agent 从已保存草稿继续抽取。',
  'nextStep.brandContinueAiExtractionAiBody': '从当前品牌脚手架恢复 agent 抽取，并完成同一个设计系统。',
  'nextStep.brandContinueAiExtractionBusy': '正在继续 agent 抽取...',


  "newsletter.label": "邮箱地址（选填）",
  "newsletter.placeholder": "you@studio.com",
  'newsletter.phoneLabel': 'Telefone / WhatsApp (opcional)',
  'newsletter.phonePlaceholder': '(00) 00000-0000',
  'newsletter.consent': 'Aceito receber novidades e contato do Crie3 por e-mail e WhatsApp.',
  "settings.memoryModelInlineLabel": "Memory 模型",
  "settings.memoryModelInlineSameAsChat": "与聊天一致",
  "settings.memoryModelInlineSameAsChatWithModel": "与聊天一致（{model}）",
  "settings.memoryModelInlineSameAsChatWithProvider":
    "与聊天一致（{provider}）",
  "settings.memoryModelInlineHintCli":
    "可选。支持的情况下会直接使用当前 Local CLI；这里只需要在想覆盖默认模型时选择。",
  "settings.memoryModelInlineHintCliConstrained":
    "可选。支持时会直接使用当前 Local CLI；{provider} 只作为不支持 CLI 时的备用供应商。",
  "settings.memoryModelInlineHintByok":
    "可选。复用你聊天用的 API key，在同供应商上换一个（通常更便宜的）模型来跑后台 memory 提取。",
  "settings.memoryModelInlineHintByokNeutral":
    "Memory 使用独立于聊天的模型，默认沿用当前聊天模型。",
  "settings.memoryModelInlineFlashSaved": "已保存",
  "settings.memoryModelInlineFlashCleared": "已清除",
  "settings.orbit.eyebrow": "自动化",
  "settings.orbit.title": "Orbit",
  "settings.orbit.navHint": "每日连接器摘要",
  "settings.orbit.lede":
    "按计划收集连接器活动，并将结果发布为可刷新的实时看板。",
  "settings.orbit.statusOnTitle": "每日计划运行已开启",
  "settings.orbit.statusOffTitle": "每日计划运行已关闭",
  "settings.orbit.statusActive": "活跃",
  "settings.orbit.statusOff": "关闭",
  "settings.orbit.runTitle": "启动一次 Orbit 运行并打开实时对话",
  "settings.orbit.running": "运行中…",
  "settings.orbit.runOpen": "立即运行",
  "settings.orbit.dailySummaryTitle": "每日摘要",
  "settings.orbit.dailySummarySub": "每天在计划的本地时间运行一次。",
  "settings.orbit.on": "开启",
  "settings.orbit.off": "关闭",
  "settings.orbit.runTimeTitle": "运行时间",
  "settings.orbit.runTimeSub": "默认 08:00。保存后应用到 daemon 计划。",
  "settings.orbit.runTimeAria": "每日 Orbit 运行时间",
  "settings.orbit.nextRun": "下次运行",
  "settings.orbit.nextRunScheduledAfterSave": "保存后计划",
  "settings.orbit.schedule": "计划",
  "settings.orbit.pausedManualOnly": "已暂停 — 仅手动运行",
  "settings.orbit.templateTitle": "提示词模板",
  "settings.orbit.templateMissing": "模板 {id} 未安装。",
  "settings.orbit.templateMissingOption": "{id}（缺失）",
  "settings.orbit.templateMissingInstall": "安装 Orbit skill 以引导提示词。",
  "settings.orbit.templateMissingPickAnother": "从下拉菜单选择另一个模板。",
  "settings.orbit.templateResetTitle": "重置为 {id}",
  "settings.orbit.templateReset": "重置",
  "settings.orbit.templateHelp":
    "用 skill 引导 Orbit — 所选模板的示例提示词会注入每次 Orbit 运行，让摘要遵循该模板结构。",
  "settings.orbit.templateAria": "Orbit 提示词模板",
  "settings.orbit.templatesLoading": "正在加载模板…",
  "settings.orbit.templatesOptgroup": "Orbit skill 模板",
  "settings.orbit.lastRun": "上次运行",
  "settings.orbit.triggerManual": "手动",
  "settings.orbit.triggerScheduled": "计划",
  "settings.orbit.meterAria":
    "已成功 {succeeded}，已跳过 {skipped}，失败 {failed}，共检查 {checked}",
  "settings.orbit.countChecked": "已检查",
  "settings.orbit.countSucceeded": "成功",
  "settings.orbit.countSkipped": "已跳过",
  "settings.orbit.countFailed": "失败",
  "settings.orbit.runError":
    "无法运行 Orbit。请确认本地 daemon 正在运行且连接器已配置。",
  "settings.orbit.gateAriaLabel": "使用 Orbit 需要先配置连接器",
  "settings.orbit.gateEyebrow": "需要先完成设置",
  "settings.orbit.gateTitle": "连接一个工具，让 Orbit 运行起来",
  "settings.orbit.gateBody":
    "Orbit 会汇总你已连接服务的活动。你目前还没有任何连接 —— 至少添加一个集成，让 Orbit 有内容可以报告。",
  "settings.orbit.gateBodyNoKey":
    "Orbit 会汇总连接器的活动，而连接器通过 Composio 运行。在「连接器」中填入 Composio API 密钥即可解锁目录并选择第一个集成。",
  "settings.orbit.gateAction": "打开连接器",
  "settings.orbit.gateActionNoKey": "配置 Composio",
  "settings.orbit.gateLoading": "正在检查连接器…",
  "settings.orbit.controlsLockedBadge": "已锁定",
  "settings.orbit.controlsLockedHint":
    "连接一个工具后即可解锁 Orbit 的排程与模板设置。",
  "settings.orbit.artifactKickerLive": "实时看板",
  "settings.orbit.artifactKickerLegacy": "旧版摘要",
  "settings.orbit.artifactTitle": "每日 Orbit 活动摘要",
  "settings.orbit.artifactMetaLive": "由连接器活动生成的可刷新 HTML artifact。",
  "settings.orbit.artifactMetaLegacy":
    "在启用实时看板支持之前生成 — 再次运行 Orbit 以发布一个。",
  "settings.orbit.copyMarkdownTitle": "复制 Markdown 摘要到剪贴板",
  "settings.orbit.copied": "已复制",
  "settings.orbit.copy": "复制",
  "settings.orbit.openArtifact": "打开 artifact",
  "settings.orbit.sourceMarkdown": "源 Markdown",
  "diagnostics.exportTitle": "导出诊断日志",
  "diagnostics.exportButton": "导出诊断日志",
  "diagnostics.exportHint":
    "将近期的应用日志和机器信息打包成 zip,方便发给我们排查问题。",
  "diagnostics.exporting": "导出中…",
  "diagnostics.exportSuccess": "诊断日志已保存到 {path}",
  "diagnostics.exportFailed": "导出诊断日志失败：{message}",
  "automations.eyebrow": "定时智能体会话",
  "automations.title": "自动化",
  "automations.lede": "为项目工作、Orbit 摘要和实时看板规划周期性会话。",
  "automations.summaryAria": "自动化概览",
  "automations.metricActive": "运行中",
  "automations.metricPaused": "已暂停",
  "automations.metricTemplates": "模板",
  "automations.newAutomation": "新建自动化",
  "automations.yourAutomations": "你的自动化",
  "automations.loading": "加载中",
  "automations.emptyTitle": "还没有自动化",
  "automations.emptyBody": "从模板创建一个，或从空白计划开始。",
  "automations.targetNewEachRun": "每次运行新建项目",
  "automations.targetCreateEachRun": "每次运行新建项目",
  "automations.lastRun": "上次运行 {time}",
  "automations.openResult": "打开结果",
  "automations.run": "运行",
  "automations.runNowTitle": "立即运行并打开会话",
  "automations.history": "历史记录",
  "automations.hideHistory": "隐藏历史记录",
  "automations.edit": "编辑",
  "automations.pause": "暂停",
  "automations.resume": "恢复",
  "automations.deleteAria": "删除自动化",
  "automations.deleteTitle": "删除此自动化",
  "automations.deleteConfirm": "删除此自动化？过去的运行及其项目会保留。",
  "automations.proposalsTitle": "进化提案",
  "automations.proposalsSub":
    "在自动化输出改动记忆、技能或设计体系之前先审阅。",
  "automations.proposalsPending": "{n} 个待处理",
  "automations.apply": "应用",
  "automations.reject": "拒绝",
  "automations.proposalsDismissReason": "在自动化中已忽略",
  "automations.templatesTitle": "模板",
  "automations.templatesSub": "Orbit 和实时看板都是同一自动化流程中的模板。",
  "automations.templatesCount": "{total} 个中的 {filtered} 个",
  "automations.templateFiltersAria": "模板筛选器",
  "automations.templatesEmptyTitle": "此分类下还没有模板。",
  "automations.templatesEmptyBody": "换一个筛选条件，或从空白自动化开始。",
  "automations.useTemplate": "使用模板",
  "automations.promptPlaceholder":
    "告诉代理按此计划运行什么，或用 @ 提及上下文...",
  "automations.runHistoryLoading": "正在加载运行历史…",
  "automations.runHistoryEmpty": "还没有运行记录。",
  "automations.runHistoryTitle": "运行历史",
  "automations.runHistoryLatest": "最近 10 条",
  "automations.crystallize": "沉淀",
  "automations.crystallizing": "沉淀中",
  "automations.crystallizeTitle": "根据本次运行起草技能和记忆提案",
  "automations.crystallizeFailed": "Crystallize failed: {error}",
  "automations.crystallizePartialSuccess":
    "Crystallize created proposals, but Automations could not refresh the proposal list. Review the visible proposals or try refreshing.",
  "automations.crystallizeRefreshFailed":
    "Crystallize finished, but Automations could not refresh proposals. Try refreshing before running it again.",
  "automations.crystallizeNoProposals":
    "Crystallize finished, but no proposals were returned. Try refreshing or check the run details.",
  "automations.openConversation": "打开会话",
  "automations.runHistoryAria": "自动化运行历史",
  "automations.proposalsAria": "自动化进化提案",
  "automations.templatesAria": "自动化模板",
  "automations.runInProgress": "进行中",
  "automations.scheduleStatusPaused": "已暂停",
  "automations.nextRunManualOnly": "仅手动",
  "automations.nextRunScheduled": "已排期",
  "automations.nextRunAt": "下次 {time}",
  "automations.statusSucceeded": "成功",
  "automations.statusFailed": "失败",
  "automations.statusRunning": "运行中",
  "automations.statusQueued": "排队中",
  "automations.statusCanceled": "已取消",
  "automations.kindOrbit": "Orbit",
  "automations.kindLiveArtifact": "实时看板",
  "automations.kindAutomation": "自动化",
  "automations.proposalTargetMemory": "记忆",
  "automations.proposalTargetDesignSystem": "设计体系",
  "automations.proposalTargetSkill": "技能",
  "automations.proposalTargetTemplate": "自动化模板",
  "automations.proposalActionCreate": "创建",
  "automations.proposalActionUpdate": "更新",
  "automations.proposalActionMerge": "合并",
  "automations.proposalActionMove": "移动",
  "automations.proposalActionDelete": "删除",
  "automations.proposalActionPromote": "提升",
  "automations.filterAll": "全部",
  "automations.filterOrbit": "Orbit",
  "automations.filterLiveArtifacts": "实时看板",
  "automations.filterMemory": "记忆",
  "automations.filterDesignSystems": "设计体系",
  "automations.filterSkills": "技能",
  "automations.filterConnectors": "连接器",
  "automations.filterCompression": "压缩",
  "automations.filterRelease": "发布",
  "automations.filterQuality": "质量",
  "automations.tpl.memoryRefresh.title": "根据近期工作刷新项目记忆。",
  "automations.tpl.memoryRefresh.desc":
    "把重复的决策、偏好和反馈转化为可复用的记忆更新。",
  "automations.tpl.designSystemRefresh.title": "根据已交付的制品更新设计体系。",
  "automations.tpl.designSystemRefresh.desc":
    "在近期设计工作中发现可复用的 token、组件和规则。",
  "automations.tpl.liveArtifactRegistry.title": "审计实时看板并刷新过时版本。",
  "automations.tpl.liveArtifactRegistry.desc":
    "让持久的仪表盘、报告和预览保持最新，而不是重复创建。",
  "automations.tpl.orbitDashboard.title": "构建连接器活动仪表盘。",
  "automations.tpl.orbitDashboard.desc":
    "把选定的连接器聚合成 Orbit 风格的实时仪表盘。",
  "automations.tpl.releaseNotes.title": "根据已交付的设计工作起草发布说明。",
  "automations.tpl.releaseNotes.desc":
    "把已合并的 PR、制品和面向产品的改动整合成发布说明。",
  "automations.tpl.qualityRegressionWatch.title": "监测设计与实现的回归问题。",
  "automations.tpl.qualityRegressionWatch.desc":
    "把近期改动与基准、追踪记录和已采纳的参考进行对比。",
  "automations.tpl.orbitDaily.title": "每日连接器摘要。",
  "automations.tpl.orbitDaily.desc": "按计划刷新连接器活动摘要。",
  "automations.tpl.liveStatusBoard.title": "保持实时状态制品始终最新。",
  "automations.tpl.liveStatusBoard.desc":
    "更新同一个持久制品，而不是每次运行都新建报告。",
  "dsManager.areaAria": "设计体系区域",
  "dsManager.tabDesignSystem": "设计体系",
  "dsManager.tabTemplate": "模板",
  "dsManager.sourceAria": "设计体系来源",
  "dsManager.templateSourceAria": "模板来源",
  "dsManager.yourSystems": "你的体系",
  "dsManager.officialPresets": "官方预设",
  "dsManager.enterprise": "企业版",
  "dsManager.yourTemplates": "你的模板",
  "dsManager.yourSystemsAria": "你的设计体系",
  "dsManager.eyebrowDesignSystems": "设计体系",
  "dsManager.yourSystemsHeading": "你的体系",
  "dsManager.filterAria": "筛选设计体系",
  "dsManager.filterAll": "全部",
  "dsManager.filterPublished": "已发布",
  "dsManager.filterDraft": "草稿",
  "dsManager.createTitle": "新建设计体系",
  "dsManager.createBody":
    "把你的品牌、产品、代码、素材和设计参考教给 Crie3。",
  "dsManager.createAction": "创建",
  "dsManager.emptyMine":
    "还没有设计体系。从真实的产品上下文创建一个，审阅草稿后再发布，供以后的项目使用。",
  "dsManager.badgeDefault": "对话默认",
  "dsManager.rowMetaUpdated": "你 · 更新于 {date}",
  "dsManager.edit": "编辑",
  "dsManager.openSystem": "编辑体系",
  "dsManager.editWithAgent": "用 Agent 编辑",
  "dsManager.downloadTitle": "下载设计体系（.zip + SKILLS.md）",
  "dsManager.downloadAria": "下载 {title} 为 .zip",
  "dsManager.downloadFailed": "无法下载该设计体系，请重试。",
  "dsManager.deleteConfirm":
    "删除「{title}」？这会从本设备移除该草稿设计体系。",
  "dsManager.makeDefault": "设为新对话默认",
  "dsManager.statusPublished": "已发布",
  "dsManager.statusDraft": "草稿",
  "dsWorkspace.back": "Back",
  "dsWorkspace.setDefault": "Default for new chats",
  "dsWorkspace.setDefaultHint": "Preselect this design system for new chats and new projects.",
  "dsWorkspace.fontsMissingTitle": "Brand font files missing",
  "dsWorkspace.fontsMissingBody": "Typography previews are using substitute web fonts until brand font files are added.",
  "dsWorkspace.addFonts": "Add brand font files",
  "dsWorkspace.stepRead": "Read current system",
  "dsWorkspace.stepUpdate": "Update design files",
  "dsWorkspace.stepRefresh": "Refresh review",
  "dsManager.openSystemAria": "编辑 {title}",
  "dsManager.deleteSystemAria": "删除 {title}",
  "dsManager.presetsAria": "官方设计体系预设",
  "dsManager.eyebrowLibrary": "库",
  "dsManager.eyebrowTemplates": "模板",
  "dsManager.yourTemplatesAria": "你的模板",
  "dsManager.emptyTemplates":
    "还没有模板。启用模板发布后，可通过任意已生成项目的「分享」来创建。",
  "dsManager.templateDescFallback": "从项目创建",
  "dsManager.comingSoonBadge": "敬请期待",
  "dsManager.enterpriseDsTitle": "企业设计体系",
  "dsManager.enterpriseDsBody": "团队共享的设计体系和受管控的品牌库即将推出。",
  "dsManager.enterpriseTplTitle": "企业模板",
  "dsManager.enterpriseTplBody": "团队批准的模板和组织级发布即将推出。",
  "settings.instructionsTitle": "指令 / 规则",
  "settings.instructionsSubtitle": "助手应始终遵循的固定行为",
  "settings.instructionsNavSub": "固定的助手行为",
  "settings.customInstructionsDesc":
    "Crie3 在每次对话中都会遵循的固定指令。它们不是保存的记忆；事实、偏好和项目上下文请使用「记忆」。",
  "mcpClient.forwardedToLabel": "已转发给：",
  "mcpClient.notForwardedToLabel": "未转发给：",
  "mcpClient.forwardedAcpNote":
    "标记为 stdio only 的 ACP 适配器只会从此列表接收 stdio 类型的 MCP 服务器；HTTP 和 SSE 条目会在启动时被丢弃。",
  "mcpClient.notForwardedNote":
    "对于这些智能体，请在其各自的配置文件中配置 MCP 服务器（例如 ~/.codex/config.toml、~/.gemini/settings.json）；下方的服务器在那里不会生效。",

  // Design systems library + extraction
  "brand.libraryTitle": "设计系统",
  "brand.librarySubtitle":
    "把你的设计系统教给 Crie3——从网站提取一个设计系统，然后在任意对话中应用它。",
  "brand.newBrand": "新建设计系统",
  "brand.searchPlaceholder": "搜索你的设计系统…",
  "brand.empty": "还没有设计系统。从一个网站提取一个设计系统即可开始。",
  "brand.colorsCount": "{count} 种颜色",
  "brand.extracting": "提取中…",
  "brand.failed": "提取失败",
  "brand.needsInput": "需要操作",
  "brand.needsInputHint": "提取已暂停 —— 打开项目完成验证或回答问题。",
  "brand.appliedToChat": "正在使用 {name}",
  "brand.previewEmpty": "选择一个设计系统进行预览",
  "brand.viewDetails": "查看详情",
  "newBrand.title": "新建设计系统",
  "newBrand.subtitle":
    "粘贴一个网站，或在下方挑选一个品牌，我们会提取它的颜色、字体和标识。",
  "newBrand.urlLabel": "品牌网站",
  "newBrand.urlPlaceholder": "yourcompany.com",
  "newBrand.extract": "提取设计系统",
  "newBrand.cancel": "取消",
  "newBrand.close": "关闭",
  "newBrand.stage1": "正在抓取网站并测量其设计",
  "newBrand.stage2": "正在构建设计系统预览",
  "newBrand.stage3": "正在推导并注册设计系统",
  "newBrand.measured": "{colors} 种颜色 · {fonts} 种字体 · {logos} 个标识",
  "newBrand.done": "设计系统已就绪",
  "brandDetail.identity": "品牌标识",
  "brandDetail.designLanguage": "设计语言",
  "brandDetail.colors": "颜色",
  "brandDetail.fonts": "字体",
  "brandDetail.tone": "语气",
  "brandDetail.aesthetic": "审美风格",
  "brandDetail.tagline": "标语",
  "brandDetail.voice": "声音",
  "brandDetail.useInChat": "在新对话中使用",
  "brandDetail.delete": "删除设计系统",
  "brandDetail.back": "设计系统",
  "brandDetail.refining": "正在优化此设计系统…",
  "brandDetail.notFound": "未找到设计系统。",
  "brandDetail.logo": "Logo",
  "brandDetail.typography": "字体排版",
  "brandDetail.palette": "调色板",
  "brandDetail.voiceTone": "语气与调性",
  "brandDetail.imageryLayout": "图像与布局",
  "brandDetail.images": "图像",
  "brandDetail.designSystem": "设计系统",
  "brandDetail.brandAssets": "设计系统素材",
  "brandDetail.openProject": "打开项目",
  "brandDetail.themeLight": "浅色",
  "brandDetail.themeDark": "深色",
  "brandDetail.subjects": "主题",
  "brandDetail.treatment": "处理方式",
  "brandDetail.useLabel": "使用",
  "brandDetail.avoidLabel": "避免",
  "brandDetail.layoutPosture": "布局准则",
  "brandDetail.deleteConfirm": '删除"{name}"？这会移除该设计系统。',
  "brandDetail.viewMore": "查看全部 {count} 张",
  "brandDetail.viewLess": "收起",
  "settings.resetOnboarding": "重置引导流程",
  "settings.resetOnboardingDesc": "重新进行首次设置，包括品牌提取。",
  "settings.resetOnboardingButton": "重置",
  "onboarding.brandTitle": "提取你的设计系统",
  "onboarding.brandSubtitle":
    "粘贴品牌网站，我们会把品牌线索转成后续可复用的设计系统。",
  "onboarding.brandSkip": "暂时跳过",
  "onboarding.brandDone": "设计系统已提取",
  "onboarding.buildTitle": "一次创建,处处复用",
  "onboarding.buildBody":
    "Crie3 把你的品牌沉淀为可复用的设计系统,让你之后构建的一切都保持品牌一致。",
  "onboarding.buildBenefitMemoryTitle": "一份品牌记忆",
  'onboarding.buildBenefitMemoryBody': '颜色、字体、标志和语气都会保存下来，用在每一件作品里。',
  "onboarding.buildBenefitAlignedTitle": "每个产出都保持一致",
  'onboarding.buildBenefitAlignedBody': '帖子、轮播、快拍和邀请函都遵循同一套规则。',
  "onboarding.buildBenefitSourcesTitle": "从已有材料开始",
  'onboarding.buildBenefitSourcesBody': '使用你的网站、Instagram、标志、照片或现有字体。',
  "onboarding.buildPreviewLabel": "品牌系统",
  "onboarding.buildStart": "创建设计系统",
  "onboarding.interview.title": "来了解一下你的教会吧",
  "onboarding.interview.body": "回答几个简单的问题，AI 就会为你填写用于内容创作的教会资料。你也可以跳过，稍后在设置中填写。",
  "onboarding.interview.placeholder": "输入你的回答…",
  "onboarding.interview.send": "发送",
  "onboarding.interview.skip": "暂时跳过",
  'onboarding.interview.start': '现在回答',
  "onboarding.interview.sending": "正在输入…",
  "onboarding.interview.error": "现在无法继续访谈。你可以跳过，稍后在 设置 → 我的品牌 中填写。",
  "onboarding.interview.errorQuota": "你的账户本月的 AI 用量已用完。先跳过吧，你可以在 设置 → 我的品牌 中填写资料。",
  "onboarding.interview.errorBusy": "AI 当前繁忙，请稍后再试。",
  "onboarding.interview.errorNotConfigured": "此安装不支持 AI 访谈。先跳过吧，你可以在 设置 → 我的品牌 中手动填写资料。",
  "onboarding.interview.retry": "重试",
  "onboarding.logo.title": "上传教会标志",
  "onboarding.logo.body": "它会保存在你的教会资料中，并用在 Crie3 制作的作品上。如果有两个版本，请上传浅色背景用和深色背景用的版本。你可以跳过，稍后在 设置 → 我的品牌 中上传。",
  "onboarding.interview.titleMinistry": "来了解一下你的事工吧",
  "onboarding.interview.titleWorship": "来了解一下你的乐队吧",
  "onboarding.interview.titleAgency": "来了解一下你的机构吧",
  "onboarding.interview.bodyProfile": "回答几个简单的问题，AI 就会为你填写用于内容创作的资料。你也可以跳过，稍后在设置中填写。",
  "onboarding.logo.titleMinistry": "上传事工标志",
  "onboarding.logo.titleWorship": "上传乐队标志",
  "onboarding.logo.titleAgency": "上传机构标志",
  "onboarding.logo.bodyProfile": "它会保存在你的资料中，并用在 Crie3 制作的作品上。如果有两个版本，请上传浅色背景用和深色背景用的版本。你可以跳过，稍后在设置中上传。",
  "onboarding.interview.done": "资料已保存！你可以随时在 设置 → 我的品牌 中调整。",
  "onboarding.interview.continue": "继续",
  "onboarding.buildHome": "直接进入主页",
  "dsCreate.heroEyebrow": "设计系统",
  "dsCreate.heroTitle": "几分钟搭建设计系统",
  "dsCreate.heroLede": "把一个网站或 DESIGN.md，连同你已有的上下文，变成可直接使用、符合品牌的设计系统。",
  "dsCreate.heroStepCount": "3 步",
  "dsCreate.heroDuration": "约 3 分钟",
  "dsCreate.heroStep1Title": "你的品牌",
  'dsCreate.heroStep1Desc': '使用“我的品牌”资料、网站或 Instagram',
  "dsCreate.heroStep2Title": "上传素材",
  "dsCreate.heroStep2Desc": "标志、封面、照片、字体（可选）",
  "dsCreate.heroStep3Title": "生成",
  "dsCreate.heroStep3Desc": "先出草稿，AI 之后再细化",
  "dsCreate.heroShowcaseTitle": "你的设计系统",
  "dsFonts.missingTitle": "缺少品牌字体文件",
  "dsFonts.missingBody": "在添加品牌字体文件之前，排版预览将使用替代网页字体。",
  "dsCreate.referenceLabel": "从现有设计系统复制",
  "dsCreate.referenceLoading": "正在加载 DESIGN.md...",
  "dsCreate.referenceLoadFailed": "无法加载该设计系统。",
  "dsCreate.heroShowGuideAria": "显示设计系统指南",
  "dsCreate.heroHideGuideAria": "隐藏设计系统指南",
  "dsCreate.heroShowGuideTitle": "显示指南",
  "dsCreate.heroHideGuideTitle": "隐藏指南",
  "dsCreate.heroGuide": "指南",
  "dsCreate.missingSourceError":
    "请添加网站、DESIGN.md、描述、文件、Figma 来源或备注来创建设计系统。",
  "dsCreate.continueToGeneration": "继续生成",
  "dsCreate.embeddedTitle": "从你的素材生成",
  "dsCreate.embeddedBody": "先添加网站或品牌参考，再补充你已有的源文件。",
  "dsCreate.sourceSectionTitle": "从 GitHub、网站或源素材提取",
  "dsCreate.sourceSectionBody":
    "从 GitHub 仓库、网站、DESIGN.md 或能体现风格的文件开始。Crie3 会先快速创建一套可用系统，然后 AI 可在项目中继续细化。",
  "dsCreate.githubWebsiteLabel": "GitHub 或网站",
  "dsCreate.add": "添加",
  "dsCreate.startFromBrand": "从品牌开始",
  "dsCreate.brandPickerSubtitle":
    "搜索数百个品牌，选择一个后我们会把它的网站作为风格参考加入。",
  "dsCreate.brandPickerQuickPicks": "热门品牌 · 点击添加",
  "dsCreate.addedSourceLinks": "已添加的来源链接",
  "dsCreate.openSourceLabel": "打开 {label}",
  "dsCreate.removeSourceLabel": "移除 {label}",
  "dsCreate.addFiles": "添加文件",
  "dsCreate.describeBrand": "描述品牌",
  "dsCreate.optional": "可选",
  "dsCreate.describeBrandHelp":
    "品牌语气、简介和产品上下文。会用于快速生成和 AI 细化。",
  "dsCreate.companyPlaceholder":
    "例如：Mission Impastabowl，一个支持自助点餐、移动应用和网站的快休闲意面餐厅",
  "dsCreate.pasteDesignMd": "粘贴 DESIGN.md",
  "dsCreate.pasteDesignMdHelp":
    "粘贴 DESIGN.md，即可直接从 token、设计理由和组件指南创建设计系统。",
  "dsCreate.reference": "参考",
  "dsCreate.designMdViewMode": "DESIGN.md 查看模式",
  "dsCreate.advancedToggle": "高级 · 仓库、本地代码、Figma",
  "dsCreate.githubRepo": "GitHub 仓库",
  "dsCreate.localCodeLabel": "关联本地代码",
  "dsCreate.localCodeHelper": "使用此电脑上的文件夹或选中的文件。",
  "dsCreate.localCodePrompt": "拖入文件夹或浏览",
  "dsCreate.uploadFigLabel": "上传 .fig",
  "dsCreate.uploadFigHelper":
    "在你的设备上解码为真实 token、组件和素材，无需 Figma 账号。",
  "dsCreate.uploadFigPrompt": "拖入 .fig 或浏览",
  "dsCreate.figmaUrl": "Figma URL",
  "dsCreate.figmaPlaceholder": "https://figma.com/design/… 或 /file/…",
  "dsCreate.addedFigmaUrls": "已添加的 Figma URL",
  "dsCreate.savedFigmaHelp":
    "已保存为 Figma 设计来源。Agent 会把它作为标准参考；如需完整离线解码，请在上方导出 .fig。",
  "dsCreate.notes": "备注",
  "dsCreate.notesPlaceholder":
    "例如：我们使用温暖自然的配色和圆角。品牌语气有趣但专业...",
  "dsCreate.back": "返回",
  "dsCreate.generate": "生成",
  "dsCreate.libraryPickerTitle": "从资料库选择",
  "dsCreate.libraryPickerConfirm": "添加到素材",
  "dsCreate.designMdPreviewKicker": "设计系统",
  "dsCreate.designMdPreviewTitle": "DESIGN.md 预览",
  "dsCreate.componentKit": "组件套件",
  "dsCreate.defaultTheme": "默认主题",
  "dsCreate.componentKitTitle": "{name} · 组件套件",
  "dsCreate.designMdGeneratedDescription":
    "由粘贴的 DESIGN.md token、设计理由和组件指南生成。",
  "dsCreate.previewButtons": "按钮",
  "dsCreate.previewButtonsHelp": "五种类型，三种尺寸。",
  "dsCreate.buttonPrimary": "主要",
  "dsCreate.buttonDashed": "虚线",
  "dsCreate.buttonText": "文本",
  "dsCreate.buttonLink": "链接",
  "dsCreate.sizeSmall": "小",
  "dsCreate.sizeMedium": "中",
  "dsCreate.sizeLarge": "大",
  "dsCreate.previewTypeScale": "字体层级",
  "dsCreate.extractedTokens": "提取的 DESIGN.md token",
  "brandPicker.heading": "从你喜欢的品牌开始",
  "brandPicker.subtext": "点击任意品牌，即可直接从其网站提取设计系统。",
  "brandPicker.quickPicksLabel": "热门品牌 · 点击即可提取",
  "brandPicker.searchPlaceholder": "搜索品牌…",
  "brandPicker.allCategories": "全部",
  "brandPicker.extractAction": "提取",
  "brandPicker.showMore": "显示更多",
  "brandPicker.opening": "正在开始提取 — 正在打开 {brand}…",
  "ds.kitVisualize": "可视化",
  "ds.kitEdit": "编辑",
  "ds.kitSource": "源码",
  "ds.saveDesignMd": "保存 DESIGN.md",
  "ds.saving": "保存中…",
  "ds.copyDesignMd": "复制 DESIGN.md",
  "ds.editDesignMd": "编辑 DESIGN.md",
  "ds.openDesignMd": "打开 DESIGN.md",
  "ds.copyDesignMdModule": "复制{module}段落",
  "ds.editDesignMdModule": "编辑{module}段落",
  "ds.openDesignMdModule": "打开{module}段落",
  "ds.uploadMd": "上传 MD",
  "ds.uploadFont": "添加字体文件",
  "ds.pasteImage": "粘贴图片",
  "ds.refresh": "刷新",
  "ds.download": "下载",
  "ds.importFolder": "导入文件夹",
  "ds.reset": "重置",
  "ds.editingDesignMdHint": "编辑这份 Markdown 会更新已渲染的套件模块。",
  "ds.editingModuleHint": "仅编辑{module}模块。",
  "ds.manualEditModuleHint": "在这里编辑{module}。悬停此模块可显示修改控件。",
  "ds.saveModule": "保存模块",
  "ds.uploadLogo": "上传 Logo",
  "ds.uploadImage": "上传图片",
  "ds.uploading": "上传中…",
  "ds.moduleEmptyLogo": "暂无 Logo",
  "ds.moduleEmptyFonts": "暂无字体文件。",
  "ds.actionDone": "完成",
  "ds.actionFailed": "出错了，请重试。",
  "ds.uploadDone": "已上传",
  "ds.uploadFailed": "上传失败，请重试。",
  "ds.deleteLogo": "删除 Logo",
  "ds.deleteImage": "删除 {caption}",
  "ds.deleteProjectConfirm":
    "删除「{title}」？这会从本设备永久移除该设计体系及其项目。",
  "ds.deleteProjectAction": "删除 {title}",
  "ds.editColor": "编辑{name}",
  "ds.colorLabel": "颜色",
  "ds.hexLabel": "Hex",
  "ds.hexValueLabel": "Hex 值",
  "ds.saveColor": "保存颜色",
  "ds.invalidHexColor": "请输入有效的 Hex 颜色，例如 #FF6A3D。",
  "ds.colorSaveFailed": "无法保存该颜色。",
  "ds.colorResetFailed": "无法重置该颜色。",
  "ds.designMdSectionLabel": "{module} DESIGN.md 段落",
  "ds.kitErrorTitle": "此视图遇到问题。",
  "ds.kitErrorRetry": "重新加载",
  "ds.shortcutsLabel": "键盘快捷键",
  "ds.shortcutsHint": "快捷键：E 编辑 · C 复制 · U 上传 · R 刷新 · ⌫ 删除 Logo",
  "ds.moduleEmptyImages": "暂无图片",
  "ds.noOriginalColor": "暂无可用于该色板的原始颜色。",
  "ds.manifestReadFailed": "无法读取 _ds_manifest.json。",
  "ds.reviewCollapseSection": "收起{title}",
  "ds.reviewExpandSection": "展开{title}",
  "ds.reviewNeedsReview": "待审阅",
  "ds.reviewLooksGood": "看起来不错",
  "ds.reviewActionsLabel": "审阅{title}",
  "ds.reviewNeedsWorkEllipsis": "需要修改...",
  "ds.reviewEditFile": "编辑 {file}",
  "ds.reviewFeedbackLabel": "告诉 agent 需要改什么",
  "ds.reviewFeedbackPlaceholder":
    "例如：收紧 {title} 的间距，重新生成这个预览...",
  "ds.reviewChangedAfterFeedback":
    "此段落已根据你的反馈发生变化。发布前请再次审阅。",
  "ds.reviewChangedDuringRun": "此段落在最近一次运行中发生变化。发布前请审阅。",
  "ds.reviewLastFeedback": "上次反馈",
  "ds.previewGenerating": "正在生成预览...",
  "ds.creatingProjectTitle": "正在创建你的设计体系...",
  "ds.creatingProjectSubtitle": "请保持此标签页打开。几分钟后可以回来查看。",
  "ds.generationProgressLabel": "设计体系生成进度 {progress}%",
  "ds.publishRepoRequiredTitle": "请先完成 GitHub 仓库导入，再发布。",
  "ds.publishDesignSystem": "发布设计体系",
  "ds.unpublishDesignSystem": "取消发布设计体系",
  "ds.published": "已发布",
  "ds.publish": "发布",
  "ds.extractionRunningTitle": "正在提取设计体系",
  "ds.extractionCompleteTitle": "提取完成",
  "ds.extractionRunningBody": "Crie3 正在就地更新此体系。",
  "ds.extractionCompleteBody": "已提取的模块如下所示；空段落会保持为空。",
  "ds.publishCardPublished": "团队的新项目默认可以使用此设计体系作为上下文。",
  "ds.publishCardDraft":
    "你的设计体系已准备好，但反馈可以继续改进它。准备好用于后续项目时再发布。",
  "ds.useSystemTitle": "使用此体系",
  "ds.useSystemBody":
    "新建设计会继承此体系的颜色、字体和组件，并自动保持品牌一致。",
  "ds.createNewDesign": "新建设计",
  "ds.openSourceContext": "打开来源上下文",
  "ds.manifestNeedsAttention": "设计 manifest 需要处理",
  "ds.openManifest": "打开 manifest",
  "ds.workspacePreparing": "正在准备设计体系工作区。",
  "ds.workspaceLoadingLabel": "设计体系工作区正在加载",
  "ds.sectionQueued": "已排队",
  "ds.sectionReviewUpdatedFiles": "审阅已更新文件",
  "ds.reviewNeedsWork": "需要修改",
  "ds.sectionRequiredFileMissing": "缺少 {file}",
  "ds.sectionNoFilesYet": "暂无文件",
  "ds.generationSourceTitle": "探索已提供资源",
  "ds.generationSourceDetail":
    "公司背景、GitHub 仓库、本地代码文件夹、Figma 文件、字体、Logo 和备注。",
  "ds.generationGuidanceTitle": "创建 DESIGN.md",
  "ds.generationGuidanceDetail": "作为项目上下文使用的规范指南。",
  "ds.generationTokensTitle": "创建 tokens",
  "ds.generationTokensDetail": "颜色、字体、间距和圆角证据。",
  "ds.generationPreviewsTitle": "创建预览卡片",
  "ds.generationPreviewsDetail": "用于设计体系标签页的 HTML 审阅卡片。",
  "ds.generationUiKitTitle": "创建 UI kit",
  "ds.generationUiKitDetail": "可复用的界面示例。",
  "ds.generationAssetsTitle": "登记资产",
  "ds.generationAssetsDetail": "Logo、图标、字体和品牌文件。",
  "ds.phaseQueuedTypography": "字体已排队",
  "ds.phaseQueuedTokens": "Token 已排队",
  "ds.phaseQueuedSpacing": "间距已排队",
  "ds.phaseQueuedUiKit": "UI kit 已排队",
  "ds.phaseQueuedAssets": "资产已排队",
  "ds.phaseReadingTypography": "正在读取字体",
  "ds.phaseReadingTokens": "正在读取 tokens",
  "ds.phaseReadingSpacing": "正在读取间距",
  "ds.phaseReadingUiKit": "正在读取 UI kit",
  "ds.phaseReadingAssets": "正在读取资产",
  "ds.phaseWritingTypography": "正在写入字体",
  "ds.phaseWritingTokens": "正在写入 tokens",
  "ds.phaseWritingSpacing": "正在写入间距",
  "ds.phaseBuildingUiKit": "正在构建 UI kit",
  "ds.phaseUpdatingAssets": "正在更新资产",
  "ds.phaseNeedsAttention": "需要处理",
  "ds.phaseUpdated": "已更新",
  "ds.sectionActivityFromTodo": "{phase}，来自待办：{todo}",
  "ds.sectionActivityReadFiles": "已读取 {files}",
  "ds.sectionActivityPhaseFiles": "{phase}：{files}",
  "ds.sectionRunningReadingContext":
    "Crie3 正在读取 {title} 的段落上下文。",
  "ds.sectionRunningNow": "{phase}中。",
  "ds.reviewLastReviewed": "上次审阅 {time}",
  "ds.agentFeedbackQueued": "反馈已保存。当前运行结束后，agent 会继续处理。",
  "ds.agentFeedbackSent": "已发送给 agent。",
  "ds.agentFeedbackSentAt": "已于 {time} 发送给 agent。",
  "ds.agentFeedbackFailedWithError": "Agent 任务失败：{error}",
  "ds.agentFeedbackFailed": "Agent 任务失败。",
  "ds.agentFeedbackUnknown": "Agent 任务状态未知。",
  "ds.repoConnectBannerTitle": "连接你的仓库，以提取设计体系信息",
  "ds.repoConnectCardTitle": "连接仓库",
  "ds.repoConnectPendingBody": "正在检查 GitHub 连接...",
  "ds.repoConnectPendingButton": "正在检查 GitHub...",
  "ds.repoConnectedTitle": "GitHub 已连接",
  "ds.repoConnectedBody": "重新导入此仓库，把文件拉入你的设计体系。",
  "ds.repoImportButton": "导入仓库",
  "ds.repoConnectBannerBody":
    "连接 GitHub 后，Crie3 可以读取你的仓库，并把颜色、字体和组件提取到此设计体系中。",
  "ds.repoConnectCardBody": "从仓库中提取颜色、字体和组件到此设计体系。",
  "ds.repoConnectButton": "连接 GitHub",
  "newproj.startFromLabel": "起点",
  "newproj.startBlank": "空白",
  "newproj.startBlankHint": "从零开始",
  "workspace.pages": "页面",
  "workspace.allProjectFiles": "全部项目文件",
  "workspace.newBlankPage": "新建空白页面",
  "workspace.noPagesYet": "还没有页面",
  "workspace.pageCreateFailed": "无法创建页面。",
  "workspace.pageCreatorTitle": "新建页面",
  "workspace.pageCreatorSearch": "搜索模板",
  "workspace.pageCreatorCategoryAll": "全部场景",
  "workspace.pageCreatorEmpty": "没有匹配的页面类型。",
  "workspace.pageCreatorPreview": "预览",
  "workspace.pageCreatorUse": "使用",
  "fileViewer.presentInTabDeckHint": "演讲者备注会在弹窗中打开",
  "fileViewer.presentEscHint": "按 Esc 退出演示",
  "fileViewer.presenterPause": "暂停",
  "fileViewer.presenterResume": "继续",
  "fileViewer.presenterPrevious": "上一页",
  "fileViewer.presenterNext": "下一页",
  "questions.uploadingFiles": "正在上传文件…",
  "questions.uploadNeedsProject": "文件上传需要一个活跃的项目。",
  "questions.uploadPartialFailed": "已上传 {uploaded} 个文件，{failed} 个失败。",
  "questions.uploadFailed": "有 {failed} 个文件上传失败。",
  // TikTok consent screen. The Music Usage Confirmation sentence and the
  // processing notice are NOT here on purpose: they come from the server in
  // English because a human auditor reads those exact words, and translating
  // them would change the thing being checked.
  'fileViewer.publishToSocial': 'Publish to social',
  'social.loading': 'Loading your accounts…',
  'settings.socialNetworks': 'Social networks',
  'settings.socialNetworksHint': 'Connected accounts and publishing',
  'social.connectionsTitle': 'Connected accounts',
  'social.clientConnectHint': '要连接客户的 Instagram，请在{screen}中打开该客户的资料，使用“{button}”。下面的按钮连接的是本账户自己的主页。',
  'social.noConnections': 'No account connected yet.',
  'social.disconnect': 'Disconnect',
  'social.connectTo': 'Connect {network}',
  'social.connectFailed': 'Could not start the connection. Publishing may not be configured yet.',
  'social.appCredentialsTitle': 'App credentials',
  'social.appCredentialsHint': 'The keys for this deployment’s own app on each network. Everyone who uses the product publishes through it.',
  'social.publishingOn': 'Publishing is on.',
  'social.publishingOff': 'Publishing is off: {reason}',
  'social.sourceEnv': 'from environment',
  'social.sourceStored': 'saved here',
  'social.sourceUnset': 'not set',
  'social.managedByEnv': 'Set by an environment variable on the host, which takes precedence. Editing here would have no effect.',
  'social.save': 'Save',
  'social.saving': 'Saving…',
  'social.clear': 'Clear',
  'social.publicBaseUrl': 'Public address',
  'social.publicBaseUrlHint': 'The public origin the networks fetch the image from. Without it every post fails at the far end.',
  'social.noAccounts': 'No TikTok account is connected yet.',
  'social.connectTikTok': 'Connect TikTok',
  'social.notConfigured': 'This deployment has no TikTok app credentials, so accounts cannot be connected.',
  'social.account': 'Account',
  'social.postingAs': 'Posting as {name}',
  'social.preview': 'What will be posted',
  'social.titleLabel': 'Title',
  'social.captionLabel': 'Caption',
  'social.privacyLabel': 'Who can see this',
  'social.privacyPlaceholder': 'Choose an audience',
  'social.privacyRequired': 'Choose who can see this post.',
  'social.disableComment': 'Turn off comments',
  'social.commercialContent': 'This post is commercial content',
  'social.yourBrand': 'Your brand',
  'social.yourBrandHint': 'Labels the post as promotional content.',
  'social.brandedContent': 'Branded content',
  'social.brandedContentHint': 'Labels the post as a paid partnership.',
  'social.disclosureRequired': 'Commercial content needs at least one disclosure.',
  'social.brandedNotPrivate': 'A paid partnership cannot be posted as “only me”.',
  'social.musicRequired': 'Accept the Music Usage Confirmation to continue.',
  'social.publish': 'Approve and schedule',
  'social.publishing': 'Sending…',
  'social.queued': 'Approved. It will be posted at the time you chose.',
  'social.cancel': 'Cancel',
  'social.close': 'Close',
  'social.errorGeneric': 'Something went wrong. Try again.',
  'social.noMedia': 'This project has no JPEG or WebP images to post yet.',
  'social.renderTitle': 'Images for Instagram',
  'social.renderHint': 'Instagram only takes JPEG. This turns each card of the piece into its own image, in order, and keeps them in the project.',
  'social.renderAction': 'Prepare images',
  'social.renderBusy': 'Preparing images…',
  'social.renderDone': '{count} images ready in {folder}.',
  'social.renderUnavailable': 'This deployment cannot turn pieces into images.',
  'social.renderTryLater': 'The images could not be prepared right now. Try again in a moment.',
  'social.assembleTitle': 'Video from these slides',
  'social.assembleHint': 'Each slide is fitted whole into a vertical frame, never cropped, and held for three seconds. The clip is silent: a soundtrack is a rights decision, not a default. Nothing is published — the file lands in this project.',
  'social.assembleAction': 'Build the video',
  'social.assembleBusy': 'Building the video...',
  'social.assembleDone': 'Saved as {path} — {width}x{height}, {seconds}s, no audio. Nothing was published.',
  'social.assembleUnavailable': 'This installation has no video encoder, so a clip cannot be built here.',
  // Instagram connect funnel. The account-type question comes before any
  // redirect on purpose: Instagram cannot be reached by a personal account,
  // and Meta does not document what such an attempt returns.
  'social.connectInstagram': 'Connect Instagram',
  'social.askAccountKind': 'What kind of Instagram account is it?',
  'social.askAccountKindWhy': 'Instagram only lets apps post from a professional account. Answering now saves you a failed login.',
  'social.accountKindProfessional': 'Creator or Business',
  'social.accountKindPersonal': 'Personal',
  'social.accountKindUnsure': 'I\'m not sure',
  'social.convertTitle': 'Switch to a Creator account first',
  'social.convertWhy': 'It is free, takes under a minute, and you can switch back any time. Your username, your posts and your followers stay exactly as they are.',
  'social.convertDone': 'Done — connect now',
  'social.convertStep1': 'Open the Instagram app and go to your profile.',
  'social.convertStep2': 'Tap the menu, then Settings and privacy.',
  'social.convertStep3': 'Tap Account type and tools, then Switch to professional account.',
  'social.convertStep4': 'Choose Creator (or Business), pick a category, and finish.',
  'social.convertStep5': 'Come back here and connect again.',
  // Assisted delivery. A different promise from automatic publishing, and
  // the copy says so wherever it appears — selling one plan that silently
  // delivers both behaviours is what produces refunds.
  'social.assistedLabel': 'I will post it myself',
  'social.assistedHint': 'You get the piece and the caption ready at the scheduled time, and post it in two taps. It is not automatic publishing.',
  'social.queuedAssisted': 'Scheduled. At the time you chose you will get the piece and the caption, ready to post.',
  // The list where an assisted piece actually arrives.
  'social.waitingForYou': 'Ready for you to post',
  'social.openApp': 'Open the app',
  'social.iPosted': 'I posted it',
  // Reaching the two paths that had no entry point.
  'social.connectFacebook': 'Connect a Facebook Page',
  'social.assistedOffer': 'No professional account? You can still schedule it.',
  'social.whereWillYouPost': 'Where will you post it?',
  // ISSUE-026 — short placeholder hints, in place of the action prompts.
  'chat.composerHintPiece1': 'Ask for a piece for Sunday service',
  'chat.composerHintPiece2': 'Change the colour, the photo or the verse',
  'chat.composerHintPiece3': 'Ask for a version for stories',
  'chat.composerHintImage1': 'Describe the image you want for the post',
  'chat.composerHintImage2': 'Ask for the same image in another colour',
  'chat.composerHintVideo1': 'Describe the short video for the invitation',
  'chat.composerHintVideo2': 'Ask for a shorter version for stories',
  'chat.composerHintAudio1': 'Say what to announce, and in what voice',
  'chat.composerHintAudio2': 'Ask for a calmer, slower reading',
  'chat.composerHintDesignSystem1': 'Ask to improve the church colours and fonts',
  'chat.composerHintDesignSystem2': 'Ask what is still missing here',
  'chat.composerHintPlan1': 'Ask to turn this plan into the pieces',
  'chat.composerHintPlan2': 'Ask to improve the plan first',
  // ISSUE-014 — the pieces of the "what you sent" line in the transcript.
  'dsCreate.sourceLabelDesignMd': 'pasted DESIGN.md',
  'dsCreate.sourceLabelFile': '1 file',
  'dsCreate.sourceLabelFiles': '{count} files',
  'dsCreate.sourceLabelFolder': '1 folder',
  'dsCreate.sourceLabelFolders': '{count} folders',
  'dsCreate.sourceLabelLink': '1 link',
  'dsCreate.sourceLabelLinks': '{count} links',
  'dsCreate.sourceLabelDescription': 'description',
  'dsCreate.sourceLabelChurchProfile': '“我的品牌”资料',
  'dsCreate.churchProfileTitle': '你已在“我的品牌”中填写过这些',
  'dsCreate.churchProfileBody': 'The colours, fonts, logos and voice you saved are ready here. Change any of it afterwards — or fill it in from scratch, if this look is a different one.',
  'dsCreate.churchProfileUse': '使用“我的品牌”资料',
  'dsCreate.churchProfileApplied': '来自你的“我的品牌”资料',
  'dsCreate.churchProfileDrop': 'Do not use the profile',
};
